(function() {
  angular.module('cogniss', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'ui.sortable', 'angularFileUpload', 'jlareau.bowser', 'ngStorage', 'ezfb', 'nvd3', 'pascalprecht.translate', 'angularUtils.directives.dirPagination', 'ngTagsInput', 'ngFileUpload', 'colorpicker.module']);

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminTopicController', function($scope, topic, ContentService) {
    'ngInject';
    $scope.topic = topic;
    return ContentService.getSubject(topic.subjectId).then(function(subject) {
      return $scope.subject = subject;
    });
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminTopicsController', function($scope, ContentService, modalService, $state, tenant, subject, QuestionTypes, TopicTypes, $filter) {
    'ngInject';
    $scope.tenant = tenant;
    ContentService.getTopics($scope.tenant).then(function(allTopics) {
      var i, len, topic, topics;
      $scope.allTopics = allTopics;
      topics = [];
      for (i = 0, len = allTopics.length; i < len; i++) {
        topic = allTopics[i];
        if (topic.subjectId === subject.id) {
          topics.push(topic);
        }
      }
      topics = $filter('orderBy')(topics, "order");
      return $scope.topics = topics;
    });
    $scope.questionTypes = QuestionTypes;
    $scope.topicTypes = TopicTypes;
    $scope.sortableOptions = {
      stop: function(event, ui) {
        return ContentService.orderItem(ui.item.sortable.model, $scope.topics, function(topic) {
          return ContentService.saveTopic(topic).then(function(topic) {});
        });
      }
    };
    $scope.newTopic = function() {
      return $scope.topicFormData = {
        name: "",
        description: "",
        subjectId: subject.id,
        tags: [],
        next: null,
        unlock: false,
        topicType: TopicTypes.LEARNING,
        questionType: null,
        virtualGoods: []
      };
    };
    $scope.newTopic();
    $scope.$watch("topicFormData.id", function(id) {
      if (id != null) {
        return ContentService.getQuestions(tenant, $scope.topicFormData.id).then(function(questions) {
          return $scope.questions = questions;
        });
      } else {
        return $scope.questions = [];
      }
    });
    $scope.$watch("topicFormData.questionType", function(type) {
      var usesAttributes;
      usesAttributes = type === QuestionTypes.MULTICHOICE || type === QuestionTypes.AUDIO_RESPONSE || type === QuestionTypes.IMAGE_RESPONSE;
      if (usesAttributes && ($scope.topicFormData.attributes == null)) {
        return $scope.topicFormData.attributes = {};
      }
    });
    $scope.saveTopic = function() {
      var index;
      index = $scope.topics.indexOf($scope.editTopic);
      $scope.editTopic = angular.copy($scope.topicFormData);
      return ContentService.saveTopic($scope.topicFormData).then(function(topic) {
        if ($scope.editTopic.id == null) {
          $scope.topics.push(topic);
          $scope.editTopic = topic;
        } else {
          $scope.topics.splice(index, 1, topic);
        }
        return $scope.newTopic();
      });
    };
    $scope.selectTopic = function(topic) {
      console.log("select Topic", topic);
      $scope.editTopic = topic;
      return $scope.topicFormData = angular.copy($scope.editTopic);
    };
    $scope.archiveTopic = function(topic) {
      var doArchive;
      doArchive = function() {
        var index;
        index = $scope.topics.indexOf(topic);
        topic.archived = true;
        ContentService.saveTopic(topic).then(function(topic) {
          return $scope.topics.splice(index, 1);
        }, function(error) {
          return modalService.showModal("Error", "Error archiving topic");
        });
        return $scope.newTopic();
      };
      return modalService.showModal("Confirm archiving Topic", "Are you sure you want to archive this topic?", true, true, "Cancel", doArchive, "Confirm");
    };
    $scope.getQuestionAttributesSelected = function() {
      if ($scope.topicFormData.attributes == null) {
        return false;
      }
      if ($scope.topicFormData.attributes.questionText) {
        return false;
      }
      if ($scope.topicFormData.attributes.questionAudio) {
        return false;
      }
      if ($scope.topicFormData.attributes.questionImage) {
        return false;
      }
      return true;
    };
    return $scope.getOptionAttributesSelected = function() {
      if ($scope.topicFormData.attributes == null) {
        return false;
      }
      if ($scope.topicFormData.attributes.optionText) {
        return false;
      }
      if ($scope.topicFormData.attributes.optionAudio) {
        return false;
      }
      if ($scope.topicFormData.attributes.optionImage) {
        return false;
      }
      return true;
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminSubjectsController', function($scope, ContentService, modalService, $state, tenant, $filter) {
    'ngInject';
    ContentService.getSubjects(tenant).then(function(subjects) {
      subjects = $filter('orderBy')(subjects, "order");
      return $scope.subjects = subjects;
    });
    $scope.sortableOptions = {
      stop: function(event, ui) {
        return ContentService.orderItem(ui.item.sortable.model, $scope.subjects, function(subject) {
          return ContentService.saveSubject(subject).then(function(subject) {});
        });
      }
    };
    $scope.newSubject = function() {
      $scope.formData = {
        tenant: tenant.code,
        name: ""
      };
      return $scope.editSubject = true;
    };
    $scope.newSubject();
    $scope.saveSubject = function() {
      var index;
      index = $scope.subjects.indexOf($scope.editSubject);
      $scope.editSubject = angular.copy($scope.formData);
      return ContentService.saveSubject($scope.formData).then(function(subject) {
        if ($scope.editSubject.id == null) {
          $scope.subjects.push(subject);
          $scope.editSubject = subject;
        } else {
          $scope.subjects.splice(index, 1, subject);
        }
        return $scope.newSubject();
      });
    };
    $scope.selectSubject = function(subject) {
      $scope.editSubject = subject;
      return $scope.formData = angular.copy($scope.editSubject);
    };
    return $scope.archiveSubject = function(subject) {
      var doArchive;
      doArchive = function() {
        var index;
        index = $scope.subjects.indexOf(subject);
        subject.archived = true;
        ContentService.saveSubject(subject).then(function(subject) {
          return $scope.subjects.splice(index, 1);
        }, function(error) {
          return modalService.showModal("Error", "Error archiving subject");
        });
        return $scope.newSubject();
      };
      return modalService.showModal("Confirm archiving Subject", "Are you sure you want to archive this subject?", true, true, "Cancel", doArchive, "Confirm");
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminSubjectController', function($scope, subject) {
    'ngInject';
    return $scope.subject = subject;
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminQuestionsController', function($scope, ContentService, modalService, $state, tenant, topic, $filter) {
    'ngInject';
    ContentService.getQuestions(tenant, topic.id).then(function(questions) {
      questions = $filter('orderBy')(questions, "order");
      return $scope.questions = questions;
    });
    $scope.sortableOptions = {
      stop: function(event, ui) {
        return ContentService.orderItem(ui.item.sortable.model, $scope.questions, function(question) {
          return ContentService.saveQuestion(question).then(function(question) {});
        });
      }
    };
    $scope.topic = topic;
    $scope.newQuestion = function() {
      var question;
      question = {
        label: "",
        topicId: topic.id,
        type: $scope.topic.questionType
      };
      return $scope.questionFormData = question;
    };
    $scope.archiveOption = function(option) {
      return $scope.questionFormData.options.splice($scope.questionFormData.options.indexOf(option), 1);
    };
    $scope.saveQuestion = function() {
      var index;
      if ($scope.questions != null) {
        index = $scope.questions.indexOf($scope.editQuestion);
      }
      $scope.editQuestion = angular.copy($scope.questionFormData);
      console.log("saving Question", $scope.editQuestion);
      return ContentService.saveQuestion($scope.questionFormData).then(function(question) {
        console.log("response", question);
        if ($scope.editQuestion.id == null) {
          $scope.questions.push(question);
          $scope.editQuestion = question;
        } else {
          $scope.questions.splice(index, 1, question);
        }
        return $scope.newQuestion();
      });
    };
    $scope.selectQuestion = function(question) {
      $scope.editQuestion = question;
      return $scope.questionFormData = angular.copy($scope.editQuestion);
    };
    $scope.archiveQuestion = function(question) {
      var doArchive;
      doArchive = function() {
        var index;
        index = $scope.questions.indexOf(question);
        question.archived = true;
        ContentService.saveQuestion(question).then(function(question) {
          return $scope.questions.splice(index, 1);
        }, function(error) {
          return modalService.showModal("Error", "Error archiving question");
        });
        return $scope.newQuestion();
      };
      return modalService.showModal("Confirm archiving Question", "Are you sure you want to archive this question?", true, true, "Cancel", doArchive, "Confirm");
    };
    return $scope.newQuestion();
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminContentOverviewController', function($scope, ContentService, modalService, $state, tenant) {
    'ngInject';
    var content;
    content = null;
    $scope.importFileChange = function(ele) {
      var file, files, fr;
      files = ele.files;
      file = files[0];
      fr = new FileReader;
      console.log(fr);
      fr.onload = function(e) {
        var json, string;
        string = e.target.result;
        try {
          json = JSON.parse(string);
        } catch (error) {
          e = error;
          console.log("error parsing json", e);
        }
        $scope.content = json;
        $scope.$apply();
        console.log(json);
        return content = json;
      };
      return fr.readAsText(file);
    };
    $scope["import"] = function() {
      return ContentService.importContent(tenant, content).then(function(res) {
        content = null;
        return modalService.showModal("Content imported", "Your content has successfully beein imported", true, true);
      }, function() {
        return modalService.showModal("Content import error", "There was an error importing your content", true, true);
      });
    };
    return $scope["export"] = function() {
      return ContentService.exportContent(tenant).then(function(content) {
        var blob, json;
        json = JSON.stringify(content);
        blob = new Blob([json], {
          type: "application/json"
        });
        return saveAs(blob, "export.json");
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminActivitiesController', function($scope, ContentService, modalService, $state, tenant, subject, $filter) {
    'ngInject';
    $scope.tenant = tenant;
    ContentService.getTopics($scope.tenant, subject.id).then(function(topics) {
      $scope.topics = topics;
      return ContentService.getTemplates().then(function(templates) {
        $scope.templates = templates;
        return ContentService.getActivities($scope.tenant).then(function(activities) {
          var acs, activity, found, i, j, len, len1, topic;
          acs = [];
          for (i = 0, len = activities.length; i < len; i++) {
            activity = activities[i];
            found = false;
            for (j = 0, len1 = topics.length; j < len1; j++) {
              topic = topics[j];
              if (topic.id === activity.topicId) {
                found = true;
              }
            }
            if (found) {
              acs.push(activity);
            }
          }
          activities = acs;
          activities = $filter('orderBy')(activities, "order");
          return $scope.activities = activities;
        });
      });
    });
    $scope.sortableOptions = {
      stop: function(event, ui) {
        return ContentService.orderItem(ui.item.sortable.model, $scope.activities, function(activity) {
          return ContentService.saveActivity(activity).then(function(activity) {});
        });
      }
    };
    $scope.newActivity = function() {
      return $scope.activityFormData = {
        name: "",
        topicId: "",
        templateId: "",
        xp: 0,
        gc: 0,
        vg: []
      };
    };
    $scope.saveActivity = function() {
      var index;
      index = $scope.activities.indexOf($scope.editActivity);
      $scope.editActivity = angular.copy($scope.activityFormData);
      return ContentService.saveActivity($scope.activityFormData).then(function(activity) {
        if ($scope.editActivity.id == null) {
          $scope.activities.push(activity);
          $scope.editActivity = activity;
        } else {
          $scope.activities.splice(index, 1, activity);
        }
        return $scope.newActivity();
      });
    };
    $scope.selectActivity = function(activity) {
      $scope.editActivity = activity;
      return $scope.activityFormData = angular.copy($scope.editActivity);
    };
    return $scope.archiveActivity = function(activity) {
      var doArchive;
      doArchive = function() {
        var index;
        index = $scope.activities.indexOf(activity);
        activity.archived = true;
        ContentService.saveActivity(activity).then(function(activity) {
          return $scope.activities.splice(index, 1);
        }, function(error) {
          return modalService.showModal("Error", "Error archiving activity");
        });
        return $scope.newActivity();
      };
      return modalService.showModal("Confirm archiving Activity", "Are you sure you want to archive this activity?", true, true, "Cancel", doArchive, "Confirm");
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantUserSubjectController', function($scope, tenant, userDetails, subjectId, TenantService, UserService, ProgressService) {
    'ngInject';
    $scope.tenant = tenant;
    TenantService.getContent(tenant).then(function(content) {
      var getAggregate, i, len, results, subject, subjects, topic;
      subjects = content.subjects;
      results = [];
      for (i = 0, len = subjects.length; i < len; i++) {
        subject = subjects[i];
        if (subject.id === subjectId) {
          $scope.subject = subject;
          $scope.topicOverviews = [];
          getAggregate = function(subject) {
            var overview;
            overview = {
              topic: topic
            };
            $scope.topicOverviews.push(overview);
            return ProgressService.getQuestionAggregate([userDetails.playerId], tenant, $scope.subject.id, topic.id).then(function(aggregate) {
              overview.completePercent = 100 * aggregate.complete / aggregate.total;
              overview.revisionPercent = 100 * aggregate.revision / aggregate.total;
              overview.attemptedPercent = 100 * aggregate.attempted / aggregate.total;
              overview.status = "Not Yet Attempted";
              if (aggregate.attempted > 0 || aggregate.revision > 0) {
                overview.status = "In Progress";
              }
              if (aggregate.complete === aggregate.total) {
                overview.status = "Mastered";
              }
              return overview.aggregate = aggregate;
            });
          };
          results.push((function() {
            var j, len1, ref, results1;
            ref = $scope.subject.topics;
            results1 = [];
            for (j = 0, len1 = ref.length; j < len1; j++) {
              topic = ref[j];
              results1.push(getAggregate(topic));
            }
            return results1;
          })());
        } else {
          results.push(void 0);
        }
      }
      return results;
    });
    $scope.search = "";
    $scope.searchFilter = function(overview) {
      var i, len, ref, tag, topic;
      topic = overview.topic;
      if ($scope.search === "") {
        return true;
      }
      if (topic.name.toLowerCase().indexOf($scope.search.toLowerCase()) > -1) {
        return true;
      }
      ref = topic.tags;
      for (i = 0, len = ref.length; i < len; i++) {
        tag = ref[i];
        if (tag.toLowerCase().indexOf($scope.search.toLowerCase()) > -1) {
          return true;
        }
      }
      return false;
    };
    $scope.selectTag = function(tag) {
      return $scope.search = tag;
    };
    return $scope.userDetails = userDetails;
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantUserResponseController', function($scope, tenant, userDetails, ProgressService, responseId, cogniss, QuestionTypes, $uibModal) {
    'ngInject';
    $scope.QuestionTypes = QuestionTypes;
    $scope.userDetails = userDetails;
    ProgressService.getActivityResponse(responseId).then(function(activityResponse) {
      $scope.activityResponse = activityResponse;
      return ProgressService.listQuestionResponses(null, responseId).then(function(responses) {
        var i, len, response, showDuration;
        $scope.questionResponses = responses;
        showDuration = false;
        for (i = 0, len = responses.length; i < len; i++) {
          response = responses[i];
          if (response.duration) {
            showDuration = true;
          }
        }
        return $scope.showDuration = showDuration;
      });
    });
    $scope.getQuestionText = function(question) {
      if (question.label != null) {
        return question.label;
      }
      if (question.text != null) {
        return question.text;
      }
      if (question.text1 != null) {
        return question.text1;
      }
      return "";
    };
    return $scope.showImageResponse = function(response) {
      var modal, modalScope;
      modalScope = $scope.$new();
      modalScope.response = response;
      return modal = $uibModal.open({
        templateUrl: "app/screens/tenant/user/response/image-response-modal.html",
        scope: modalScope
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantUserOverviewController', function($scope, tenant, userDetails, TenantService, $state, modalService, cogniss, ProgressService) {
    'ngInject';
    $scope.$watch(function() {
      return cogniss.user;
    }, function(val) {
      return $scope.user = val;
    });
    $scope.userDetails = userDetails;
    $scope.chartOptions = {
      chart: {
        type: 'pieChart',
        height: 200,
        donut: true,
        showLegend: false,
        showLabels: false,
        valueFormat: d3.format(',.0f'),
        margin: 0,
        y: function(d) {
          return d.y;
        },
        x: function(d) {
          return d.x;
        },
        color: function(d) {
          return d.color;
        },
        duration: 500
      }
    };
    ProgressService.getQuestionAggregate([userDetails.playerId], tenant).then(function(progress) {
      return $scope.progress = progress;
    });
    TenantService.getContent(tenant).then(function(content) {
      var getAggregate, i, len, ref, results, subject;
      $scope.subjects = content.subjects;
      $scope.subjectOverviews = [];
      getAggregate = function(subject) {
        var overview;
        overview = {
          subject: subject
        };
        $scope.subjectOverviews.push(overview);
        return ProgressService.getQuestionAggregate([userDetails.playerId], tenant, subject.id).then(function(aggregate) {
          overview.showMastery = true;
          overview.activityResponses = aggregate.activityResponses;
          if (aggregate.total === 0) {
            overview.showMastery = false;
          }
          overview.chartData = [
            {
              x: "Complete",
              y: aggregate.complete,
              color: "#23AE89"
            }, {
              x: "In revision",
              y: aggregate.revision,
              color: "#FFB61C"
            }, {
              x: "Attempted",
              y: aggregate.attempted,
              color: "#2EC1CC"
            }, {
              x: "Not yet attempted",
              y: aggregate.total - aggregate.attempted - aggregate.revision - aggregate.complete,
              color: "#f5f5f5"
            }
          ];
          return overview.aggregate = aggregate;
        });
      };
      ref = $scope.subjects;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        subject = ref[i];
        results.push(getAggregate(subject));
      }
      return results;
    });
    return $scope.selectSubject = function(subject) {
      return $state.go("tenant.user.subject", {
        tenantRef: tenant.urlName,
        userId: userDetails.playerId,
        subjectId: subject.id
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantTeamSubjectController', function($scope, tenant, team, subjectId, TenantService, ProgressService) {
    'ngInject';
    var i, len, ref, user, userIds;
    $scope.tenant = tenant;
    $scope.team = team;
    userIds = [];
    ref = team.members;
    for (i = 0, len = ref.length; i < len; i++) {
      user = ref[i];
      userIds.push(user.id);
    }
    $scope.userIds = userIds;
    TenantService.getContent(tenant).then(function(content) {
      var getAggregate, j, len1, results, subject, subjects, topic;
      subjects = content.subjects;
      results = [];
      for (j = 0, len1 = subjects.length; j < len1; j++) {
        subject = subjects[j];
        if (subject.id === subjectId) {
          $scope.subject = subject;
          $scope.topicOverviews = [];
          getAggregate = function(topic) {
            var overview;
            overview = {
              topic: topic
            };
            $scope.topicOverviews.push(overview);
            return ProgressService.getQuestionAggregate(userIds, tenant, $scope.subject.id, topic.id).then(function(aggregate) {
              overview.completePercent = 100 * aggregate.complete / aggregate.total;
              overview.revisionPercent = 100 * aggregate.revision / aggregate.total;
              overview.attemptedPercent = 100 * aggregate.attempted / aggregate.total;
              overview.status = "Not Yet Attempted";
              if (aggregate.attempted > 0 || aggregate.revision > 0) {
                overview.status = "In Progress";
              }
              if (aggregate.complete === aggregate.total) {
                overview.status = "Mastered";
              }
              return overview.aggregate = aggregate;
            });
          };
          results.push((function() {
            var k, len2, ref1, results1;
            ref1 = $scope.subject.topics;
            results1 = [];
            for (k = 0, len2 = ref1.length; k < len2; k++) {
              topic = ref1[k];
              results1.push(getAggregate(topic));
            }
            return results1;
          })());
        } else {
          results.push(void 0);
        }
      }
      return results;
    });
    $scope.search = "";
    $scope.searchFilter = function(overview) {
      var j, len1, ref1, tag, topic;
      topic = overview.topic;
      if ($scope.search === "") {
        return true;
      }
      if (topic.name.toLowerCase().indexOf($scope.search.toLowerCase()) > -1) {
        return true;
      }
      ref1 = topic.tags;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        tag = ref1[j];
        if (tag.toLowerCase().indexOf($scope.search.toLowerCase()) > -1) {
          return true;
        }
      }
      return false;
    };
    return $scope.selectTag = function(tag) {
      return $scope.search = tag;
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantTeamBehaviorsController', function($scope, team, tenant) {
    'ngInject';
    $scope.team = team;
    return $scope.tenant = tenant;
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantTeamOverviewController', function($scope, team, tenant, $state, ProgressService, TenantService) {
    'ngInject';
    var i, len, ref, user, userIds;
    $scope.team = team;
    userIds = [];
    ref = team.members;
    for (i = 0, len = ref.length; i < len; i++) {
      user = ref[i];
      userIds.push(user.id);
    }
    $scope.userIds = userIds;
    $scope.tenant = tenant;
    $scope.selectUser = function(user) {
      console.log("select user", user);
      return $state.go("tenant.user.overview", {
        tenantRef: tenant.urlName,
        userId: user.id
      });
    };
    $scope.chartOptions = {
      chart: {
        type: 'pieChart',
        height: 200,
        donut: true,
        showLegend: false,
        showLabels: false,
        valueFormat: d3.format(',.0f'),
        margin: 0,
        y: function(d) {
          return d.y;
        },
        x: function(d) {
          return d.x;
        },
        color: function(d) {
          return d.color;
        },
        duration: 500
      }
    };
    ProgressService.getQuestionAggregate(userIds, tenant).then(function(progress) {
      return $scope.progress = progress;
    });
    TenantService.getContent(tenant).then(function(content) {
      var getAggregate, j, len1, ref1, results, subject;
      $scope.subjects = content.subjects;
      $scope.subjectOverviews = [];
      getAggregate = function(subject) {
        var overview;
        overview = {
          subject: subject
        };
        $scope.subjectOverviews.push(overview);
        return ProgressService.getQuestionAggregate(userIds, tenant, subject.id).then(function(aggregate) {
          overview.chartData = [
            {
              x: "Complete",
              y: aggregate.complete,
              color: "#23AE89"
            }, {
              x: "In revision",
              y: aggregate.revision,
              color: "#FFB61C"
            }, {
              x: "Attempted",
              y: aggregate.attempted,
              color: "#2EC1CC"
            }, {
              x: "Not yet attempted",
              y: aggregate.total - aggregate.attempted - aggregate.revision - aggregate.complete,
              color: "#f5f5f5"
            }
          ];
          return overview.aggregate = aggregate;
        });
      };
      ref1 = $scope.subjects;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        subject = ref1[j];
        results.push(getAggregate(subject));
      }
      return results;
    });
    return $scope.selectSubject = function(subject) {
      return $state.go("tenant.team.subject", {
        tenantRef: tenant.urlName,
        teamId: team.id,
        subjectId: subject.id
      });
    };
  });

}).call(this);



(function() {


}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminUsersController', function($scope, cogniss, tenant, TenantService) {
    'ngInject';
    $scope.order = 'created.$date';
    $scope.orderReverse = true;
    $scope.limit = 10;
    return TenantService.getUsers(tenant).then(function(users) {
      return $scope.users = users;
    });
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminVouchersController', function($scope, cogniss, tenant, VoucherService, $uibModal) {
    'ngInject';
    var editVoucher, modal, saveVoucher, update;
    modal = null;
    $scope.order = 'created.$date';
    $scope.orderReverse = true;
    $scope.limit = 10;
    $scope.skip = 0;
    $scope.count = 0;
    $scope.currentPage = 0;
    $scope.$watch("currentPage", function(val) {
      return update();
    });
    update = function() {
      var skip;
      skip = ($scope.currentPage - 1) * $scope.limit;
      return VoucherService.getVouchers(tenant, $scope.limit, skip).then(function(result) {
        $scope.vouchers = result.vouchers;
        return $scope.count = result.count;
      });
    };
    saveVoucher = function(voucher, config) {
      if (config.bulk) {
        return VoucherService.bulkCreateVouchers(voucher, config.count, config.codes).then(function() {
          update();
          return modal.close();
        });
      } else {
        if (!config.isAssigned) {
          voucher.playerId = null;
          voucher.consumed = false;
        }
        if (!voucher.consumed) {
          voucher.consumedDate = null;
        }
        return VoucherService.saveVoucher(voucher).then(function(voucher) {
          update();
          return modal.close();
        });
      }
    };
    $scope.createVoucher = function(bulk) {
      return editVoucher(bulk);
    };
    $scope.selectVoucher = function(voucher) {
      return editVoucher(null, angular.copy(voucher));
    };
    $scope.deleteVoucher = function(voucher) {
      return VoucherService.deleteVoucher(voucher).then(function(voucher) {
        update();
        return modal.close();
      });
    };
    return editVoucher = function(bulk, voucher) {
      var config, modalScope;
      modalScope = $scope.$new();
      modalScope.saveVoucher = saveVoucher;
      modalScope.expiryOptions = {
        showWeeks: false
      };
      config = {
        bulk: bulk
      };
      if (voucher != null) {
        config.assigned = voucher.playerId != null;
        config.isAssigned = config.assigned;
        config.consumed = voucher.consumed;
      } else {
        voucher = {
          tenant: tenant.code
        };
        if (bulk) {
          config.autoCodes = true;
          config.codes = [];
          config.count = 2;
        } else {
          voucher.code = random.alphaNum(6).toUpperCase();
        }
      }
      modalScope.voucher = voucher;
      modalScope.config = config;
      return modal = $uibModal.open({
        templateUrl: "app/screens/tenant/admin/vouchers/vouchercreate-modal.html",
        scope: modalScope
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminLeaderboardsController', function($scope, LeaderboardService, modalService, $state, tenant, $filter) {
    'ngInject';
    $scope.tenant = tenant;
    LeaderboardService.getLeaderboards($scope.tenant).then(function(leaderboards) {
      return $scope.leaderboards = leaderboards;
    });
    $scope.dateOptions = {
      showWeeks: false
    };
    $scope.addTeam = function() {
      var team;
      team = {
        teamId: "",
        xp: 0,
        multiplyer: 1
      };
      return $scope.leaderboardFormData.teams.push(team);
    };
    $scope.deleteTeam = function(team) {
      return $scope.leaderboardFormData.teams.splice($scope.leaderboardFormData.teams.indexOf(team), 1);
    };
    $scope.newLeaderboard = function() {
      $scope.leaderboardFormData = {
        name: "",
        teams: [],
        start: null,
        end: null,
        tenant: tenant.code
      };
      return $scope.addTeam();
    };
    $scope.newLeaderboard();
    $scope.$watch("leaderboardFormData", function(leaderboard) {
      $scope.start = moment(leaderboard.start).toDate();
      return $scope.end = moment(leaderboard.end).toDate();
    });
    $scope.saveLeaderboard = function() {
      var index;
      $scope.leaderboardFormData.start = $scope.start.toISOString();
      $scope.leaderboardFormData.end = $scope.end.toISOString();
      index = $scope.leaderboards.indexOf($scope.editLeaderboard);
      $scope.editLeaderboard = angular.copy($scope.leaderboardFormData);
      console.log("saving Leaderboard", $scope.editLeaderboard);
      return LeaderboardService.saveLeaderboard($scope.leaderboardFormData).then(function(leaderboard) {
        if ($scope.editLeaderboard.id == null) {
          $scope.leaderboards.push(leaderboard);
          $scope.editLeaderboard = leaderboard;
        } else {
          $scope.leaderboards.splice(index, 1, leaderboard);
        }
        return $scope.newLeaderboard();
      });
    };
    $scope.selectLeaderboard = function(leaderboard) {
      console.log("select Leaderboard", leaderboard);
      $scope.editLeaderboard = leaderboard;
      return $scope.leaderboardFormData = angular.copy($scope.editLeaderboard);
    };
    return $scope.archiveLeaderboard = function(leaderboard) {
      var doArchive;
      doArchive = function() {
        var index;
        index = $scope.leaderboards.indexOf(leaderboard);
        leaderboard.archived = true;
        LeaderboardService.saveLeaderboard(leaderboard).then(function(leaderboard) {
          return $scope.leaderboards.splice(index, 1);
        }, function(error) {
          return modalService.showModal("Error", "Error archiving leaderboard");
        });
        return $scope.newLeaderboard();
      };
      return modalService.showModal("Confirm archiving Leaderboard", "Are you sure you want to archive this leaderboard?", true, true, "Cancel", doArchive, "Confirm");
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminBehaviorsController', function($scope, cogniss, tenant) {
    'ngInject';
    return $scope.tenant = tenant;
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantContentSubjectsController', function($scope, ContentService, $state, tenant, $filter) {
    'ngInject';
    return ContentService.getSubjects(tenant).then(function(subjects) {
      subjects = $filter('orderBy')(subjects, "order");
      return $scope.subjects = subjects;
    });
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantContentSubjectController', function($scope, ContentService, $state, tenant, $filter, subjectId) {
    'ngInject';
    ContentService.getSubject(subjectId).then(function(subject) {
      $scope.subject = subject;
      return ContentService.getTopics(tenant, subject.id).then(function(topics) {
        return $scope.topics = topics;
      });
    });
    return $scope.launchTopic = function(topic) {
      return ContentService.getActivities(tenant, null, topic).then(function(activities) {
        var activity;
        console.log("activities", activities);
        if (activities.length === 0) {
          alert("no activities for this topic");
          return;
        }
        activity = activities[0];
        return $state.go("tenant.content.activity", {
          tenantRef: tenant.urlName,
          activityId: activity.id
        });
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantContentActivityController', function($scope, ContentService, tenant, activityId, ProgressService, UtilService, $filter) {
    'ngInject';
    var completeActivity, nextQuestion, questionIndex;
    console.log("activityId", activityId);
    questionIndex = 0;
    ContentService.getActivity(activityId).then(function(activity) {
      $scope.activity = activity;
      return ContentService.getTopic(activity.topicId).then(function(topic) {
        $scope.topic = topic;
        return ContentService.getQuestions(tenant, activity.topicId).then(function(questions) {
          var activityResponse;
          $scope.questions = $filter('orderBy')(questions, 'order');
          nextQuestion();
          activityResponse = {
            activityId: activity.id,
            date: UtilService.localISOString()
          };
          console.log("activityResponse", activityResponse);
          return ProgressService.saveActivityResponse(activityResponse).then(function(response) {
            console.log("response", response);
            return $scope.activityResponse = response;
          });
        });
      });
    });
    nextQuestion = function() {
      $scope.question = $scope.questions[questionIndex];
      console.log("$scope.question", $scope.question);
      return questionIndex++;
    };
    completeActivity = function() {
      $scope.activityComplete = true;
      if (!$scope.activityResponse.complete) {
        $scope.activityResponse.complete = true;
        $scope.activityResponse.completeDate = UtilService.localISOString();
        console.log("activityResponse", $scope.activityResponse);
        return ProgressService.saveActivityResponse($scope.activityResponse).then(function(response) {
          return console.log("response", response);
        });
      }
    };
    return $scope.selectOption = function(option) {
      var questionResponse;
      questionResponse = {
        questionId: $scope.question.id,
        activityResponseId: $scope.activityResponse.id,
        date: UtilService.localISOString(),
        correct: true,
        answer: option.text
      };
      console.log("questionResponse", questionResponse);
      ProgressService.saveQuestionResponse(questionResponse).then(function(response) {
        return console.log("response", response);
      });
      if (questionIndex < $scope.questions.length) {
        return nextQuestion();
      } else {
        $scope.question = null;
        return completeActivity();
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantUsersController', function($scope, $uibModal, cogniss, tenant, modalService, $state, Analytics) {
    'ngInject';
    var modal, submitUser;
    modal = null;
    $scope.tenant = tenant;
    $scope.$watch(function() {
      return cogniss.user;
    }, function(val) {
      return $scope.user = val;
    });
    cogniss.getInsightsUsers(tenant).then(function(users) {
      return $scope.users = users;
    });
    submitUser = function(code) {
      return cogniss.addInsightsUser(tenant, code).then(function(userId) {
        if ($scope.user.userId === userId) {
          modalService.showModal("Error", "User Exists");
        } else {
          $scope.users.push(userId);
        }
        return modal.close();
      }, function(error) {
        return modalService.showModal("Error", "Invalid insights code");
      });
    };
    $scope.selectUser = function(user) {
      return $state.go("tenant.user.overview", {
        tenantRef: tenant.urlName,
        userId: user
      });
    };
    return $scope.addUser = function() {
      var modalScope;
      modalScope = $scope.$new();
      modalScope.code = "";
      modalScope.submitUser = submitUser;
      return modal = $uibModal.open({
        templateUrl: "app/screens/tenant/users/add-user-modal.html",
        scope: modalScope
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantUserController', function($scope, $uibModal, cogniss, tenant, userDetails, modalService, UserService, TenantService, $state, Auth) {
    'ngInject';
    return $scope.$watch(function() {
      return cogniss.user;
    }, function(val) {
      $scope.user = val;
      return Auth.isTenantAdmin(tenant).then(function(isAdmin) {
        if (!isAdmin) {
          return cogniss.getInsightsUsers(tenant).then(function(users) {
            var found, i, len, user;
            found = false;
            if ($scope.user.userId === userDetails.playerId) {
              found = true;
            }
            for (i = 0, len = users.length; i < len; i++) {
              user = users[i];
              if (user === userDetails.playerId) {
                found = true;
              }
            }
            if (!found) {
              return $state.go("tenant.users");
            }
          });
        }
      });
    });
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantTeamsController', function($scope, TeamService, $state) {
    'ngInject';
    TeamService.getTeams().then(function(teams) {});
    $scope.$watch(function() {
      return TeamService.teams;
    }, function(teams) {
      return $scope.teams = teams;
    });
    return $scope.selectTeam = function(team) {
      return $state.go("tenant.team.overview", {
        teamId: team.id
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantTeamController', function($scope) {
    return 'ngInject';
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantSubjectsController', function($scope, cogniss, tenant, TenantService, $filter) {
    'ngInject';
    TenantService.getContent(tenant).then(function(content) {
      var allSubjects;
      $scope.subjectList = _.clone(content.subjects);
      $scope.subjectList = $filter('orderBy')($scope.subjectList, 'order');
      allSubjects = {
        name: "All subjects"
      };
      $scope.subjectList.splice(0, 0, allSubjects);
      $scope.subject = allSubjects;
      $scope.topics = content.topics;
      return $scope.$watch("subject", function(val) {
        if (val === allSubjects) {
          return $scope.topics = content.topics;
        } else {
          return $scope.topics = val.topics;
        }
      });
    });
    $scope.search = "";
    $scope.searchFilter = function(topic) {
      var i, len, ref, tag;
      if ($scope.search === "") {
        return true;
      }
      if (topic.name.indexOf($scope.search) > -1) {
        return true;
      }
      ref = topic.tags;
      for (i = 0, len = ref.length; i < len; i++) {
        tag = ref[i];
        if (tag.indexOf($scope.search) > -1) {
          return true;
        }
      }
      return false;
    };
    return $scope.selectTag = function(tag) {
      return $scope.search = tag;
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantAdminController', function($scope, cogniss, tenant, TenantService) {
    return 'ngInject';
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TeamsTeamController', function($scope, team, TeamService, $state, cogniss, $uibModal) {
    'ngInject';
    console.log("team", team);
    return $scope.team = team;
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TeamsOverviewController', function($scope, $uibModal, TeamService, $state, modalService) {
    'ngInject';
    TeamService.getTeams().then(function(teams) {});
    $scope.$watch(function() {
      return TeamService.teams;
    }, function(teams) {
      return $scope.teams = teams;
    });
    $scope.addTeam = function() {
      var modal, modalScope;
      modalScope = $scope.$new();
      modalScope.team = {
        code: "",
        name: "",
        description: ""
      };
      modalScope.submitTeam = function(team) {
        return TeamService.addTeam(team).then(function(team) {
          modal.close();
          return $state.go("teams.team", {
            teamId: team.id
          });
        }, function(error) {
          if ((error.data != null) && error.data.code === "409") {
            return modalService.showModal("Error", "This team code is in use. Please choose another.");
          }
        });
      };
      return modal = $uibModal.open({
        templateUrl: "app/screens/teams/overview/add-team-modal.html",
        scope: modalScope
      });
    };
    $scope.joinTeam = function() {
      var modal, modalScope;
      modalScope = $scope.$new();
      modalScope.code = "";
      modalScope.submitCode = function(code) {
        console.log("submit code", modalScope);
        return TeamService.joinTeam(code).then(function(team) {
          modal.close();
          return $state.go("teams.team", {
            teamId: team.id
          });
        }, function(error) {
          console.log("error", error);
          if ((error.data != null) && error.data.code === "404") {
            return modalService.showModal("Error", "This team code is incorrect. Please choose another.");
          }
        });
      };
      return modal = $uibModal.open({
        templateUrl: "app/screens/teams/overview/join-team-modal.html",
        scope: modalScope
      });
    };
    return $scope.selectTeam = function(team) {
      return $state.go("teams.team", {
        teamId: team.id
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('AdminTenantsController', function($scope, TenantService, modalService, $state) {
    'ngInject';
    TenantService.getTenants().then(function(tenants) {
      return $scope.tenants = tenants;
    });
    $scope.newTenant = function(subject) {
      return $scope.formData = {
        name: "",
        description: "",
        filepath: ""
      };
    };
    $scope.saveTenant = function() {
      var index;
      index = $scope.tenants.indexOf($scope.editTenant);
      $scope.editTenant = angular.copy($scope.formData);
      return TenantService.saveTenant($scope.formData).then(function(tenant) {
        if ($scope.editTenant.id == null) {
          $scope.tenants.push(tenant);
          $scope.editTenant = tenant;
        } else {
          $scope.tenants.splice(index, 1, tenant);
        }
        return $scope.newTenant();
      });
    };
    $scope.selectTenant = function(tenant) {
      $scope.editTenant = tenant;
      return $scope.formData = angular.copy($scope.editTenant);
    };
    return $scope.deleteTenant = function(tenant) {
      var doDelete;
      doDelete = function() {
        var index;
        index = $scope.tenants.indexOf(tenant);
        TenantService.deleteTenant(tenant).then(function(tenant) {
          return $scope.tenants.splice(index, 1);
        }, function(error) {
          return modalService.showModal("Error", "Error removing tenant");
        });
        return $scope.newTenant();
      };
      return modalService.showModal("Confirm removing Tenant", "Are you sure you want to remove this tenant?", true, true, "Cancel", doDelete, "Confirm");
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('AdminTemplatesController', function($scope, ContentService, modalService, $state, QuestionTypes) {
    'ngInject';
    ContentService.getTemplates().then(function(templates) {
      return $scope.templates = templates;
    });
    $scope.questionTypes = QuestionTypes;
    $scope.newTemplate = function(subject) {
      $scope.formData = {
        name: "",
        description: "",
        filepath: "",
        questionTypes: []
      };
      return $scope.addType();
    };
    $scope.saveTemplate = function() {
      var index;
      index = $scope.templates.indexOf($scope.editTemplate);
      $scope.editTemplate = angular.copy($scope.formData);
      return ContentService.saveTemplate($scope.formData).then(function(template) {
        if ($scope.editTemplate.id == null) {
          $scope.templates.push(template);
          $scope.editTemplate = template;
        } else {
          $scope.templates.splice(index, 1, template);
        }
        return $scope.newTemplate();
      });
    };
    $scope.selectTemplate = function(template) {
      $scope.editTemplate = template;
      return $scope.formData = angular.copy($scope.editTemplate);
    };
    $scope.archiveTemplate = function(template) {
      var doArchive;
      doArchive = function() {
        var index;
        index = $scope.templates.indexOf(template);
        template.archived = true;
        ContentService.saveTemplate(template).then(function(template) {
          return $scope.templates.splice(index, 1);
        }, function(error) {
          return modalService.showModal("Error", "Error archiving template");
        });
        return $scope.newTemplate();
      };
      return modalService.showModal("Confirm archiving Template", "Are you sure you want to archive this template?", true, true, "Cancel", doArchive, "Confirm");
    };
    $scope.addType = function() {
      if ($scope.formData.questionTypes == null) {
        $scope.formData.questionTypes = [];
      }
      return $scope.formData.questionTypes.push({
        type: "",
        attributes: {}
      });
    };
    $scope.onChangeType = function(type) {
      return type.attributes = {};
    };
    $scope.removeType = function(type) {
      return $scope.formData.questionTypes.splice($scope.formData.questionTypes.indexOf(type), 1);
    };
    return $scope.newTemplate();
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('AdminBehaviorsController', function($scope) {
    return 'ngInject';
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionInputTextRange', function() {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/questioninput/textrange/textrange.html',
      scope: {
        question: "="
      },
      link: function($scope) {}
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionInputTemplateInterpreted', function($interval) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/questioninput/templateinterpreted/templateinterpreted.html',
      scope: {
        question: "="
      },
      link: function($scope) {
        $scope.$watch("question", function(val) {
          return $scope.jsonString = JSON.stringify(val, null, 2);
        });
        return $scope.$watch("jsonString", function(val) {
          var error;
          $scope.wellFormed = true;
          try {
            return JSON.parse($scope.jsonString);
          } catch (error1) {
            error = error1;
            console.log("error", error);
            return $scope.wellFormed = false;
          } finally {
            $scope.jsonForm.jsonInput.$setValidity("wellFormed", $scope.wellFormed);
            if ($scope.wellFormed) {
              $scope.question = JSON.parse($scope.jsonString);
            }
          }
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionInputMultichoice', function(TopicTypes) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/questioninput/multichoice/multichoice.html',
      scope: {
        topic: "=",
        question: "="
      },
      link: function($scope) {
        $scope.selectOption = function(option) {
          return $scope.selectedOption = option;
        };
        $scope.$watch("selectedOption", function(option) {
          var i, len, o, ref;
          if ($scope.question == null) {
            return;
          }
          if ($scope.question.options == null) {
            return;
          }
          ref = $scope.question.options;
          for (i = 0, len = ref.length; i < len; i++) {
            o = ref[i];
            o.correct = false;
          }
          if (option == null) {
            return;
          }
          return option.correct = true;
        });
        $scope.$watch("topic", function(topic) {
          $scope.showCorrect = topic.topicType !== TopicTypes.SURVEY && topic.topicType !== TopicTypes.SCORED_SURVEY;
          return $scope.showScore = topic.topicType === TopicTypes.SCORED_SURVEY;
        });
        $scope.$watch("question", function(question) {
          if (question.id == null) {
            question.label = "";
            question.description = "";
            question.text = "";
            if (question.options == null) {
              question.options = [];
              $scope.addOption();
              $scope.addOption();
            }
          }
          return $scope.updateSelectedOption();
        });
        $scope.updateSelectedOption = function() {
          var i, len, option, ref, results;
          $scope.selectedOption = null;
          ref = $scope.question.options;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            option = ref[i];
            if (option.correct) {
              results.push($scope.selectedOption = option);
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
        $scope.addOption = function() {
          var option;
          option = {};
          option.label = "";
          if ($scope.topic.attributes.optionText) {
            option.text = "";
          }
          if ($scope.topic.attributes.optionAudio) {
            option.audio = "";
          }
          if ($scope.topic.attributes.optionImage) {
            option.image = "";
          }
          if ($scope.topic.topicType === TopicTypes.SCORED_SURVEY) {
            option.score = 0;
          }
          return $scope.question.options.push(option);
        };
        return $scope.deleteOption = function(option) {
          $scope.question.options.splice($scope.question.options.indexOf(option), 1);
          return $scope.updateSelectedOption();
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionInputImageResponse', function() {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/questioninput/imageresponse/imageresponse.html',
      scope: {
        topic: "=",
        question: "="
      },
      link: function($scope) {}
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionInputFillBlanks', function() {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/questioninput/fillblanks/fillblanks.html',
      scope: {
        question: "="
      },
      link: function($scope) {}
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionInputEquation', function() {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/questioninput/equation/equation.html',
      scope: {
        question: "="
      },
      link: function($scope) {}
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionInputCategorisation', function() {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/questioninput/categorisation/categorisation.html',
      scope: {
        question: "="
      },
      link: function($scope) {}
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionInputAudioResponse', function() {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/questioninput/audioresponse/audioresponse.html',
      scope: {
        topic: "=",
        question: "="
      },
      link: function($scope) {}
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgTriggerInput', function(TriggerTypes) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/behaviorinput/triggerinput/triggerinput.html',
      scope: {
        trigger: "=",
        types: "=",
        tenant: "="
      },
      link: function($scope) {
        var hour, i, j, label, minute, updateDate;
        $scope.scheduleTypes = {
          DURATION: "DURATION",
          TIME: "TIME",
          DATE: "DATE"
        };
        $scope.dateOptions = {
          minDate: new Date()
        };
        $scope.hours = [];
        for (hour = i = 0; i < 23; hour = ++i) {
          label = hour.toString();
          if (label.length === 1) {
            label = "0" + label;
          }
          $scope.hours.push({
            label: label,
            value: hour
          });
        }
        $scope.minutes = [];
        for (minute = j = 0; j < 59; minute = ++j) {
          label = minute.toString();
          if (label.length === 1) {
            label = "0" + label;
          }
          $scope.minutes.push({
            label: label,
            value: minute
          });
        }
        $scope.triggerTypes = TriggerTypes;
        $scope.$watch("trigger.type", function(type, oldType) {
          $scope.selectActivity = false;
          if (type === TriggerTypes.SCHEDULED) {
            $scope.scheduleType = $scope.scheduleTypes.DATE;
            $scope.date = moment().startOf('day').add(1, 'days').toDate();
            $scope.hour = $scope.hours[0];
            $scope.minute = $scope.minutes[0];
            updateDate();
          }
          if (($scope.tenant != null) && (type === TriggerTypes.ACTIVITY_RESPONSE || type === TriggerTypes.COMPLETE_ACTIVITY)) {
            $scope.selectActivity = true;
          }
          if (($scope.tenant != null) && type === TriggerTypes.QUESTION_RESPONSE) {
            return $scope.selectQuestion = true;
          }
        });
        updateDate = function() {
          var d, diff, duration, m, offset;
          if ($scope.trigger.type !== TriggerTypes.SCHEDULED) {
            return;
          }
          $scope.trigger.date = null;
          $scope.trigger.duration = null;
          $scope.trigger.fromMidnight = null;
          m = null;
          if ($scope.scheduleType === $scope.scheduleTypes.DATE) {
            if ($scope.date == null) {
              return;
            }
            d = $scope.date.toISOString();
            m = moment(d);
            offset = m.utcOffset();
            m.utc();
            m.add(offset, 'minutes');
            m.hour($scope.hour.value);
            m.minute($scope.minute.value);
            return $scope.trigger.date = m.toISOString();
          } else if ($scope.scheduleType === $scope.scheduleTypes.TIME) {
            m = moment();
            m.startOf('day');
            m.hour($scope.hour.value);
            m.minute($scope.minute.value);
            diff = m.diff(moment().startOf('day'), 'seconds');
            $scope.trigger.fromMidnight = true;
            return $scope.trigger.duration = diff;
          } else {
            duration = 0;
            duration += $scope.hour.value * 60 * 60;
            duration += $scope.minute.value * 60;
            $scope.trigger.fromMidnight = false;
            return $scope.trigger.duration = duration;
          }
        };
        $scope.$watch("date", updateDate);
        $scope.$watch("hour", updateDate);
        return $scope.$watch("minute", updateDate);
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgResultInput', function(ResultTypes) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/behaviorinput/resultinput/resultinput.html',
      scope: {
        result: "=",
        types: "="
      },
      link: function($scope) {
        $scope.resultTypes = ResultTypes;
        return $scope.$watch("result.type", function(type) {
          if (type === ResultTypes.SCHEDULED) {
            return updateDate();
          }
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionSelect', function(ResultTypes, ContentService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/behaviorinput/questionselect/questionselect.html',
      scope: {
        tenant: "=",
        questionId: "="
      },
      link: function($scope) {
        var updateSelectedQuestion;
        $scope.selectedQuestion = null;
        $scope.selectedTopic = null;
        $scope.$watch("tenant", function(tenant) {
          if (tenant != null) {
            return ContentService.exportContent(tenant).then(function(content) {
              $scope.content = content;
              return updateSelectedQuestion();
            });
          }
        });
        $scope.$watch("questionId", updateSelectedQuestion);
        updateSelectedQuestion = function() {
          var i, len, question, ref, results, topic;
          $scope.selectedQuestion = null;
          $scope.selectedTopic = null;
          if ($scope.content == null) {
            return;
          }
          if ($scope.questionId == null) {
            return;
          }
          ref = $scope.content.questions;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            question = ref[i];
            if (question.id === $scope.questionId) {
              $scope.selectedQuestion = question;
              results.push((function() {
                var j, len1, ref1, results1;
                ref1 = $scope.content.topics;
                results1 = [];
                for (j = 0, len1 = ref1.length; j < len1; j++) {
                  topic = ref1[j];
                  if (topic.id === $scope.selectedQuestion.topicId) {
                    results1.push($scope.selectedTopic = topic);
                  } else {
                    results1.push(void 0);
                  }
                }
                return results1;
              })());
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
        $scope.$watch("selectedTopic", function(val) {
          if ($scope.content == null) {
            return;
          }
          if (val == null) {
            return $scope.questionId = null;
          }
        });
        return $scope.$watch("selectedQuestion", function(val) {
          if ($scope.content == null) {
            return;
          }
          $scope.questionId = null;
          if (val != null) {
            console.log("setting questionId", val.id);
            return $scope.questionId = val.id;
          }
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgCriteriaInput', function(CriteriaTypes) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/behaviorinput/criteriainput/criteriainput.html',
      scope: {
        criteria: "=",
        types: "=",
        tenant: "="
      },
      link: function($scope) {
        $scope.criteriaTypes = CriteriaTypes;
        $scope.$watch("criteria.count", function(val) {
          if (val === null) {
            return delete $scope.criteria.count;
          }
        });
        $scope.$watch("criteria.score", function(val) {
          if (val === null) {
            return delete $scope.criteria.score;
          }
        });
        $scope.$watch("criteria.scoreMax", function(val) {
          if (val === null) {
            return delete $scope.criteria.scoreMax;
          }
        });
        $scope.$watch("criteria.scoreMin", function(val) {
          if (val === null) {
            return delete $scope.criteria.scoreMin;
          }
        });
        $scope.$watch("criteria.value", function(val) {
          if (val === null) {
            return delete $scope.criteria.value;
          }
        });
        $scope.$watch("criteria.valueMin", function(val) {
          if (val === null) {
            return delete $scope.criteria.valueMin;
          }
        });
        $scope.$watch("criteria.valueMax", function(val) {
          if (val === null) {
            return delete $scope.criteria.valueMax;
          }
        });
        return $scope.$watch("criteria.type", function(type) {
          $scope.selectQuestion = false;
          $scope.selectActivity = false;
          $scope.selectCount = false;
          $scope.selectAnswer = false;
          $scope.selectValue = false;
          $scope.selectScore = false;
          if (type === CriteriaTypes.ACTIVITY_RESPONSE) {
            $scope.selectActivity = true;
            $scope.selectCount = true;
            $scope.selectScore = true;
            delete $scope.criteria.answer;
            delete $scope.criteria.value;
            delete $scope.criteria.valueMax;
            delete $scope.criteria.valueMin;
          }
          if (type === CriteriaTypes.QUESTION_RESPONSE) {
            $scope.selectQuestion = true;
            $scope.selectCount = true;
            $scope.selectValue = true;
            $scope.selectAnswer = true;
            delete $scope.criteria.score;
            delete $scope.criteria.scoreMax;
            return delete $scope.criteria.scoreMin;
          }
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgActivitySelect', function(ResultTypes, ContentService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/behaviorinput/activityselect/activityselect.html',
      scope: {
        tenant: "=",
        activityId: "="
      },
      link: function($scope) {
        var updateSelectedActivity;
        $scope.selectedActivity = null;
        $scope.$watch("tenant", function(tenant) {
          if (tenant != null) {
            return ContentService.exportContent(tenant).then(function(content) {
              console.log("content", content);
              $scope.content = content;
              return updateSelectedActivity();
            });
          }
        });
        $scope.$watch("activityId", updateSelectedActivity);
        updateSelectedActivity = function() {
          var activity, i, len, ref, results;
          console.log("updateSelectedActivity", $scope.content != null, $scope.activityId);
          if ($scope.content == null) {
            return;
          }
          if ($scope.activityId == null) {
            return;
          }
          ref = $scope.content.activities;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            activity = ref[i];
            if (activity.id === $scope.activityId) {
              results.push($scope.selectedActivity = activity);
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
        return $scope.$watch("selectedActivity", function(val) {
          var activity, i, len, ref, results;
          if ($scope.content == null) {
            return;
          }
          $scope.activityId = null;
          ref = $scope.content.activities;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            activity = ref[i];
            if (activity === $scope.selectedActivity) {
              results.push($scope.activityId = activity.id);
            } else {
              results.push(void 0);
            }
          }
          return results;
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TenantController', function($scope, cogniss, TenantService, $uibModal, tenant, $state, $translate, UserService) {
    'ngInject';
    $scope.$watch(function() {
      return $state.current;
    }, function(val) {
      return $scope.topLevel = val.name.indexOf("tenant.user.") !== 0;
    });
    $scope.tenant = tenant;
    UserService.getUserDetails(cogniss.user.userId, tenant).then(function(details) {
      return $scope.userDetails = details;
    });
    return $scope.showTenantInfo = function() {
      var modalScope;
      modalScope = $scope.$new();
      modalScope.tenant = $scope.tenant;
      return $uibModal.open({
        templateUrl: "app/screens/tenant/tenant-info-modal.html",
        scope: modalScope
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('TeamsController', function($scope) {
    return 'ngInject';
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('ResetController', function($scope, cogniss, $location, modalService, Auth) {
    'ngInject';
    var search, showError, token, userId, userIds;
    $scope.initialised = true;
    search = $location.search();
    token = search.token;
    userId = search.user;
    userIds = search.users;
    if (cogniss.user != null) {
      return Auth.redirect();
    }
    if (userIds != null) {
      $scope.userIds = userIds.split(",");
    }
    showError = function() {
      return modalService.showModal("Error", "Invalid password reset link");
    };
    if (!((token != null) && ((userId != null) || ($scope.userIds != null)))) {
      showError();
    }
    $scope.password = "";
    $scope.state = "reset";
    if ($scope.userIds) {
      $scope.state = "users";
    }
    $scope.selectUser = function(id) {
      userId = id;
      return $scope.state = "reset";
    };
    return $scope.reset = function() {
      return cogniss.reset(userId, token, $scope.password).then(function() {
        return modalService.showModal("Password changed", "You can now log in to cogniss");
      }, function(error) {
        return showError();
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('RegisterController', function($scope, cogniss, $state, modalService, FacebookService, Auth) {
    'ngInject';
    if (cogniss.user != null) {
      return Auth.redirect();
    }
    $scope.user = {
      userName: "",
      email: "",
      password: ""
    };
    $scope.register = function() {
      if ($scope.pending) {
        return;
      }
      $scope.pending = true;
      return cogniss.register($scope.user).then(function() {
        $scope.pending = false;
        return Auth.redirect();
      }, function(err) {
        var message;
        $scope.pending = false;
        message = "Registration error";
        if ((err.USERNAME != null) && err.USERNAME === "TAKEN") {
          message = "That username is already taken";
        }
        return modalService.showModal("Error", message);
      });
    };
    return $scope.fbRegister = function() {
      return FacebookService.login($scope.user).then(function() {
        return Auth.redirect();
      }, function(err) {
        var message;
        message = "Registration error";
        return modalService.showModal("Error", message);
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('MainController', function() {
    return 'ngInject';
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('LoginController', function(modalService, $scope, cogniss, $state, FacebookService, Auth) {
    'ngInject';
    if (cogniss.user != null) {
      return Auth.redirect();
    }
    $scope.user = {
      userName: "",
      password: ""
    };
    $scope.login = function() {
      if ($scope.pending) {
        return;
      }
      $scope.pending = true;
      return cogniss.login($scope.user).then(function() {
        $scope.pending = false;
        return Auth.redirect();
      }, function(err) {
        var message;
        $scope.pending = false;
        message = "Invalid username or password";
        return modalService.showModal("Error", message);
      });
    };
    return $scope.fbLogin = function() {
      return FacebookService.login($scope.user).then(function() {
        return Auth.redirect();
      }, function(err) {
        var message;
        message = "Login error";
        return modalService.showModal("Error", message);
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('ForgotController', function(modalService, $scope, cogniss, $state, Auth) {
    'ngInject';
    if (cogniss.user != null) {
      return Auth.redirect();
    }
    $scope.userNameOrEmail = "";
    return $scope.forgot = function() {
      if ($scope.pending) {
        return;
      }
      $scope.pending = true;
      return cogniss.forgot($scope.userNameOrEmail).then(function() {
        $scope.pending = false;
        return modalService.showModal("Reset email sent", "Please check your email for a reset password link");
      }, function(err) {
        var message;
        $scope.pending = false;
        message = "Unknown username or email";
        return modalService.showModal("Error", message);
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').controller('AdminController', function($scope) {
    return 'ngInject';
  });

}).call(this);



(function() {
  angular.module('cogniss').service('VoucherService', function(cogniss, $q) {
    'ngInject';
    var service;
    return service = {
      getVouchers: function(tenant, limit, skip) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("VOUCHER_LIST", {
          tenant: tenant.code,
          limit: limit,
          skip: skip
        }).then(function(response) {
          return deferred.resolve(response.scriptData);
        }, deferred.reject);
        return deferred.promise;
      },
      saveVoucher: function(voucher) {
        var deferred, event;
        deferred = $q.defer();
        event = "VOUCHER_CREATE";
        if (voucher.id != null) {
          event = "VOUCHER_UPDATE";
        }
        cogniss.logEventRequest(event, {
          voucher: voucher
        }).then(function(response) {
          return deferred.resolve(response.scriptData.voucher);
        }, deferred.reject);
        return deferred.promise;
      },
      deleteVoucher: function(voucher) {
        var deferred, event;
        deferred = $q.defer();
        event = "VOUCHER_DELETE";
        cogniss.logEventRequest(event, {
          id: voucher.id
        }).then(function(response) {
          return deferred.resolve(true);
        }, deferred.reject);
        return deferred.promise;
      },
      bulkCreateVouchers: function(voucher, count, codes) {
        var data, deferred, event;
        console.log("bulkCreateVouchers", voucher, count, codes);
        deferred = $q.defer();
        event = "VOUCHER_CREATE_BULK";
        data = {
          voucher: voucher
        };
        if ((codes != null) && codes.length > 0) {
          data.codes = codes.join(',');
        } else if (count > 0) {
          data.count = count;
        }
        cogniss.logEventRequest(event, data).then(function(response) {
          console.log("bulkCreateVouchers response", response);
          return deferred.resolve(response);
        }, deferred.reject);
        return deferred.promise;
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').service('UtilService', function(cogniss, $q) {
    'ngInject';
    var service;
    return service = {
      localISOString: function(date) {
        var d, day, hour, min, month, pad, sec, tz, tzs, year;
        d = new Date;
        if (date != null) {
          d = date;
        }
        pad = function(n) {
          if (n < 10) {
            return '0' + n;
          } else {
            return n;
          }
        };
        tz = d.getTimezoneOffset();
        tzs = (tz > 0 ? '-' : '+') + pad(parseInt(Math.abs(tz / 60)));
        if (tz % 60 !== 0) {
          tzs += pad(Math.abs(tz % 60));
        }
        if (tz === 0) {
          tzs = 'Z';
        }
        year = d.getFullYear();
        month = pad(d.getMonth() + 1);
        day = pad(d.getDate());
        hour = pad(d.getHours());
        min = pad(d.getMinutes());
        sec = pad(d.getSeconds());
        return year + '-' + month + '-' + day + 'T' + hour + ':' + min + ':' + sec + tzs;
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgUserThumb', function(TenantService, UserService, $state, ProgressService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/userthumb/userthumb.html',
      scope: {
        userId: "=",
        tenant: "="
      },
      link: function($scope) {
        var pending, update;
        pending = false;
        $scope.$watch("userId", function(val) {
          if ($scope.userId != null) {
            return update();
          }
        });
        $scope.$watch("tenant", function(val) {
          if (val != null) {
            pending = false;
          }
          if (($scope.userId != null) && $scope.tenant) {
            return update();
          }
        });
        return update = function() {
          if (pending) {
            return;
          }
          pending = true;
          UserService.getUserDetails($scope.userId, $scope.tenant).then(function(details) {
            return $scope.details = details;
          });
          if ($scope.tenant != null) {
            return ProgressService.getQuestionAggregate([$scope.userId], $scope.tenant).then(function(response) {
              return $scope.questionAggregate = response;
            });
          }
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').service('UserService', function(cogniss, $q, CacheService) {
    'ngInject';
    var service;
    service = {
      user: null,
      userDetails: {},
      userQuestion: {},
      userSubject: {},
      userTopic: {}
    };
    service.getUserDetails = function(userId, tenant) {
      var deferred, key;
      deferred = $q.defer();
      if (tenant != null) {
        key = "userDetailsAggregate_" + userId + "_" + tenant.code;
      } else {
        key = "userDetailsAggregate_" + userId;
      }
      if (CacheService.getItem(key) != null) {
        deferred.resolve(CacheService.getItem(key));
      } else {
        cogniss.getUserDetails(userId, tenant).then(function(details) {
          CacheService.addItem(key, details, 60);
          return deferred.resolve(details);
        }, function(error) {
          return deferred.reject(error);
        });
      }
      return deferred.promise;
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').filter('uploadURL', function($q, cogniss, CacheService, $sce) {
    'ngInject';
    var filter;
    filter = function(uploadId) {
      var cached, deferred, promise;
      cached = CacheService.getItem(uploadId);
      if (cached != null) {
        if (typeof cached === "string") {
          return cached;
        } else {
          return void 0;
        }
      } else {
        deferred = $q.defer();
        cogniss.getUploadedUrl(uploadId).then(function(url) {
          $sce.trustAsResourceUrl(url);
          CacheService.addItem(uploadId, url, 60);
          return deferred.resolve(url);
        }, deferred.reject);
        promise = deferred.promise;
        promise.success = function(displayName) {};
        return CacheService.addItem(uploadId, promise, 60);
      }
    };
    filter.$stateful = true;
    return filter;
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgUpload', function(cogniss, FileUploader) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/upload/upload.html',
      scope: {
        uploadId: "=",
        accept: "@"
      },
      link: function($scope) {
        var uploadUrl, uploader;
        uploadUrl = "";
        uploader = $scope.uploader = new FileUploader();
        uploader.onWhenAddingFileFailed = function(item, filter, options) {};
        uploader.onAfterAddingFile = function(fileItem) {
          var random;
          random = Math.random();
          return cogniss.getUploadUrl({
            random: random
          }).then(function(url) {
            uploadUrl = url;
            uploader.uploadAll();
            return cogniss.onMessage.then(null, null, function(message) {
              console.log("on message handler", message);
              if ((message.uploadData != null) && message.uploadData.random === random) {
                console.log("completed upload", message.uploadData.uploadId);
                return $scope.uploadId = message.uploadData.uploadId;
              }
            });
          });
        };
        uploader.onAfterAddingAll = function(addedFileItems) {};
        uploader.onBeforeUploadItem = function(item) {
          return item.url = uploadUrl;
        };
        uploader.onProgressItem = function(fileItem, progress) {};
        uploader.onProgressAll = function(progress) {};
        uploader.onSuccessItem = function(fileItem, response, status, headers) {};
        uploader.onErrorItem = function(fileItem, response, status, headers) {};
        uploader.onCancelItem = function(fileItem, response, status, headers) {};
        uploader.onCompleteItem = function(fileItem, response, status, headers) {};
        return uploader.onCompleteAll = function() {};
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').filter('topicName', function($q, ContentService, CacheService) {
    'ngInject';
    var filter;
    filter = function(topicId) {
      var cached, deferred, promise;
      if (topicId == null) {
        return "";
      }
      cached = CacheService.getItem(topicId);
      if (cached) {
        if (typeof cached === "string") {
          return cached;
        } else {
          return void 0;
        }
      } else {
        deferred = $q.defer();
        ContentService.getTopic(topicId).then(function(topic) {
          var name;
          name = topic.name;
          CacheService.addItem(topicId, name);
          return deferred.resolve(name);
        }, deferred.reject);
        promise = deferred.promise;
        promise.success = function(name) {};
        return CacheService.addItem(topicId, promise);
      }
    };
    filter.$stateful = true;
    return filter;
  });

}).call(this);



(function() {
  angular.module('cogniss').filter('titlecase', function() {
    'ngInject';
    return function(input) {
      var smallWords;
      smallWords = /^(a|an|and|as|at|but|by|con|de|en|for|if|in|la|las|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
      if (!input) {
        return;
      }
      input = input.toLowerCase();
      return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
          return match.toLowerCase();
        }
        if (match.substr(1).search(/[A-Z]|\../) > -1) {
          return match;
        }
        return match.charAt(0).toUpperCase() + match.substr(1);
      });
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').service('TenantService', function(cogniss, $q, CacheService, ContentService) {
    'ngInject';
    var service;
    service = {
      tenants: null,
      tenant: null
    };
    service.getTenants = function() {
      var deferred;
      deferred = $q.defer();
      cogniss.logEventRequest("TENANT_LIST").then(function(response) {
        return deferred.resolve(response.scriptData.tenants);
      }, deferred.reject);
      return deferred.promise;
    };
    service.getTenantByCode = function(ref) {
      var deferred, doGetTenant;
      deferred = $q.defer();
      doGetTenant = function() {
        var found, i, len, ref1, tenant;
        found = false;
        ref1 = service.tenants;
        for (i = 0, len = ref1.length; i < len; i++) {
          tenant = ref1[i];
          if (tenant.code === ref) {
            found = true;
            deferred.resolve(tenant);
          }
        }
        if (!found) {
          return deferred.reject();
        }
      };
      service.getTenants().then(function(tenants) {
        return doGetTenant();
      });
      return deferred.promise;
    };
    service.getTenantByUrlName = function(name) {
      var deferred, doGetTenant;
      deferred = $q.defer();
      doGetTenant = function() {
        var found, i, len, ref1, tenant;
        found = false;
        ref1 = service.tenants;
        for (i = 0, len = ref1.length; i < len; i++) {
          tenant = ref1[i];
          if (tenant.urlName === name) {
            found = true;
            deferred.resolve(tenant);
          }
        }
        if (!found) {
          return deferred.reject();
        }
      };
      if (service.tenants) {
        doGetTenant();
      } else {
        service.getTenants().then(function(tenants) {
          service.tenants = tenants;
          return doGetTenant();
        }, deferred.reject);
      }
      return deferred.promise;
    };
    service.getDefaultTenant = function() {
      var deferred, doGetTenant;
      deferred = $q.defer();
      doGetTenant = function() {
        var i, len, ref1, results, tenant;
        ref1 = service.tenants;
        results = [];
        for (i = 0, len = ref1.length; i < len; i++) {
          tenant = ref1[i];
          if (tenant.insights) {
            deferred.resolve(tenant);
            break;
          } else {
            results.push(void 0);
          }
        }
        return results;
      };
      if (service.tenants) {
        doGetTenant();
      } else {
        service.getTenants().then(function(tenants) {
          service.tenants = tenants;
          return doGetTenant();
        });
      }
      return deferred.promise;
    };
    service.getContent = function(tenant) {
      var deferred, key;
      deferred = $q.defer();
      key = "tenant_content_" + tenant.code;
      if (CacheService.getItem(key) != null) {
        deferred.resolve(CacheService.getItem(key));
      } else {
        ContentService.exportContent(tenant).then(function(content) {
          var activity, i, j, k, l, len, len1, len2, len3, len4, m, question, questionById, ref1, ref2, ref3, ref4, ref5, subject, subjectById, template, templateById, topic, topicById;
          templateById = {};
          topicById = {};
          subjectById = {};
          questionById = {};
          ref1 = content.subjects;
          for (i = 0, len = ref1.length; i < len; i++) {
            subject = ref1[i];
            subjectById[subject.id] = subject;
            subject.questions = [];
            subject.topics = [];
          }
          ref2 = content.templates;
          for (j = 0, len1 = ref2.length; j < len1; j++) {
            template = ref2[j];
            templateById[template.id] = template;
          }
          ref3 = content.topics;
          for (k = 0, len2 = ref3.length; k < len2; k++) {
            topic = ref3[k];
            topicById[topic.id] = topic;
            topic.subject = subjectById[topic.subjectId];
            topic.questions = [];
            topic.subject.topics.push(topic);
          }
          ref4 = content.activities;
          for (l = 0, len3 = ref4.length; l < len3; l++) {
            activity = ref4[l];
            activity.topic = topicById[activity.topicId];
            activity.template = templateById[activity.templateId];
          }
          ref5 = content.questions;
          for (m = 0, len4 = ref5.length; m < len4; m++) {
            question = ref5[m];
            questionById[question.id] = question;
            question.topic = topicById[question.topicId];
            question.topic.questions.push(question);
            question.topic.subject.questions.push(question);
          }
          CacheService.addItem(key, content, 60 * 20);
          return deferred.resolve(content);
        }, function(error) {
          return deferred.reject(error);
        });
      }
      return deferred.promise;
    };
    service.getUsers = function(tenant) {
      var deferred;
      deferred = $q.defer();
      cogniss.logEventRequest("TENANT_LIST_PLAYER_DETAILS", {
        tenant: tenant.code
      }).then(function(response) {
        return deferred.resolve(response.scriptData.details);
      }, deferred.reject);
      return deferred.promise;
    };
    service.saveTenant = function(tenant) {
      var deferred, event;
      deferred = $q.defer();
      event = "TENANT_CREATE_TENANT";
      if (tenant.id != null) {
        event = "TENANT_UPDATE_TENANT";
      }
      cogniss.logEventRequest(event, {
        tenant: tenant
      }).then(function(response) {
        return deferred.resolve(response.scriptData.tenant);
      }, deferred.reject);
      return deferred.promise;
    };
    service.deleteTenant = function(tenant) {
      var deferred, event;
      deferred = $q.defer();
      if (tenant.id != null) {
        event = "TENANT_DELETE_TENANT";
      }
      cogniss.logEventRequest(event, {
        code: tenant.code
      }).then(function(response) {
        return deferred.resolve(response);
      }, deferred.reject);
      return deferred.promise;
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').filter('templateName', function($q, ContentService, CacheService) {
    'ngInject';
    var filter;
    filter = function(id) {
      var cached, deferred, promise;
      cached = CacheService.getItem(id);
      if (cached) {
        if (typeof cached === "string") {
          return cached;
        } else {
          return void 0;
        }
      } else {
        deferred = $q.defer();
        ContentService.getTemplate(id).then(function(template) {
          var displayName;
          displayName = template.name;
          CacheService.addItem(id, displayName);
          return deferred.resolve(displayName);
        }, deferred.reject);
        promise = deferred.promise;
        promise.success = function(displayName) {};
        return CacheService.addItem(id, promise);
      }
    };
    filter.$stateful = true;
    return filter;
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgTeamThumb', function(TenantService, TeamService, ProgressService, $state) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/teamthumb/teamthumb.html',
      scope: {
        team: "=",
        tenant: "="
      },
      link: function($scope) {
        var pending, update;
        pending = false;
        $scope.$watch("team", function(val) {
          if ($scope.team != null) {
            return update();
          }
        });
        $scope.$watch("tenant", function(val) {
          if (val != null) {
            pending = false;
          }
          if (($scope.team != null) && $scope.tenant) {
            return update();
          }
        });
        return update = function() {
          var i, len, member, ref, userIds;
          if (pending) {
            return;
          }
          pending = true;
          if ($scope.tenant != null) {
            userIds = [];
            ref = $scope.team.members;
            for (i = 0, len = ref.length; i < len; i++) {
              member = ref[i];
              userIds.push(member.id);
            }
            return ProgressService.getQuestionAggregate(userIds, $scope.tenant).then(function(response) {
              return $scope.questionAggregate = response;
            });
          }
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').service('TeamService', function(cogniss, $q) {
    'ngInject';
    var service;
    service = {};
    service.teams = null;
    service.getTeams = function() {
      var deferred;
      deferred = $q.defer();
      cogniss.logEventRequest("TEAMS_LIST_TEAMS").then(function(response) {
        service.teams = response.scriptData.teams;
        return deferred.resolve(response.scriptData.teams);
      }, deferred.reject);
      return deferred.promise;
    };
    service.getTeam = function(id) {
      var deferred, findTeam;
      deferred = $q.defer();
      findTeam = function() {
        var i, len, ref, team;
        ref = service.teams;
        for (i = 0, len = ref.length; i < len; i++) {
          team = ref[i];
          if (team.id === id) {
            deferred.resolve(team);
            return;
          }
        }
      };
      service.getTeams().then(function(teams) {
        return findTeam();
      }, deferred.reject);
      return deferred.promise;
    };
    service.addTeam = function(team) {
      var deferred;
      deferred = $q.defer();
      cogniss.logEventRequest("TEAMS_CREATE_TEAM", {
        team: team
      }).then(function(response) {
        console.log("response", response);
        service.teams.push(response.scriptData.team);
        return deferred.resolve(response.scriptData.team);
      }, deferred.reject);
      return deferred.promise;
    };
    service.addCode = function(team, code) {
      var deferred;
      console.log("addCode", team, code);
      deferred = $q.defer();
      cogniss.logEventRequest("TEAMS_ADD_CODE", {
        code: code,
        team: team.id
      }).then(function(response) {
        return deferred.resolve(code);
      }, deferred.reject);
      return deferred.promise;
    };
    service.joinTeam = function(code) {
      var deferred;
      deferred = $q.defer();
      cogniss.logEventRequest("TEAMS_JOIN_TEAM", {
        code: code
      }).then(function(response) {
        service.teams.push(response.scriptData.team);
        return deferred.resolve(response.scriptData.team);
      }, deferred.reject);
      return deferred.promise;
    };
    service.leaveTeam = function(team) {
      var deferred;
      console.log("leave team", team);
      deferred = $q.defer();
      cogniss.logEventRequest("TEAMS_LEAVE_TEAM", {
        id: team.id
      }).then(function(response) {
        service.teams = _.without(service.teams, team);
        return deferred.resolve();
      }, deferred.reject);
      return deferred.promise;
    };
    service.disbandTeam = function(team) {
      var deferred;
      deferred = $q.defer();
      cogniss.logEventRequest("TEAMS_DELETE_TEAM", {
        id: team.id
      }).then(function(response) {
        console.log("response", response);
        service.teams = _.without(service.teams, team);
        return deferred.resolve();
      }, deferred.reject);
      return deferred.promise;
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgTeamProfilePanel', function(cogniss, UserService, modalService, $state, $uibModal, TeamService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/teamprofilepanel/teamprofilepanel.html',
      scope: {
        tenant: "=",
        team: "="
      },
      link: function($scope) {
        $scope.$watch(function() {
          return cogniss.user;
        }, function(val) {
          return $scope.user = val;
        });
        $scope.disbandTeam = function() {
          return TeamService.disbandTeam(team).then(function() {
            return $state.go("teams.overview");
          });
        };
        $scope.leaveTeam = function() {
          return TeamService.leaveTeam(team).then(function() {
            return $state.go("teams.overview");
          });
        };
        return $scope.addCode = function() {
          var modal, modalScope;
          modalScope = $scope.$new();
          modalScope.code = "";
          modalScope.submitCode = function(code) {
            console.log("submit code", modalScope);
            return TeamService.addCode($scope.team, code).then(function(code) {
              return modal.close();
            }, function(error) {
              console.log("error", error);
              if ((error.data != null) && error.data.code === "409") {
                return modalService.showModal("Error", "This team code is in use. Please choose another.");
              }
            });
          };
          return modal = $uibModal.open({
            templateUrl: "app/screens/teams/team/add-code-modal.html",
            scope: modalScope
          });
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').filter('teamName', function($q, TeamService, CacheService) {
    'ngInject';
    var filter;
    filter = function(teamId) {
      var cached, deferred, promise;
      cached = CacheService.getItem(teamId);
      if (cached) {
        return cached;
      } else {
        deferred = $q.defer();
        TeamService.getTeam(teamId).then(function(team) {
          var name;
          name = team.name;
          if ((name == null) || name.length === 0) {
            name = teamId;
          }
          CacheService.addItem(teamId, name);
          return deferred.resolve(name);
        }, deferred.reject);
        promise = deferred.promise;
        promise.success = function(name) {};
        return CacheService.addItem(teamId, promise);
      }
    };
    filter.$stateful = true;
    return filter;
  });

}).call(this);



(function() {
  angular.module('cogniss').filter('subjectName', function($q, ContentService, CacheService) {
    'ngInject';
    var filter;
    filter = function(subjectId) {
      var cached, deferred, promise;
      if (subjectId == null) {
        return "";
      }
      cached = CacheService.getItem(subjectId);
      if (cached) {
        if (typeof cached === "string") {
          return cached;
        } else {
          return void 0;
        }
      } else {
        deferred = $q.defer();
        ContentService.getSubject(subjectId).then(function(subject) {
          var name;
          name = subject.name;
          CacheService.addItem(subjectId, name);
          return deferred.resolve(name);
        }, deferred.reject);
        promise = deferred.promise;
        promise.success = function(name) {};
        return CacheService.addItem(subjectId, promise);
      }
    };
    filter.$stateful = true;
    return filter;
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgSplash', function() {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/splash/splash.html',
      scope: {},
      link: function($scope) {}
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgSidebar', function(TenantService, $state, cogniss, UserService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/sidebar/sidebar.html',
      scope: {},
      link: function($scope) {
        $scope.$watch(function() {
          return cogniss.user;
        }, function(user) {
          $scope.user = user;
          if (user != null) {
            TenantService.getTenants().then(function(tenants) {
              return $scope.tenants = tenants;
            });
            return UserService.getUserDetails(user.userId).then(function(details) {
              return $scope.userDetails = details;
            });
          }
        });
        return $scope.selectTenant = function(tenant) {
          return $state.go("tenant.users", {
            tenantRef: tenant.urlName
          });
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgQuestionInput', function(QuestionTypes, ContentService, TopicTypes, TenantService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/questioninput/questioninput.html',
      scope: {
        topic: "=",
        question: "="
      },
      link: function($scope) {
        $scope.QuestionTypes = QuestionTypes;
        $scope.TopicTypes = TopicTypes;
        return $scope.$watch("topic", function(topic) {
          if (topic == null) {
            return;
          }
          $scope.noQuestionType = topic.questionType == null;
          return TenantService.getTenantByCode(topic.tenant).then(function(tenant) {
            return ContentService.getTopics(tenant).then(function(topics) {
              return $scope.topics = topics;
            });
          });
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').service('ProgressService', function(cogniss, $q, CacheService) {
    'ngInject';
    var service;
    service = {};
    service.getUserActivityResponses = function(userIds, tenant, subject, topic, start, end, skip, limit) {
      var deferred, params;
      deferred = $q.defer();
      params = {
        tenant: tenant.code,
        players: userIds
      };
      if (subject != null) {
        params.subject = subject.id;
      }
      if (topic != null) {
        params.topic = topic.id;
      }
      if (start != null) {
        params.dateMin = start.getTime();
      }
      if (end != null) {
        params.dateMax = end.getTime();
      }
      if (skip != null) {
        params.skip = skip;
      }
      if (limit != null) {
        params.limit = limit;
      }
      cogniss.logEventRequest("PROGRESS_LIST_ACTIVITY_RESPONSES", params).then(function(response) {
        return deferred.resolve(response.scriptData);
      }, deferred.reject);
      return deferred.promise;
    };
    service.saveActivityResponse = function(response) {
      var deferred, event;
      deferred = $q.defer();
      event = "PROGRESS_SAVE_ACTIVITY_RESPONSE";
      if (response.id) {
        event = "PROGRESS_UPDATE_ACTIVITY_RESPONSE";
      }
      cogniss.logEventRequest(event, {
        response: response
      }).then(function(response) {
        return deferred.resolve(response.scriptData.response);
      }, deferred.reject);
      return deferred.promise;
    };
    service.saveQuestionResponse = function(response) {
      var deferred, event;
      deferred = $q.defer();
      event = "PROGRESS_SAVE_QUESTION_RESPONSE";
      cogniss.logEventRequest(event, {
        response: response
      }).then(function(response) {
        return deferred.resolve(response.scriptData.response);
      }, deferred.reject);
      return deferred.promise;
    };
    service.getActivityResponse = function(responseId) {
      var deferred, event, key;
      deferred = $q.defer();
      key = "activityResponse_" + responseId;
      if (CacheService.getItem(key) != null) {
        deferred.resolve(CacheService.getItem(key));
      } else {
        event = "PROGRESS_GET_ACTIVITY_RESPONSE";
        cogniss.logEventRequest(event, {
          id: responseId
        }).then(function(response) {
          return deferred.resolve(response.scriptData.response);
        }, deferred.reject);
      }
      return deferred.promise;
    };
    service.listQuestionResponses = function(questionId, activityResponseId) {
      var deferred, event, key, params;
      deferred = $q.defer();
      key = "questionResponses_" + questionId + "_" + activityResponseId;
      if (CacheService.getItem(key) != null) {
        deferred.resolve(CacheService.getItem(key));
      } else {
        event = "PROGRESS_LIST_QUESTION_RESPONSES";
        params = {
          question: "",
          activityResponse: "",
          topicResponse: "",
          player: "",
          tenant: ""
        };
        if (questionId != null) {
          params.question = questionId;
        }
        if (activityResponseId != null) {
          params.activityResponse = activityResponseId;
        }
        cogniss.logEventRequest(event, params).then(function(response) {
          return deferred.resolve(response.scriptData.responses);
        }, deferred.reject);
      }
      return deferred.promise;
    };
    service.getQuestionAggregate = function(userIds, tenant, subjectId, topicId) {
      var deferred, event, key, params, tenantCode;
      tenantCode = "null";
      if (tenant != null) {
        tenantCode = tenant.code;
      }
      deferred = $q.defer();
      key = "usersQuestionAggregate_" + (userIds.join()) + "_" + tenantCode + "_" + subjectId + "_" + topicId;
      if (CacheService.getItem(key) != null) {
        deferred.resolve(CacheService.getItem(key));
      } else {
        event = "PROGRESS_GET_QUESTION_AGGREGATE";
        params = {
          players: userIds,
          tenant: tenantCode
        };
        if (subjectId != null) {
          params.subject = subjectId;
        }
        if (topicId != null) {
          params.topic = topicId;
        }
        cogniss.logEventRequest(event, params).then(function(response) {
          return deferred.resolve(response.scriptData.data);
        }, deferred.reject);
      }
      return deferred.promise;
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgProfilePanel', function(cogniss, UserService, modalService, $state) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/profilepanel/profilepanel.html',
      scope: {
        tenant: "=",
        userId: "="
      },
      link: function($scope) {
        var pending, update;
        pending = false;
        $scope.$watch("userId", function(val) {
          if ($scope.userId != null) {
            return update();
          }
        });
        $scope.$watch("tenant", function(val) {
          if (val != null) {
            pending = false;
          }
          if (($scope.userId != null) && $scope.tenant) {
            return update();
          }
        });
        update = function() {
          if (pending) {
            return;
          }
          pending = true;
          return UserService.getUserDetails($scope.userId, $scope.tenant).then(function(details) {
            return $scope.userDetails = details;
          });
        };
        $scope.deleteUser = function() {
          var doDelete;
          doDelete = function() {
            return cogniss.removeInsightsUser($scope.tenant, $scope.userDetails.playerId).then(function() {
              return $state.go("tenant.users");
            }, function(error) {
              return modalService.showModal("Error", "Error removing user");
            });
          };
          return modalService.showModal("Confirm removing user", "Are you sure you want to remove this user from your insights dashboard?", true, true, "Cancel", doDelete, "Confirm");
        };
        return $scope.getIsCurrentUser = function() {
          return $scope.userId === cogniss.user.userId;
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgPagination', function() {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/pagination/pagination.html',
      scope: {
        index: "=",
        limit: "=",
        max: "=",
        pageLimit: "=?"
      },
      link: function($scope) {
        var update;
        update = function() {
          var displayPages, first, i, j, k, last, page, pages, ref, ref1, ref2, ref3;
          pages = [];
          for (i = j = 0, ref = $scope.max, ref1 = $scope.limit; ref1 > 0 ? j <= ref : j >= ref; i = j += ref1) {
            page = {
              index: pages.length,
              first: pages.length * $scope.limit,
              last: (pages.length * $scope.limit) + ($scope.limit - 1)
            };
            if (page.first < $scope.max) {
              page.current = (page.first <= $scope.index) && (page.last >= $scope.index);
              if (page.current) {
                $scope.current = page;
              }
              pages.push(page);
            }
          }
          $scope.pages = pages;
          $scope.lastPage = pages[pages.length - 1];
          if (pages.length <= $scope.pageLimit) {
            return $scope.displayPages = pages;
          } else {
            first = Math.round(($scope.index / $scope.limit) - ($scope.pageLimit / 2));
            if (first < 0) {
              first = 0;
            }
            if (first >= pages.length - $scope.pageLimit) {
              first = pages.length - $scope.pageLimit;
            } else {
              last = first + ($scope.pageLimit - 1);
            }
            displayPages = [];
            for (i = k = ref2 = first, ref3 = first + ($scope.pageLimit - 1); ref2 <= ref3 ? k <= ref3 : k >= ref3; i = ref2 <= ref3 ? ++k : --k) {
              displayPages.push(pages[i]);
            }
            return $scope.displayPages = displayPages;
          }
        };
        $scope.$watch("index", update);
        $scope.$watch("limit", update);
        $scope.$watch("max", update);
        $scope.$watch("pageLimit", update);
        $scope.first = function() {
          return $scope.goPage($scope.pages[0]);
        };
        $scope.previous = function() {
          return $scope.goPage($scope.pages[$scope.current.index - 1]);
        };
        $scope.next = function() {
          return $scope.goPage($scope.pages[$scope.current.index + 1]);
        };
        $scope.last = function() {
          return $scope.goPage($scope.pages[$scope.pages.length - 1]);
        };
        $scope.goPage = function(page) {
          if (page == null) {
            return;
          }
          return $scope.index = page.first;
        };
        return $scope.pageLimit = 5;
      }
    };
  });

}).call(this);



(function() {
  angular.module("cogniss").service('OptionsService', function() {
    'ngInject';
    var service;
    service = {};
    service.showSidebar = function() {
      return $scope.$root.showSidebar = !$scope.$root.showSidebar;
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').service('NotesService', function(cogniss, $q) {
    'ngInject';
    var service;
    return service = {
      getNotes: function(playerIds, tenant, start, end, skip, limit) {
        var deferred, params;
        console.log('getNotes', playerIds, tenant, start, end, skip, limit);
        deferred = $q.defer();
        params = {
          tenant: tenant.code,
          players: playerIds
        };
        if (start != null) {
          params.dateMin = start.getTime();
        }
        if (end != null) {
          params.dateMax = end.getTime();
        }
        if (skip != null) {
          params.skip = skip;
        }
        if (limit != null) {
          params.limit = limit;
        }
        cogniss.logEventRequest("NOTES_LIST_NOTES", params).then(function(response) {
          console.log("gamesparks notes response", response);
          return deferred.resolve(response.scriptData);
        }, deferred.reject);
        return deferred.promise;
      },
      addNote: function(note) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("NOTES_CREATE_NOTE", {
          note: note
        }).then(function(response) {
          console.log("gamesparks notes response", response);
          return deferred.resolve(response.scriptData.note);
        }, deferred.reject);
        return deferred.promise;
      },
      updateNote: function(note) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("NOTES_UPDATE_NOTE", {
          note: note
        }).then(function(response) {
          console.log("gamesparks notes response", response);
          return deferred.resolve(response.scriptData.note);
        }, deferred.reject);
        return deferred.promise;
      },
      addComment: function(note, text) {
        var comment, deferred;
        deferred = $q.defer();
        comment = {
          playerId: cogniss.user.userId,
          text: text
        };
        cogniss.logEventRequest("NOTES_ADD_COMMENT", {
          comment: comment,
          id: note.id
        }).then(function(response) {
          console.log("gamesparks comment response", response);
          return deferred.resolve(response.scriptData.comment);
        }, deferred.reject);
        return deferred.promise;
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgNotes', function(TenantService, $state, NotesService, $uibModal, NoteTypes, cogniss) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/notes/notes.html',
      scope: {
        tenant: "=",
        playerId: "=",
        playerIds: "=?"
      },
      link: function($scope) {
        var pending, update;
        console.log('notes');
        pending = false;
        $scope.limit = 10;
        $scope.skip = 0;
        $scope.max = 0;
        $scope.noteTypes = NoteTypes;
        $scope.startDateOptions = {
          showWeeks: false
        };
        $scope.endDateOptions = {
          showWeeks: false
        };
        update = function() {
          var end, start;
          if ($scope.tenant == null) {
            return;
          }
          if ($scope.playerIds == null) {
            return;
          }
          if (pending) {
            return;
          }
          start = $scope.start;
          end = $scope.end;
          if (end != null) {
            end = moment(end);
            end.add(23, 'h');
            end.add(59, 'm');
            end.add(59, 's');
            end = end.toDate();
          }
          pending = true;
          $scope.showAddNoteButton = $scope.playerIds.length === 1;
          if ($scope.playerIds.length === 1) {
            $scope.showAddNoteButton = cogniss.user.userId !== $scope.playerIds[0];
          }
          return NotesService.getNotes($scope.playerIds, $scope.tenant, start, end, $scope.skip, $scope.limit).then(function(data) {
            $scope.max = data.count;
            $scope.notes = data.notes;
            return pending = false;
          });
        };
        $scope.$watch("playerId", function(val) {
          if (val != null) {
            return $scope.playerIds = [val];
          }
        });
        $scope.$watch("playerIds", function(val) {
          if (val != null) {
            return update();
          }
        });
        $scope.$watch("start", update);
        $scope.$watch("end", update);
        $scope.$watch("skip", update);
        $scope.addNote = function() {
          var modal, modalScope, note;
          note = {
            playerId: $scope.playerId,
            tenant: $scope.tenant.code,
            text: "",
            type: NoteTypes.NOTE
          };
          modalScope = $scope.$new();
          modalScope.noteTypes = NoteTypes;
          modalScope.note = note;
          modalScope.saveNote = function(note) {
            return NotesService.addNote(note).then(function(note) {
              update();
              return modal.close();
            });
          };
          return modal = $uibModal.open({
            templateUrl: "app/components/notes/addnote.modal.html",
            scope: modalScope
          });
        };
        return $scope.selectNote = function(note) {
          var modal, modalScope;
          modalScope = $scope.$new();
          modalScope.noteTypes = NoteTypes;
          modalScope.note = note;
          modalScope.commentText = "";
          modalScope.saveComment = function(text) {
            modalScope.commentText = "";
            return NotesService.addComment(note, text).then(function(comment) {
              return modalScope.note.comments.push(comment);
            });
          };
          modalScope.saveNote = function(note) {
            return NotesService.updateNote(note).then(function(note) {
              update();
              return modal.close();
            });
          };
          return modal = $uibModal.open({
            templateUrl: "app/components/notes/note.modal.html",
            scope: modalScope
          });
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').service('modalService', function($rootScope, $uibModal) {
    'ngInject';
    var service;
    service = {
      showModal: function(title, body, close, footer, dismissLabel, onAccept, acceptLabel) {
        var backdrop, modal, modalScope;
        modal = null;
        if (close == null) {
          close = true;
        }
        if (footer == null) {
          footer = false;
        }
        if (dismissLabel == null) {
          dismissLabel = "Ok";
        }
        modalScope = $rootScope.$new();
        modalScope.title = title;
        modalScope.body = body;
        modalScope.close = close;
        modalScope.footer = footer;
        if (onAccept != null) {
          modalScope.accept = function() {
            onAccept();
            return modal.close();
          };
        }
        modalScope.dismissLabel = dismissLabel;
        modalScope.acceptLabel = acceptLabel;
        backdrop = true;
        if (!close) {
          backdrop = "static";
        }
        return modal = $uibModal.open({
          templateUrl: "app/components/modal/modal.html",
          scope: modalScope,
          backdrop: backdrop
        });
      }
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').service('LeaderboardService', function(cogniss, $q) {
    'ngInject';
    var service;
    return service = {
      getLeaderboards: function(tenant) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("LEADERBOARD_LIST", {
          tenant: tenant.code
        }).then(function(response) {
          return deferred.resolve(response.scriptData.leaderboards);
        }, deferred.reject);
        return deferred.promise;
      },
      getLeaderboard: function(id) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("LEADERBOARD_GET", {
          id: id
        }).then(function(response) {
          return deferred.resolve(response.scriptData.leaderboard);
        }, deferred.reject);
        return deferred.promise;
      },
      saveLeaderboard: function(leaderboard) {
        var deferred, event;
        deferred = $q.defer();
        event = "LEADERBOARD_CREATE";
        if (leaderboard.id != null) {
          event = "LEADERBOARD_UPDATE";
        }
        cogniss.logEventRequest(event, {
          leaderboard: leaderboard
        }).then(function(response) {
          return deferred.resolve(response.scriptData.leaderboard);
        }, deferred.reject);
        return deferred.promise;
      },
      deleteLeaderboard: function(leaderboard) {
        var deferred, event;
        deferred = $q.defer();
        if (leaderboard.id != null) {
          event = "LEADERBOARD_DELETE";
        }
        cogniss.logEventRequest(event, {
          id: leaderboard.id
        }).then(function(response) {
          return deferred.resolve(response);
        }, deferred.reject);
        return deferred.promise;
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgHeader', function(cogniss, $state, Auth, $translate, OptionsService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/header/header.html',
      scope: {},
      link: function($scope) {
        $scope.toggleSidebar = function() {
          return OptionsService.showSidebar = !OptionsService.showSidebar;
        };
        $scope.logout = function() {
          return Auth.logout();
        };
        $scope.$watch(function() {
          return cogniss.user;
        }, function(val) {
          return $scope.user = val;
        });
        $scope.home = function() {
          if ($scope.user != null) {
            return $state.go("tenant.users");
          } else {
            return $state.go("login");
          }
        };
        $scope.lang = 'English';
        $scope.setLang = function(lang) {
          switch (lang) {
            case 'English':
              $translate.use('en');
              break;
            case 'Deutsch':
              $translate.use('de');
              break;
            case 'Español':
              $translate.use('es');
              break;
            case '中文':
              $translate.use('zh');
              break;
            case '日本語':
              $translate.use('ja');
              break;
            case 'Portugal':
              $translate.use('pt');
              break;
            case 'Русский язык':
              $translate.use('ru');
          }
          return $scope.lang = lang;
        };
        $scope.getFlag = function() {
          var lang;
          lang = $scope.lang;
          switch (lang) {
            case 'English':
              return 'flags-american';
            case 'Deutsch':
              return 'flags-germany';
            case 'Español':
              return 'flags-spain';
            case '中文':
              return 'flags-china';
            case 'Portugal':
              return 'flags-portugal';
            case '日本語':
              return 'flags-japan';
            case 'Русский язык':
              return 'flags-russia';
          }
        };
        return $scope.$watch(function() {
          return cogniss.pendingCount;
        }, function(val) {
          return $scope.pendingCount = val;
        });
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgFooter', function(cogniss, $state, Auth, $translate, OptionsService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/footer/footer.html',
      scope: {},
      link: function($scope) {}
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').factory('FacebookService', function(cogniss, ezfb, $q) {
    'ngInject';
    var service;
    service = {
      login: function() {
        var deferred;
        deferred = $q.defer();
        ezfb.login(function(response) {
          if (response.authResponse) {
            return cogniss.fbLogin(response.authResponse.accessToken).then(function() {
              return deferred.resolve();
            }, function() {
              return deferred.reject();
            });
          } else {

          }
        }, {
          scope: 'email'
        });
        return deferred.promise;
      }
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').filter('displayName', function($q, cogniss, CacheService) {
    'ngInject';
    var filter;
    filter = function(userId) {
      var cached, deferred, promise;
      cached = CacheService.getItem(userId);
      if (cached) {
        return cached;
      } else {
        deferred = $q.defer();
        cogniss.getUserDetails(userId).then(function(details) {
          var displayName;
          displayName = details.displayName;
          if ((displayName == null) || displayName.length === 0) {
            displayName = userId;
          }
          CacheService.addItem(userId, displayName);
          return deferred.resolve(displayName);
        }, deferred.reject);
        promise = deferred.promise;
        promise.success = function(displayName) {};
        return CacheService.addItem(userId, promise);
      }
    };
    filter.$stateful = true;
    return filter;
  });

}).call(this);



(function() {
  angular.module('cogniss').service('ContentService', function(cogniss, $q) {
    'ngInject';
    var service;
    return service = {
      getTemplates: function() {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_LIST_TEMPLATES", {}).then(function(response) {
          return deferred.resolve(response.scriptData.templates);
        }, deferred.reject);
        return deferred.promise;
      },
      getTemplate: function(id) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_GET_TEMPLATE", {
          id: id
        }).then(function(response) {
          return deferred.resolve(response.scriptData.template);
        }, deferred.reject);
        return deferred.promise;
      },
      saveTemplate: function(template) {
        var deferred, event;
        deferred = $q.defer();
        event = "CONTENT_CREATE_TEMPLATE";
        if (template.id != null) {
          event = "CONTENT_UPDATE_TEMPLATE";
        }
        cogniss.logEventRequest(event, {
          template: template
        }).then(function(response) {
          return deferred.resolve(response.scriptData.template);
        }, deferred.reject);
        return deferred.promise;
      },
      deleteTemplate: function(template) {
        var deferred, event;
        deferred = $q.defer();
        if (template.id != null) {
          event = "CONTENT_DELETE_TEMPLATE";
        }
        cogniss.logEventRequest(event, {
          id: template.id
        }).then(function(response) {
          return deferred.resolve(response);
        }, deferred.reject);
        return deferred.promise;
      },
      getSubjects: function(tenant) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_LIST_SUBJECTS", {
          tenant: tenant.code
        }).then(function(response) {
          return deferred.resolve(response.scriptData.subjects);
        }, deferred.reject);
        return deferred.promise;
      },
      getSubject: function(id) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_GET_SUBJECT", {
          id: id
        }).then(function(response) {
          return deferred.resolve(response.scriptData.subject);
        }, deferred.reject);
        return deferred.promise;
      },
      saveSubject: function(subject) {
        var deferred;
        deferred = $q.defer();
        if (subject.id == null) {
          cogniss.logEventRequest("CONTENT_CREATE_SUBJECT", {
            subject: subject
          }).then(function(response) {
            return deferred.resolve(response.scriptData.subject);
          }, deferred.reject);
        } else {
          cogniss.logEventRequest("CONTENT_UPDATE_SUBJECT", {
            subject: subject
          }).then(function(response) {
            return deferred.resolve(response.scriptData.subject);
          }, deferred.reject);
        }
        return deferred.promise;
      },
      deleteSubject: function(subject) {
        var deferred, event;
        deferred = $q.defer();
        if (subject.id != null) {
          event = "CONTENT_DELETE_SUBJECT";
        }
        cogniss.logEventRequest(event, {
          id: subject.id
        }).then(function(response) {
          return deferred.resolve(response);
        }, deferred.reject);
        return deferred.promise;
      },
      getTopics: function(tenant, subjectId) {
        var deferred;
        if (subjectId == null) {
          subjectId = "";
        }
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_LIST_TOPICS", {
          tenant: tenant.code,
          subject: subjectId
        }).then(function(response) {
          return deferred.resolve(response.scriptData.topics);
        }, deferred.reject);
        return deferred.promise;
      },
      getTopic: function(id) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_GET_TOPIC", {
          id: id
        }).then(function(response) {
          return deferred.resolve(response.scriptData.topic);
        }, deferred.reject);
        return deferred.promise;
      },
      saveTopic: function(topic) {
        var deferred, event;
        deferred = $q.defer();
        event = "CONTENT_CREATE_TOPIC";
        if (topic.id != null) {
          event = "CONTENT_UPDATE_TOPIC";
        }
        cogniss.logEventRequest(event, {
          topic: topic
        }).then(function(response) {
          return deferred.resolve(response.scriptData.topic);
        }, deferred.reject);
        return deferred.promise;
      },
      deleteTopic: function(topic) {
        var deferred, event;
        deferred = $q.defer();
        if (topic.id != null) {
          event = "CONTENT_DELETE_TOPIC";
        }
        cogniss.logEventRequest(event, {
          id: topic.id
        }).then(function(response) {
          return deferred.resolve(response);
        }, deferred.reject);
        return deferred.promise;
      },
      getQuestions: function(tenant, topicId) {
        var deferred;
        if (topicId == null) {
          topicId = "";
        }
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_LIST_QUESTIONS", {
          tenant: tenant.code,
          topic: topicId
        }).then(function(response) {
          return deferred.resolve(response.scriptData.questions);
        }, deferred.reject);
        return deferred.promise;
      },
      getQuestion: function(id) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_GET_QUESTION", {
          id: id
        }).then(function(response) {
          return deferred.resolve(response.scriptData.question);
        }, deferred.reject);
        return deferred.promise;
      },
      saveQuestion: function(question) {
        var deferred, event;
        deferred = $q.defer();
        event = "CONTENT_CREATE_QUESTION";
        if (question.id != null) {
          event = "CONTENT_UPDATE_QUESTION";
        }
        cogniss.logEventRequest(event, {
          question: question
        }).then(function(response) {
          return deferred.resolve(response.scriptData.question);
        }, deferred.reject);
        return deferred.promise;
      },
      deleteQuestion: function(question) {
        var deferred, event;
        deferred = $q.defer();
        if (question.id != null) {
          event = "CONTENT_DELETE_QUESTION";
        }
        cogniss.logEventRequest(event, {
          id: question.id
        }).then(function(response) {
          return deferred.resolve(response);
        }, deferred.reject);
        return deferred.promise;
      },
      getActivities: function(tenant, template, topic, subject) {
        var deferred, query;
        query = {};
        if (tenant != null) {
          query.tenant = tenant.code;
        }
        if (topic != null) {
          query.topic = topic.id;
        }
        if (template != null) {
          query.template = template.id;
        }
        if (template != null) {
          query.subject = subject.id;
        }
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_LIST_ACTIVITIES", query).then(function(response) {
          return deferred.resolve(response.scriptData.activities);
        }, deferred.reject);
        return deferred.promise;
      },
      getActivity: function(id) {
        var deferred;
        deferred = $q.defer();
        cogniss.logEventRequest("CONTENT_GET_ACTIVITY", {
          id: id
        }).then(function(response) {
          return deferred.resolve(response.scriptData.activity);
        }, deferred.reject);
        return deferred.promise;
      },
      saveActivity: function(activity) {
        var deferred, event;
        deferred = $q.defer();
        event = "CONTENT_CREATE_ACTIVITY";
        if (activity.id != null) {
          event = "CONTENT_UPDATE_ACTIVITY";
        }
        cogniss.logEventRequest(event, {
          activity: activity
        }).then(function(response) {
          return deferred.resolve(response.scriptData.activity);
        }, deferred.reject);
        return deferred.promise;
      },
      deleteActivity: function(activity) {
        var deferred, event;
        deferred = $q.defer();
        if (activity.id != null) {
          event = "CONTENT_DELETE_ACTIVITY";
        }
        cogniss.logEventRequest(event, {
          id: activity.id
        }).then(function(response) {
          return deferred.resolve(response);
        }, deferred.reject);
        return deferred.promise;
      },
      importContent: function(tenant, content) {
        var deferred, event;
        deferred = $q.defer();
        event = "CONTENT_IMPORT";
        cogniss.logEventRequest(event, {
          tenant: tenant.code,
          content: content
        }).then(function(response) {
          return deferred.resolve(response);
        }, deferred.reject);
        return deferred.promise;
      },
      exportContent: function(tenant) {
        var deferred, event;
        deferred = $q.defer();
        event = "CONTENT_EXPORT";
        cogniss.logEventRequest(event, {
          tenant: tenant.code
        }).then(function(response) {
          return deferred.resolve(response.scriptData.content);
        }, deferred.reject);
        return deferred.promise;
      },
      orderItem: function(item, list, saveCallback) {
        var index, next, oldOrder, pre;
        index = list.indexOf(item);
        oldOrder = item.order;
        pre = false;
        next = false;
        if (index > 0) {
          pre = list[index - 1];
        }
        if (index < list.length - 1) {
          next = list[index + 1];
        }
        if (pre && next) {
          item.order = pre.order + (next.order - pre.order) / 2;
        } else if (pre) {
          item.order = pre.order + 10000;
        } else if (next) {
          item.order = next.order - 10000;
        }
        if (oldOrder !== item.order) {
          return typeof saveCallback === "function" ? saveCallback(item) : void 0;
        }
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').service('cogniss', function(gamesparksPreview, gamesparksKey, gamesparksSecret, $rootScope, bowser, $localStorage, $window, $uibModal, tenantShortcode, $timeout, $q) {
    'ngInject';
    var messageDeferred, service;
    messageDeferred = $q.defer();
    service = {
      connected: false,
      pendingCount: 0,
      onMessage: messageDeferred.promise
    };
    service.init = function() {
      var authToken, deferred, gamesparks, onInit, onMessage, onNonce, sessionId;
      deferred = $q.defer();
      gamesparks = new GameSparks();
      service.gs = gamesparks;
      service.pendingCount++;
      window.gamesparks = gamesparks;
      $rootScope.$watch(function() {
        return service.user;
      }, function(val) {
        if (val != null) {
          return service.getUserDetails(service.user.userId).then(function(details) {
            return service.user.details = details;
          }, function(err) {});
        }
      });
      authToken = $localStorage.gsAuthToken;
      sessionId = $localStorage.gsSessionId;
      onNonce = function(nonce) {
        return CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(nonce, gamesparksSecret));
      };
      onInit = function() {
        return service.gs.accountDetailsRequest(function(response) {
          var err;
          err = response.error;
          service.connected = true;
          service.pendingCount--;
          if (err != null) {
            deferred.reject(err);
          } else {
            service._storeTokens();
            service.user = response;
          }
          return $rootScope.$apply();
        });
      };
      onMessage = function(message) {
        console.log("gamesparks on message", message);
        return $rootScope.$apply(function() {
          return messageDeferred.notify(message);
        });
      };
      if (gamesparksPreview) {
        service.gs.initPreview({
          authToken: authToken,
          sessionId: sessionId,
          key: gamesparksKey,
          onNonce: onNonce,
          onInit: onInit,
          onMessage: onMessage
        });
      } else {
        service.gs.initLive({
          authToken: authToken,
          sessionId: sessionId,
          key: gamesparksKey,
          onNonce: onNonce,
          onInit: onInit,
          onMessage: onMessage
        });
      }
      return deferred.promise;
    };
    service.deviceAuthenticationRequest = function() {
      var deferred, deviceId, deviceModel, deviceName, deviceOS, deviceType, operatingSystem;
      deferred = $q.defer();
      service.pendingCount++;
      deviceId = $localStorage.deviceId;
      if (deviceId == null) {
        deviceId = random.alphaNum(32);
      }
      $localStorage.deviceId = deviceId;
      deviceModel = bowser.version;
      deviceName = bowser.name;
      deviceOS = $window.navigator.platform;
      deviceType = "browser";
      operatingSystem = $window.navigator.platform;
      service.gs.deviceAuthenticationRequest(deviceId, deviceModel, deviceName, deviceOS, deviceType, operatingSystem, function(response) {
        var err;
        err = response.error;
        service.pendingCount--;
        if (err != null) {
          deferred.reject(err);
        } else {
          deferred.resolve(response);
        }
        return $rootScope.$apply();
      });
      return deferred.promise;
    };
    service.register = function(user, cb) {
      var deferred, request;
      deferred = $q.defer();
      service.pendingCount++;
      request = {
        password: user.password,
        userName: user.userName,
        displayName: user.userName,
        scriptData: {
          playerDetails: {
            email: user.email
          }
        }
      };
      service.gs.sendWithData("RegistrationRequest", request, function(response) {
        var err;
        err = response.error;
        service.pendingCount--;
        if (err != null) {
          deferred.reject(err);
        } else {
          service._storeTokens();
          service.user = response;
          deferred.resolve(response);
        }
        return $rootScope.$apply();
      });
      return deferred.promise;
    };
    service.login = function(user, cb) {
      var deferred, request;
      deferred = $q.defer();
      service.pendingCount++;
      request = {
        password: user.password,
        userName: user.userName
      };
      service.gs.sendWithData("AuthenticationRequest", request, function(response) {
        var err;
        err = response.error;
        service.pendingCount--;
        if (err != null) {
          deferred.reject(err);
        } else {
          service._storeTokens();
          service.user = response;
          deferred.resolve(response);
        }
        return $rootScope.$apply();
      });
      return deferred.promise;
    };
    service.fbLogin = function(token) {
      var deferred;
      deferred = $q.defer();
      service.pendingCount++;
      service.gs.facebookConnectRequest(token, null, function(response) {
        var err;
        err = response.error;
        service.pendingCount--;
        if (err != null) {
          deferred.reject(err);
        } else {
          service._storeTokens();
          service.user = response;
          deferred.resolve(response);
        }
        return $rootScope.$apply();
      });
      return deferred.promise;
    };
    service.logout = function() {
      var deferred;
      deferred = $q.defer();
      $localStorage.gsAuthToken = null;
      $localStorage.gsSessionId = null;
      service.user = null;
      deferred.resolve();
      return deferred.promise;
    };
    service.forgot = function(userNameOrEmail) {
      var deferred;
      deferred = $q.defer();
      service.deviceAuthenticationRequest().then(function() {
        var data;
        data = {
          userNameOrEmail: userNameOrEmail,
          tenant: tenantShortcode
        };
        return service.logEventRequest("ACCOUNT_FORGOT_PASSWORD", data).then(deferred.resolve, deferred.reject);
      });
      return deferred.promise;
    };
    service.reset = function(userId, token, password) {
      var deferred;
      deferred = $q.defer();
      service.deviceAuthenticationRequest().then(function() {
        var data;
        data = {
          token: token,
          player: userId,
          tenant: tenantShortcode,
          password: password
        };
        return service.logEventRequest("ACCOUNT_RESET_PASSWORD", data).then(deferred.resolve, deferred.reject);
      });
      return deferred.promise;
    };
    service.getUserDetails = function(userId, tenant) {
      var deferred, onAuth;
      deferred = $q.defer();
      onAuth = function() {
        var code;
        code = tenantShortcode;
        if (tenant != null) {
          code = tenant.code;
        }
        return service.logEventRequest("PROFILE_GET_PLAYER_DETAILS", {
          tenant: code,
          player: userId
        }).then(function(response) {
          return deferred.resolve(response.scriptData.response);
        }, deferred.reject);
      };
      if (service.user != null) {
        onAuth();
      } else {
        service.deviceAuthenticationRequest().then(onAuth);
      }
      return deferred.promise;
    };
    service.updateUserDetails = function(details) {
      var data, deferred;
      deferred = $q.defer();
      data = {
        details: details
      };
      service.logEventRequest("PROFILE_UPDATE_PLAYER_DETAILS", data).then(function(response) {
        return deferred.resolve(response.scriptData);
      }, deferred.reject);
      return deferred.promise;
    };
    service.getInsightsUsers = function(tenant) {
      var deferred;
      deferred = $q.defer();
      service.logEventRequest("INSIGHTS_GET_USERS", {
        tenant: tenant.code
      }).then(function(response) {
        return deferred.resolve(response.scriptData.users);
      }, deferred.reject);
      return deferred.promise;
    };
    service.addInsightsUser = function(tenant, code) {
      var deferred;
      deferred = $q.defer();
      service.logEventRequest("INSIGHTS_ADD_USER", {
        tenant: tenant.code,
        code: code
      }).then(function(response) {
        return deferred.resolve(response.scriptData.user);
      }, deferred.reject);
      return deferred.promise;
    };
    service.removeInsightsUser = function(tenant, userId) {
      var deferred;
      deferred = $q.defer();
      service.logEventRequest("INSIGHTS_REMOVE_USER", {
        tenant: tenant.code,
        player: userId
      }).then(function(response) {
        return deferred.resolve();
      }, deferred.reject);
      return deferred.promise;
    };
    service.getUploadUrl = function(data) {
      var deferred;
      if (!data) {
        data = {};
      }
      deferred = $q.defer();
      service.gs.getUploadUrlRequest(data, function(res) {
        if (res.error != null) {
          return deferred.reject();
        } else {
          return deferred.resolve(res.url);
        }
      });
      return deferred.promise;
    };
    service.getUploadedUrl = function(uploadId) {
      var deferred;
      deferred = $q.defer();
      service.gs.getUploadedRequest(uploadId, function(res) {
        if (res.error != null) {
          return deferred.reject();
        } else {
          return deferred.resolve(res.url);
        }
      });
      return deferred.promise;
    };
    service._storeTokens = function() {
      $localStorage.gsAuthToken = service.gs.getAuthToken();
      return $localStorage.gsSessionId = service.gs.getSessionId();
    };
    service.logEventRequest = function(key, data) {
      var deferred;
      deferred = $q.defer();
      if (data == null) {
        data = {};
      }
      data = JSON.parse(angular.toJson(data));
      data.eventKey = key;
      service.pendingCount++;
      service.gs.sendWithData("LogEventRequest", data, function(response) {
        return $timeout(function() {
          if (response.error != null) {
            service.pendingCount--;
            return deferred.reject(response.error);
          } else {
            service.pendingCount--;
            return deferred.resolve(response);
          }
        });
      });
      return deferred.promise;
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').factory('CacheService', function() {
    var service;
    service = {
      _cache: {},
      addItem: function(key, item, lifespan) {
        var expires;
        expires = false;
        if (lifespan != null) {
          expires = moment().add(lifespan, "seconds");
        }
        return service._cache[key] = {
          item: item,
          expires: expires
        };
      },
      removeItem: function(key) {
        return service._cache[key] = null;
      },
      getItem: function(key) {
        var cache, expired;
        cache = service._cache[key];
        if (cache == null) {
          return;
        }
        expired = false;
        if (cache.expires) {
          expired = moment().isAfter(cache.expires);
        }
        if (expired) {
          service.removeItem(key);
          return;
        }
        return cache.item;
      }
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').service('BehaviorService', function(cogniss, $q) {
    'ngInject';
    var service;
    return service = {
      getBehaviors: function(tenant, team, playerId, template) {
        var deferred, params;
        deferred = $q.defer();
        params = {};
        if (tenant != null) {
          params.tenant = tenant.code;
        }
        if (team != null) {
          params.teamId = team.id;
        }
        if (playerId != null) {
          params.player = playerId;
        }
        if (template != null) {
          params.template = template ? 1 : 0;
        }
        cogniss.logEventRequest("BEHAVIORS_LIST_BEHAVIORS", params).then(function(response) {
          return deferred.resolve(response.scriptData.behaviors);
        }, deferred.reject);
        return deferred.promise;
      },
      saveBehavior: function(behavior) {
        var deferred, event;
        deferred = $q.defer();
        event = "BEHAVIORS_CREATE_BEHAVIOR";
        if (behavior.id != null) {
          event = "BEHAVIORS_UPDATE_BEHAVIOR";
        }
        cogniss.logEventRequest(event, {
          behavior: behavior
        }).then(function(response) {
          return deferred.resolve(response.scriptData.behavior);
        }, deferred.reject);
        return deferred.promise;
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgBehaviorInput', function(TriggerTypes, CriteriaTypes, ResultTypes, BehaviorService, Auth) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/behaviorinput/behaviorinput.html',
      scope: {
        behavior: "=",
        tenant: "=",
        team: "=",
        playerId: "="
      },
      link: function($scope) {
        var update;
        $scope.$watch("tenant", function(tenant) {
          return update();
        });
        $scope.$watch("team", function(team) {
          return update();
        });
        $scope.$watch("playerId", function(playerId) {
          return update();
        });
        update = function() {
          return Auth.isAdmin().then(function(admin) {
            var doConfig, tenantAdmin;
            tenantAdmin = false;
            doConfig = function() {
              $scope.enabledTriggerTypes = [TriggerTypes.SCHEDULED, TriggerTypes.ACTIVITY_RESPONSE, TriggerTypes.COMPLETE_ACTIVITY, TriggerTypes.QUESTION_RESPONSE];
              $scope.enabledCriteriaTypes = [];
              $scope.enabledResultTypes = [ResultTypes.VIRTUAL_GOOD, ResultTypes.NOTIFICATION, ResultTypes.NEWS];
              if ($scope.tenant) {
                $scope.enabledTriggerTypes = $scope.enabledTriggerTypes.concat([]);
                $scope.enabledCriteriaTypes = $scope.enabledCriteriaTypes.concat([CriteriaTypes.ACTIVITY_RESPONSE, CriteriaTypes.QUESTION_RESPONSE]);
                $scope.enabledResultTypes = $scope.enabledResultTypes.concat([ResultTypes.NOTE]);
                if (tenantAdmin) {
                  return $scope.enabledResultTypes = $scope.enabledResultTypes.concat([ResultTypes.VOUCHER, ResultTypes.COINS, ResultTypes.XP]);
                }
              } else {
                $scope.enabledTriggerTypes = $scope.enabledTriggerTypes.concat([TriggerTypes.ADD_FRIEND, TriggerTypes.CREATE_TEAM]);
                return $scope.enabledCriteriaTypes = $scope.enabledCriteriaTypes.concat([CriteriaTypes.ADD_FRIEND]);
              }
            };
            if ($scope.tenant != null) {
              return Auth.isTenantAdmin().then(function(isTenantAdmin) {
                tenantAdmin = isTenantAdmin;
                return doConfig();
              });
            } else {
              return doConfig();
            }
          });
        };
        $scope.criteriaTypes = CriteriaTypes;
        $scope.resultTypes = ResultTypes;
        $scope.$watch("behavior", function(behavior) {
          if (behavior == null) {
            return;
          }
          if (behavior.triggers.length === 0) {
            $scope.addTrigger();
          }
          if (behavior.results.length === 0) {
            return $scope.addResult();
          }
        });
        $scope.addTrigger = function() {
          return $scope.behavior.triggers.push({
            type: null
          });
        };
        $scope.addCriteria = function() {
          return $scope.behavior.criteria.push({
            type: null
          });
        };
        $scope.addResult = function() {
          return $scope.behavior.results.push({
            type: null
          });
        };
        $scope.deleteTrigger = function(trigger) {
          return $scope.behavior.triggers.splice($scope.behavior.triggers.indexOf(trigger), 1);
        };
        $scope.deleteCriteria = function(criteria) {
          return $scope.behavior.criteria.splice($scope.behavior.criteria.indexOf(criteria), 1);
        };
        return $scope.deleteResults = function(result) {
          return $scope.behavior.results.splice($scope.behavior.results.indexOf(result), 1);
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgBehaviorEditor', function(TriggerTypes, CriteriaTypes, ResultTypes, BehaviorService, modalService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/behavioreditor/behavioreditor.html',
      scope: {
        tenant: "=",
        team: "=",
        playerId: "="
      },
      link: function($scope) {
        var refresh;
        refresh = function() {
          BehaviorService.getBehaviors($scope.tenant, $scope.team, $scope.playerId).then(function(behaviors) {
            return $scope.behaviors = behaviors;
          });
          return BehaviorService.getBehaviors($scope.tenant, null, null, true).then(function(behaviors) {
            return $scope.templateBehaviors = behaviors;
          });
        };
        $scope.$watch("tenant", refresh);
        $scope.$watch("team", refresh);
        $scope.$watch("playerId", refresh);
        $scope.copyBehavior = function() {
          var behavior;
          behavior = angular.copy($scope.selectedBehaviorTemplate);
          $scope.selectedBehaviorTemplate = null;
          if (behavior == null) {
            return;
          }
          delete behavior.id;
          behavior.template = false;
          if ($scope.tenant != null) {
            behavior.tenant = $scope.tenant.code;
          }
          if ($scope.team != null) {
            behavior.teamId = $scope.team.id;
          }
          if ($scope.playerId != null) {
            behavior.playerId = $scope.playerId;
          }
          return $scope.formData = behavior;
        };
        $scope.newBehavior = function() {
          var behavior;
          behavior = {
            name: "",
            triggers: [],
            criteria: [],
            results: [],
            open: false,
            recurring: false
          };
          if ($scope.tenant != null) {
            behavior.tenant = $scope.tenant.code;
          }
          if ($scope.team != null) {
            behavior.teamId = $scope.team.id;
          }
          if ($scope.playerId != null) {
            behavior.playerId = $scope.playerId;
          }
          return $scope.formData = behavior;
        };
        $scope.saveBehavior = function() {
          var index;
          index = $scope.behaviors.indexOf($scope.editBehavior);
          $scope.editBehavior = angular.copy($scope.formData);
          console.log("saving behavior", $scope.editBehavior);
          return BehaviorService.saveBehavior($scope.editBehavior).then(function(behavior) {
            if ($scope.editBehavior.id == null) {
              $scope.behaviors.push(behavior);
              $scope.editBehavior = behavior;
            } else {
              $scope.behaviors.splice(index, 1, behavior);
            }
            return $scope.newBehavior();
          });
        };
        $scope.selectBehavior = function(behavior) {
          $scope.editBehavior = behavior;
          return $scope.formData = angular.copy($scope.editBehavior);
        };
        $scope.archiveBehavior = function(behavior) {
          var doArchive;
          doArchive = function() {
            var index;
            index = $scope.behaviors.indexOf(behavior);
            behavior.archived = true;
            BehaviorService.saveBehavior(behavior).then(function(behavior) {
              return $scope.behaviors.splice(index, 1);
            }, function(error) {
              console.log("error", error);
              return modalService.showModal("Error", "Error archiving behavior");
            });
            return $scope.newBehavior();
          };
          return modalService.showModal("Confirm archiving Behavior", "Are you sure you want to archive this behavior?", true, true, "Cancel", doArchive, "Confirm");
        };
        return $scope.newBehavior();
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').factory('Auth', function(cogniss, $state, AccessLevels, $q, $rootScope, TenantService, UserService) {
    var service;
    service = {
      _redirectName: null,
      _redirectParams: null,
      redirect: function() {
        var redirectName, redirectParams;
        if (service._redirectName != null) {
          redirectName = service._redirectName;
          redirectParams = service._redirectParams;
          service._redirectName = null;
          service._redirectParams = null;
          return $state.go(redirectName, redirectParams);
        } else {
          return $state.go("tenant.users");
        }
      },
      setRedirect: function(name, params) {
        service._redirectName = name;
        return service._redirectParams = params;
      },
      getUser: function() {
        return cogniss.user;
      },
      logout: function(redirect) {
        cogniss.logout();
        $state.go("login");
      },
      isTenantAdmin: function(tenant) {
        var deferred;
        deferred = $q.defer();
        if (cogniss.user != null) {
          UserService.getUserDetails(cogniss.user.userId, tenant).then(function(details) {
            if (details.tenantDetails.admin) {
              return deferred.resolve(true);
            } else {
              return service.isAdmin().then(function(isAdmin) {
                return deferred.resolve(isAdmin);
              }, deferred.reject);
            }
          }, function() {
            return deferred.reject();
          });
        } else {
          deferred.reject();
        }
        return deferred.promise;
      },
      isAdmin: function() {
        var deferred;
        deferred = $q.defer();
        if (cogniss.user != null) {
          UserService.getUserDetails(cogniss.user.userId).then(function(details) {
            if (details.admin) {
              return deferred.resolve(true);
            } else {
              return deferred.resolve(false);
            }
          }, function() {
            return deferred.reject();
          });
        } else {
          deferred.reject();
        }
        return deferred.promise;
      },
      authorize: function(access, stateParams) {
        var deferred, doCheck, unwatch;
        deferred = $q.defer();
        doCheck = function() {
          var tenantRef;
          if (access === AccessLevels.user) {
            if (cogniss.user != null) {
              return deferred.resolve();
            } else {
              return deferred.reject();
            }
          } else if (access === AccessLevels.admin) {
            return service.isAdmin().then(function(isAdmin) {
              if (isAdmin) {
                return deferred.resolve();
              } else {
                return deferred.reject();
              }
            });
          } else if (access === AccessLevels.tenantAdmin) {
            if (cogniss.user != null) {
              tenantRef = stateParams.tenantRef;
              return TenantService.getTenantByUrlName(tenantRef).then(function(tenant) {
                return service.isTenantAdmin(tenant).then(function(isAdmin) {
                  if (isAdmin) {
                    return deferred.resolve();
                  } else {
                    return deferred.reject();
                  }
                }, deferred.reject);
              }, deferred.reject);
            } else {
              return deferred.reject();
            }
          } else {
            return deferred.resolve();
          }
        };
        if (cogniss.connected) {
          doCheck();
        } else {
          unwatch = $rootScope.$watch(function() {
            return cogniss.connected;
          }, function(val) {
            if (val) {
              doCheck();
              return unwatch();
            }
          });
        }
        return deferred.promise;
      }
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').factory('Analytics', function($q, TenantService) {
    var service;
    service = {
      trackerByTenant: {},
      init: function(code, callback) {
        var deferred;
        deferred = $q.defer();
        (function(i, s, o, g, r, a, m) {
          i["GoogleAnalyticsObject"] = r;
          i[r] = i[r] || function() {
            (i[r].q = i[r].q || []).push(arguments);
          };
          i[r].l = 1 * new Date();
          a = s.createElement(o);
          m = s.getElementsByTagName(o)[0];
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        })(window, document, "script", "//www.google-analytics.com/analytics.js", "ga");
        ga("create", code, "auto");
        ga(function(tracker) {
          var clientId;
          clientId = tracker.get('clientId');
          return service.clientId = clientId;
        });
        deferred.resolve();
        if (callback) {
          deferred.promise.then(callback());
        }
        return deferred.promise;
      },
      getTenantTracker: function(tenant) {
        if (service.trackerByTenant[tenant.code] != null) {
          return tenant.code;
        }
        if (tenant.gaCode == null) {
          return false;
        }
        if (tenant.gaCode != null) {
          ga("create", tenant.gaCode, "auto", tenant.code);
          service.trackerByTenant[tenant.code] = tenant.code;
          return tenant.code;
        } else {
          return false;
        }
      },
      trackPageview: function(path) {
        var tracker;
        ga("send", "pageview", path);
        if (TenantService.tenant != null) {
          tracker = service.getTenantTracker(TenantService.tenant);
          if (tracker) {
            return ga(tracker + ".send", "pageview", path);
          }
        }
      },
      trackEvent: function(category, action, label, value, nonInteraction) {
        var tracker;
        ga('send', 'event', category, action, label, value, nonInteraction);
        if (TenantService.tenant != null) {
          tracker = service.getTenantTracker(TenantService.tenant);
          if (tracker) {
            return ga('#{tracker}.send', 'event', category, action, label, value, nonInteraction);
          }
        }
      }
    };
    return service;
  });

}).call(this);



(function() {
  angular.module('cogniss').directive('cgActivityHistory', function(TenantService, $state, ProgressService) {
    'ngInject';
    var directive;
    return directive = {
      restrict: 'A',
      templateUrl: 'app/components/activityhistory/activityhistory.html',
      scope: {
        tenant: "=",
        playerId: "=?",
        playerIds: "=?",
        subject: "="
      },
      link: function($scope) {
        var noSubject, pending, update;
        pending = false;
        $scope.limit = 10;
        $scope.skip = 0;
        $scope.max = 0;
        noSubject = {
          name: "Subject"
        };
        $scope.selectedSubject = noSubject;
        $scope.startDateOptions = {
          showWeeks: false
        };
        $scope.endDateOptions = {
          showWeeks: false
        };
        update = function() {
          var end, start, subject;
          if ($scope.tenant == null) {
            return;
          }
          if ($scope.playerIds == null) {
            return;
          }
          if (pending) {
            return;
          }
          start = $scope.start;
          end = $scope.end;
          if (end != null) {
            end = moment(end);
            end.add(23, 'h');
            end.add(59, 'm');
            end.add(59, 's');
            end = end.toDate();
          }
          pending = true;
          subject = $scope.selectedSubject;
          if (subject && (subject.id == null)) {
            subject = null;
          }
          return ProgressService.getUserActivityResponses($scope.playerIds, $scope.tenant, subject, $scope.selectedTopic, $scope.start, end, $scope.skip, $scope.limit).then(function(data) {
            $scope.max = data.count;
            $scope.activityResponses = data.responses;
            return pending = false;
          });
        };
        $scope.$watch("tenant", function(val) {
          if ($scope.tenant == null) {
            return;
          }
          return TenantService.getContent($scope.tenant).then(function(content) {
            var filterSubjects;
            filterSubjects = _.clone(content.subjects);
            filterSubjects.splice(0, 0, noSubject);
            $scope.subjects = filterSubjects;
            return update();
          });
        });
        $scope.$watch("playerId", function(val) {
          if (val != null) {
            return $scope.playerIds = [val];
          }
        });
        $scope.$watch("playerIds", function(val) {
          if (val != null) {
            return update();
          }
        });
        $scope.$watch("subject", function(val) {
          if (val == null) {
            return;
          }
          pending = false;
          $scope.selectedSubject = val;
          return update();
        });
        $scope.$watch("selectedSubject", update);
        $scope.$watch("start", update);
        $scope.$watch("end", update);
        $scope.$watch("skip", update);
        return $scope.selectActivityResponse = function(response) {
          return $state.go("tenant.user.response", {
            tenantRef: $scope.tenant.urlName,
            userId: response.playerId,
            responseId: response.id
          });
        };
      }
    };
  });

}).call(this);



(function() {
  angular.module('cogniss').run(function($log, cogniss, $rootScope, $state, fbAppId, ezfb, $window, Analytics, Auth, gaCode, TenantService, modalService, OptionsService, html5Mode) {
    'ngInject';
    cogniss.init();
    ezfb.init({
      appId: fbAppId
    });
    $rootScope.$watch(function() {
      return cogniss.connected;
    }, function(val) {
      return $rootScope.connected = val;
    });
    $rootScope.$watch(function() {
      return OptionsService.showSidebar;
    }, function(val) {
      return $rootScope.showSidebar = val;
    });
    Analytics.init(gaCode);
    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      var checkAuth, checkConnected, checkTenant, continueNavigation, doLogout;
      if (fromParams.fromAsync) {
        return;
      }
      event.preventDefault();
      doLogout = function(toStateName, toParams) {
        Auth.setRedirect(toStateName, toParams);
        return Auth.logout();
      };
      checkConnected = function() {
        var watcher;
        if (cogniss.connected) {
          return checkTenant();
        } else {
          return watcher = $rootScope.$watch(function() {
            return cogniss.connected;
          }, function(val) {
            if (val) {
              return checkTenant();
            }
          });
        }
      };
      checkTenant = function() {
        if (toParams.tenantRef) {
          if (toParams.tenantRef.length > 0) {
            return TenantService.getTenantByUrlName(toParams.tenantRef).then(function(tenant) {
              TenantService.tenant = tenant;
              return checkAuth();
            }, function(err) {
              return doLogout(toState.name, toParams);
            });
          } else {
            return TenantService.getDefaultTenant().then(function(tenant) {
              TenantService.tenant = tenant;
              return checkAuth();
            });
          }
        } else {
          TenantService.tenant = null;
          TenantService.getTenants();
          return checkAuth();
        }
      };
      checkAuth = function() {
        return Auth.authorize(toState.data.access, toParams).then(function() {
          return continueNavigation();
        }, function() {
          return doLogout(toState.name, toParams);
        });
      };
      continueNavigation = function() {
        fromParams.fromAsync = true;
        return $state.go(toState.name, toParams);
      };
      return checkConnected();
    });
    return $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
      var url;
      url = toState.url;
      if (!html5Mode) {
        url = $window.location.hash.split("#!").join("");
      }
      Analytics.trackPageview(url);
      return $window.scrollTo(0, 0);
    });
  });

}).call(this);



(function() {
  angular.module('cogniss').config(function($stateProvider, $urlRouterProvider, AccessLevels) {
    'ngInject';
    var createScreen;
    createScreen = function(name, route, access, template, resolve) {
      var controllerName, stateConfig;
      if (access == null) {
        access = AccessLevels.anon;
      }
      controllerName = name + "Controller";
      controllerName = _.upperFirst(controllerName);
      if (template == null) {
        template = "app/screens/" + name + "/" + name + ".html";
      }
      if (route == null) {
        route = "/" + name;
      }
      stateConfig = {
        url: route,
        templateUrl: template,
        controller: controllerName,
        data: {
          access: access
        },
        resolve: resolve
      };
      return $stateProvider.state(name, stateConfig);
    };
    createScreen('forgot');
    createScreen('login', '/');
    createScreen('register');
    createScreen('reset', '/reset?user&users&token');
    $stateProvider.state('tenant', {
      url: '/app/:tenantRef',
      templateUrl: "app/screens/tenant/tenant.html",
      controller: "TenantController",
      abstract: true,
      data: {
        access: AccessLevels.user
      },
      resolve: {
        tenant: function($stateParams, TenantService) {
          var tenant, tenantRef;
          tenantRef = $stateParams.tenantRef;
          if ((tenantRef != null) && tenantRef.length > 0) {
            tenant = TenantService.getTenantByUrlName(tenantRef);
          } else {
            tenant = TenantService.getDefaultTenant();
          }
          return tenant;
        }
      }
    }).state('tenant.users', {
      url: "",
      templateUrl: "app/screens/tenant/users/users.html",
      controller: "TenantUsersController",
      data: {
        access: AccessLevels.user
      }
    }).state('tenant.user', {
      url: "/user/:userId",
      templateUrl: "app/screens/tenant/user/user.html",
      controller: "TenantUserController",
      abstract: true,
      data: {
        access: AccessLevels.user
      },
      resolve: {
        userDetails: function($stateParams, UserService, tenant) {
          var details, userId;
          userId = $stateParams.userId;
          details = UserService.getUserDetails(userId, tenant);
          return details;
        }
      }
    }).state('tenant.user.overview', {
      url: "",
      templateUrl: "app/screens/tenant/user/overview/overview.html",
      controller: "TenantUserOverviewController",
      data: {
        access: AccessLevels.user
      }
    }).state('tenant.user.subject', {
      url: "/subject/:subjectId",
      templateUrl: "app/screens/tenant/user/subject/subject.html",
      controller: "TenantUserSubjectController",
      data: {
        access: AccessLevels.user
      },
      resolve: {
        subjectId: function($stateParams, TenantService, tenant, $q) {
          var subjectId;
          subjectId = $stateParams.subjectId;
          return subjectId;
        }
      }
    }).state('tenant.user.response', {
      url: "/response/:responseId",
      templateUrl: "app/screens/tenant/user/response/response.html",
      controller: "TenantUserResponseController",
      data: {
        access: AccessLevels.user
      },
      resolve: {
        responseId: function($stateParams, TenantService, tenant, $q) {
          var responseId;
          responseId = $stateParams.responseId;
          return responseId;
        }
      }
    }).state('tenant.teams', {
      url: "/teams",
      templateUrl: "app/screens/tenant/teams/teams.html",
      controller: "TenantTeamsController",
      data: {
        access: AccessLevels.user
      }
    }).state('tenant.team', {
      url: "/teams/:teamId",
      templateUrl: "app/screens/tenant/team/team.html",
      controller: "TenantTeamController",
      abstract: true,
      data: {
        access: AccessLevels.user
      },
      resolve: {
        team: function($stateParams, TeamService, tenant) {
          var details, teamId;
          teamId = $stateParams.teamId;
          details = TeamService.getTeam(teamId, tenant);
          return details;
        }
      }
    }).state('tenant.team.overview', {
      url: "",
      templateUrl: "app/screens/tenant/team/overview/overview.html",
      controller: "TenantTeamOverviewController",
      data: {
        access: AccessLevels.user
      }
    }).state('tenant.team.subject', {
      url: "/subject/:subjectId",
      templateUrl: "app/screens/tenant/team/subject/subject.html",
      controller: "TenantTeamSubjectController",
      data: {
        access: AccessLevels.user
      },
      resolve: {
        subjectId: function($stateParams, TenantService, tenant, $q) {
          var subjectId;
          subjectId = $stateParams.subjectId;
          return subjectId;
        }
      }
    }).state('tenant.team.behaviors', {
      url: "/behaviors",
      templateUrl: "app/screens/tenant/team/behaviors/behaviors.html",
      controller: "TenantTeamBehaviorsController",
      data: {
        access: AccessLevels.teamAdmin
      }
    }).state('tenant.subjects', {
      url: "/subjects",
      templateUrl: "app/screens/tenant/subjects/subjects.html",
      controller: "TenantSubjectsController",
      data: {
        access: AccessLevels.user
      }
    }).state('tenant.content', {
      abstract: true,
      url: "/content",
      templateUrl: "app/screens/tenant/content/content.html",
      data: {
        access: AccessLevels.user
      }
    }).state('tenant.content.subjects', {
      url: "/",
      templateUrl: "app/screens/tenant/content/subjects/subjects.html",
      controller: "TenantContentSubjectsController",
      data: {
        access: AccessLevels.user
      }
    }).state('tenant.content.subject', {
      url: "/subject/:subjectId",
      templateUrl: "app/screens/tenant/content/subject/subject.html",
      controller: "TenantContentSubjectController",
      data: {
        access: AccessLevels.user
      },
      resolve: {
        subjectId: function($stateParams, TenantService, tenant, $q) {
          var subjectId;
          subjectId = $stateParams.subjectId;
          return subjectId;
        }
      }
    }).state('tenant.content.activity', {
      url: "/activity/:activityId",
      templateUrl: "app/screens/tenant/content/activity/activity.html",
      controller: "TenantContentActivityController",
      data: {
        access: AccessLevels.user
      },
      resolve: {
        activityId: function($stateParams, TenantService, tenant, $q) {
          var activityId;
          activityId = $stateParams.activityId;
          return activityId;
        }
      }
    }).state('tenant.admin', {
      abstract: true,
      url: "/admin",
      templateUrl: "app/screens/tenant/admin/admin.html",
      controller: "TenantAdminController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.users', {
      url: "",
      templateUrl: "app/screens/tenant/admin/users/users.html",
      controller: "TenantAdminUsersController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.vouchers', {
      url: "/vouchers",
      templateUrl: "app/screens/tenant/admin/vouchers/vouchers.html",
      controller: "TenantAdminVouchersController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.behaviors', {
      url: "/behaviors",
      templateUrl: "app/screens/tenant/admin/behaviors/behaviors.html",
      controller: "TenantAdminBehaviorsController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.leaderboards', {
      url: "/leaderboards",
      templateUrl: "app/screens/tenant/admin/leaderboards/leaderboards.html",
      controller: "TenantAdminLeaderboardsController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.content', {
      abstract: true,
      url: "/content",
      templateUrl: "app/screens/tenant/admin/content/content.html",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.content.overview', {
      url: "/overview",
      templateUrl: "app/screens/tenant/admin/content/overview/overview.html",
      controller: "TenantAdminContentOverviewController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.content.subjects', {
      url: "/subjects",
      templateUrl: "app/screens/tenant/admin/content/subjects/subjects.html",
      controller: "TenantAdminSubjectsController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.content.subject', {
      abstract: true,
      url: "/subjects/:subjectId",
      templateUrl: "app/screens/tenant/admin/content/subject/subject.html",
      controller: "TenantAdminSubjectController",
      resolve: {
        subject: function($stateParams, ContentService) {
          var subjectId;
          subjectId = $stateParams.subjectId;
          return ContentService.getSubject(subjectId);
        }
      },
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.content.subject.topics', {
      url: "/topics",
      templateUrl: "app/screens/tenant/admin/content/topics/topics.html",
      controller: "TenantAdminTopicsController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.content.subject.activities', {
      url: "/activities",
      templateUrl: "app/screens/tenant/admin/content/activities/activities.html",
      controller: "TenantAdminActivitiesController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.content.topic', {
      abstract: true,
      url: "/topics/:topicId",
      templateUrl: "app/screens/tenant/admin/content/topic/topic.html",
      controller: "TenantAdminTopicController",
      resolve: {
        topic: function($stateParams, ContentService) {
          var topicId;
          topicId = $stateParams.topicId;
          return ContentService.getTopic(topicId);
        }
      },
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.content.topic.questions', {
      url: "/questions",
      templateUrl: "app/screens/tenant/admin/content/questions/questions.html",
      controller: "TenantAdminQuestionsController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('tenant.admin.content.topic.activities', {
      url: "/activities",
      templateUrl: "app/screens/tenant/admin/content/activities/activities.html",
      controller: "TenantAdminActivitiesController",
      data: {
        access: AccessLevels.tenantAdmin
      }
    }).state('teams', {
      url: "/teams",
      abstract: true,
      templateUrl: "app/screens/teams/teams.html",
      controller: "TeamsController",
      data: {
        access: AccessLevels.user
      }
    }).state('teams.overview', {
      url: "",
      templateUrl: "app/screens/teams/overview/overview.html",
      controller: "TeamsOverviewController",
      data: {
        access: AccessLevels.user
      }
    }).state('teams.team', {
      url: "/team/:teamId",
      templateUrl: "app/screens/teams/team/team.html",
      controller: "TeamsTeamController",
      data: {
        access: AccessLevels.user
      },
      resolve: {
        team: function($stateParams, TeamService) {
          var team, teamId;
          teamId = $stateParams.teamId;
          team = TeamService.getTeam(teamId);
          return team;
        }
      }
    }).state('admin', {
      url: "/admin",
      abstract: true,
      templateUrl: "app/screens/admin/admin.html",
      controller: "AdminController",
      data: {
        access: AccessLevels.admin
      }
    }).state('admin.templates', {
      url: "",
      templateUrl: "app/screens/admin/templates/templates.html",
      controller: "AdminTemplatesController",
      data: {
        access: AccessLevels.admin
      }
    }).state('admin.tenants', {
      url: "/tenants",
      templateUrl: "app/screens/admin/tenants/tenants.html",
      controller: "AdminTenantsController",
      data: {
        access: AccessLevels.admin
      }
    }).state('admin.behaviors', {
      url: "/behaviors",
      templateUrl: "app/screens/admin/behaviors/behaviors.html",
      controller: "AdminBehaviorsController",
      data: {
        access: AccessLevels.admin
      }
    });
    return $urlRouterProvider.otherwise('/');
  });

}).call(this);



(function() {
  angular.module('cogniss').constant('gamesparksPreview', false).constant('gamesparksKey', '292003BKwVoF').constant('gamesparksSecret', 'hrZwvY95Zrh8lLk0BmaFLBB0oXuG5r3s').constant('fbAppId', '336822373342250').constant('tenantShortcode', 'COGNISS').constant('AccessLevels', {
    user: "user",
    admin: "admin",
    tenantAdmin: "tenantAdmin",
    teamAdmin: "teamAdmin",
    anon: "anon"
  }).constant('gaCode', 'UA-89044603-1').constant('html5Mode', true).constant('QuestionTypes', {
    MULTICHOICE: "MULTICHOICE",
    FILL_BLANKS: "FILL_BLANKS",
    EQUATION: "EQUATION",
    TEXT_RANGE: "TEXT_RANGE",
    IMAGE_RESPONSE: "IMAGE_RESPONSE",
    AUDIO_RESPONSE: "AUDIO_RESPONSE",
    CATEGORISATION: "CATEGORISATION",
    TEMPLATE_INTERPRETED: "TEMPLATE_INTERPRETED"
  }).constant('TopicTypes', {
    LEARNING: "LEARNING",
    PLACEMENT: "PLACEMENT",
    PRACTICE: "PRACTICE",
    ASSESSMENT: "ASSESSMENT",
    SURVEY: "SURVEY",
    SCORED_SURVEY: "SCORED_SURVEY"
  }).constant('NoteTypes', {
    NOTE: "NOTE",
    PHONE_CALL: "PHONE_CALL",
    EMAIL: "EMAIL",
    FOLLOW_UP: "FOLLOW_UP"
  }).constant('TriggerTypes', {
    ACTIVITY_RESPONSE: "ACTIVITY_RESPONSE",
    COMPLETE_ACTIVITY: "COMPLETE_ACTIVITY",
    QUESTION_RESPONSE: "QUESTION_RESPONSE",
    SCHEDULED: "SCHEDULED",
    ADD_FRIEND: "ADD_FRIEND",
    CREATE_TEAM: "CREATE_TEAM"
  }).constant('CriteriaTypes', {
    ACTIVITY_RESPONSE: "ACTIVITY_RESPONSE",
    QUESTION_RESPONSE: "QUESTION_RESPONSE",
    ADD_FRIEND: "ADD_FRIEND"
  }).constant('ResultTypes', {
    VOUCHER: "VOUCHER",
    VIRTUAL_GOOD: "VIRTUAL_GOOD",
    COINS: "COINS",
    XP: "XP",
    NOTIFICATION: "NOTIFICATION",
    NEWS: "NEWS",
    NOTE: "NOTE"
  }).constant('gaCode', 'UA-90415165-4').constant('html5Mode', false);

}).call(this);



(function() {
  angular.module('cogniss').config(function($logProvider, $translateProvider, $locationProvider, html5Mode, tagsInputConfigProvider) {
    'ngInject';
    var absUrl, redirect;
    console.log("window.location", window.location);
    absUrl = window.location.href;
    if (absUrl.indexOf("/#/reset") > -1) {
      redirect = absUrl.split("/#/reset").join("/reset");
      window.location.href = redirect;
      return;
    }
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode({
      enabled: html5Mode,
      requireBase: html5Mode
    });
    $translateProvider.useStaticFilesLoader({
      prefix: 'assets/languages/',
      suffix: '.json'
    });
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitize');
    $translateProvider.useMissingTranslationHandlerLog();
    return tagsInputConfigProvider.setDefaults('tagsInput', {
      replaceSpacesWithDashes: false
    });
  });

}).call(this);



/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
var CryptoJS=CryptoJS||function(h,s){var f={},g=f.lib={},q=function(){},m=g.Base={extend:function(a){q.prototype=this;var c=new q;a&&c.mixIn(a);c.hasOwnProperty("init")||(c.init=function(){c.$super.init.apply(this,arguments)});c.init.prototype=c;c.$super=this;return c},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var c in a)a.hasOwnProperty(c)&&(this[c]=a[c]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.init.prototype.extend(this)}},
r=g.WordArray=m.extend({init:function(a,c){a=this.words=a||[];this.sigBytes=c!=s?c:4*a.length},toString:function(a){return(a||k).stringify(this)},concat:function(a){var c=this.words,d=a.words,b=this.sigBytes;a=a.sigBytes;this.clamp();if(b%4)for(var e=0;e<a;e++)c[b+e>>>2]|=(d[e>>>2]>>>24-8*(e%4)&255)<<24-8*((b+e)%4);else if(65535<d.length)for(e=0;e<a;e+=4)c[b+e>>>2]=d[e>>>2];else c.push.apply(c,d);this.sigBytes+=a;return this},clamp:function(){var a=this.words,c=this.sigBytes;a[c>>>2]&=4294967295<<
32-8*(c%4);a.length=h.ceil(c/4)},clone:function(){var a=m.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var c=[],d=0;d<a;d+=4)c.push(4294967296*h.random()|0);return new r.init(c,a)}}),l=f.enc={},k=l.Hex={stringify:function(a){var c=a.words;a=a.sigBytes;for(var d=[],b=0;b<a;b++){var e=c[b>>>2]>>>24-8*(b%4)&255;d.push((e>>>4).toString(16));d.push((e&15).toString(16))}return d.join("")},parse:function(a){for(var c=a.length,d=[],b=0;b<c;b+=2)d[b>>>3]|=parseInt(a.substr(b,
2),16)<<24-4*(b%8);return new r.init(d,c/2)}},n=l.Latin1={stringify:function(a){var c=a.words;a=a.sigBytes;for(var d=[],b=0;b<a;b++)d.push(String.fromCharCode(c[b>>>2]>>>24-8*(b%4)&255));return d.join("")},parse:function(a){for(var c=a.length,d=[],b=0;b<c;b++)d[b>>>2]|=(a.charCodeAt(b)&255)<<24-8*(b%4);return new r.init(d,c)}},j=l.Utf8={stringify:function(a){try{return decodeURIComponent(escape(n.stringify(a)))}catch(c){throw Error("Malformed UTF-8 data");}},parse:function(a){return n.parse(unescape(encodeURIComponent(a)))}},
u=g.BufferedBlockAlgorithm=m.extend({reset:function(){this._data=new r.init;this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=j.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var c=this._data,d=c.words,b=c.sigBytes,e=this.blockSize,f=b/(4*e),f=a?h.ceil(f):h.max((f|0)-this._minBufferSize,0);a=f*e;b=h.min(4*a,b);if(a){for(var g=0;g<a;g+=e)this._doProcessBlock(d,g);g=d.splice(0,a);c.sigBytes-=b}return new r.init(g,b)},clone:function(){var a=m.clone.call(this);
a._data=this._data.clone();return a},_minBufferSize:0});g.Hasher=u.extend({cfg:m.extend(),init:function(a){this.cfg=this.cfg.extend(a);this.reset()},reset:function(){u.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);return this._doFinalize()},blockSize:16,_createHelper:function(a){return function(c,d){return(new a.init(d)).finalize(c)}},_createHmacHelper:function(a){return function(c,d){return(new t.HMAC.init(a,
d)).finalize(c)}}});var t=f.algo={};return f}(Math);
(function(h){for(var s=CryptoJS,f=s.lib,g=f.WordArray,q=f.Hasher,f=s.algo,m=[],r=[],l=function(a){return 4294967296*(a-(a|0))|0},k=2,n=0;64>n;){var j;a:{j=k;for(var u=h.sqrt(j),t=2;t<=u;t++)if(!(j%t)){j=!1;break a}j=!0}j&&(8>n&&(m[n]=l(h.pow(k,0.5))),r[n]=l(h.pow(k,1/3)),n++);k++}var a=[],f=f.SHA256=q.extend({_doReset:function(){this._hash=new g.init(m.slice(0))},_doProcessBlock:function(c,d){for(var b=this._hash.words,e=b[0],f=b[1],g=b[2],j=b[3],h=b[4],m=b[5],n=b[6],q=b[7],p=0;64>p;p++){if(16>p)a[p]=
c[d+p]|0;else{var k=a[p-15],l=a[p-2];a[p]=((k<<25|k>>>7)^(k<<14|k>>>18)^k>>>3)+a[p-7]+((l<<15|l>>>17)^(l<<13|l>>>19)^l>>>10)+a[p-16]}k=q+((h<<26|h>>>6)^(h<<21|h>>>11)^(h<<7|h>>>25))+(h&m^~h&n)+r[p]+a[p];l=((e<<30|e>>>2)^(e<<19|e>>>13)^(e<<10|e>>>22))+(e&f^e&g^f&g);q=n;n=m;m=h;h=j+k|0;j=g;g=f;f=e;e=k+l|0}b[0]=b[0]+e|0;b[1]=b[1]+f|0;b[2]=b[2]+g|0;b[3]=b[3]+j|0;b[4]=b[4]+h|0;b[5]=b[5]+m|0;b[6]=b[6]+n|0;b[7]=b[7]+q|0},_doFinalize:function(){var a=this._data,d=a.words,b=8*this._nDataBytes,e=8*a.sigBytes;
d[e>>>5]|=128<<24-e%32;d[(e+64>>>9<<4)+14]=h.floor(b/4294967296);d[(e+64>>>9<<4)+15]=b;a.sigBytes=4*d.length;this._process();return this._hash},clone:function(){var a=q.clone.call(this);a._hash=this._hash.clone();return a}});s.SHA256=q._createHelper(f);s.HmacSHA256=q._createHmacHelper(f)})(Math);
(function(){var h=CryptoJS,s=h.enc.Utf8;h.algo.HMAC=h.lib.Base.extend({init:function(f,g){f=this._hasher=new f.init;"string"==typeof g&&(g=s.parse(g));var h=f.blockSize,m=4*h;g.sigBytes>m&&(g=f.finalize(g));g.clamp();for(var r=this._oKey=g.clone(),l=this._iKey=g.clone(),k=r.words,n=l.words,j=0;j<h;j++)k[j]^=1549556828,n[j]^=909522486;r.sigBytes=l.sigBytes=m;this.reset()},reset:function(){var f=this._hasher;f.reset();f.update(this._iKey)},update:function(f){this._hasher.update(f);return this},finalize:function(f){var g=
this._hasher;f=g.finalize(f);g.reset();return g.finalize(this._oKey.clone().concat(f))}})})();

(function(){var h=CryptoJS,i=h.lib.WordArray;h.enc.Base64={stringify:function(b){var e=b.words,f=b.sigBytes,c=this._map;b.clamp();for(var b=[],a=0;a<f;a+=3)for(var d=(e[a>>>2]>>>24-8*(a%4)&255)<<16|(e[a+1>>>2]>>>24-8*((a+1)%4)&255)<<8|e[a+2>>>2]>>>24-8*((a+2)%4)&255,g=0;4>g&&a+0.75*g<f;g++)b.push(c.charAt(d>>>6*(3-g)&63));if(e=c.charAt(64))for(;b.length%4;)b.push(e);return b.join("")},parse:function(b){var b=b.replace(/\s/g,""),e=b.length,f=this._map,c=f.charAt(64);c&&(c=b.indexOf(c),-1!=c&&(e=c));
for(var c=[],a=0,d=0;d<e;d++)if(d%4){var g=f.indexOf(b.charAt(d-1))<<2*(d%4),h=f.indexOf(b.charAt(d))>>>6-2*(d%4);c[a>>>2]|=(g|h)<<24-8*(a%4);a++}return i.create(c,a)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}})();
GameSparks = function() {

	var appSecret;
	
	var socketUrl;
	var lbUrl;
	
	var authToken;
	var sessionId;

	var initialised = false;
	var connected;
	var error;
	var closing;
	
	var initCallback;
	var messageCallback;
	var errorCallback;

	var nonceCallback;
	
	var pendingRequests = {};
	
	var webSocket;
	
	var requestCounter = 0;
	
	this.getSessionId = function(){
		return sessionId;
	}
    
    this.getAuthToken = function(){
        return authToken;
    }
	
	this.isInitialised = function(){
		return initialised;
	}
	
	this.initPreview = function(options){
		options.url = "wss://preview.gamesparks.net/ws/" + options.key;
		this.init(options);
	}

	this.initLive = function(options){
		options.url = "wss://service.gamesparks.net/ws/" + options.key;
		this.init(options);
	}
	
	this.init = function(options) {
		socketUrl = options.url;
		lbUrl = options.url;
		appSecret = options.secret;
		initCallback = options.onInit;
		messageCallback = options.onMessage;
		errorCallback = options.onError;
		nonceCallback = options.onNonce;
        authToken = options.authToken;
        sessionId = options.sessionId;
		
		initialised = false;
		connected = false;
		error = false;
		closing = false;
		cleanup();
		connect();
	};
	
	this.send = function(requestType, onResponse){
		this.sendWithData(requestType, {}, onResponse);
	};
	
	this.sendWithData = function(requestType, json, onResponse){
		
		if(!initialised){
			onResponse({error:"NOT_INITIALISED"});
			return;
		}
		if(requestType.indexOf('.') !== 0){
			requestType = "."+requestType;
		}
		json["@class"] = requestType;
		
		json.requestId = (new Date()).getTime() + "_" + (++requestCounter);

		if(onResponse != null){
			pendingRequests[json.requestId] = onResponse;
			setTimeout(function(){
				if(pendingRequests[json.requestId]){
					pendingRequests[json.requestId]({error:"NO_RESPONSE"});
				}
			}, 32000);
		}
		
		var requestString = JSON.stringify(json);
		console.log("WebSocket send: " + requestString);
		webSocket.send(requestString);
	};
	
	function cleanup(){
		if(webSocket != null){
			webSocket.onclose = null;
			webSocket.close();
		}
	}
	
	var keepAliveId;

	function keepAlive(){
		if(initialised && connected){
			webSocket.send(" ");
		}
		keepAliveId = setTimeout(keepAlive, 30000);
	}

	function getWebSocket(location) {
		if (window.WebSocket) {
			return new WebSocket(location);
		} else {
			return new MozWebSocket(location);
		}
	}

	function connect() {
		try{
			webSocket = getWebSocket(socketUrl);
			webSocket.onopen = onWebSocketOpen;
			webSocket.onclose = onWebSocketClose;
			webSocket.onerror = onWebSocketError;
			webSocket.onmessage = onWebSocketMessage;
		}catch(e){}
	}

	function onWebSocketError() {
		socketUrl = lbUrl;
		console.log('WebSocket onError: Sorry, but there is some problem with your socket or the server is down');
		if(errorCallback){
			errorCallback();
		}
		error = true;
	}

	function onWebSocketClose(closeEvent) {
		connected = false;
		console.log('WebSocket onClose executed ');
		if (!error) {
			connect();
		}
	}

	function onWebSocketOpen(openEvent) {
		connected = true;
		console.log('WebSocket onOpen: Connected ' + openEvent);
	}

	function onWebSocketMessage(message) {
		
		var messageData = message.data;
		
		console.log('WebSocket onMessage: ' + messageData);
		
		var result;
		
		try {
			result = JSON.parse(messageData);
		} catch (e) {
			console.log("An error ocurred while parsing the JSON Data: "
					+ message + "; Error: " + e);
			return;
		}

		if (result['authToken']) {
			authToken = result['authToken'];
			delete result['authToken'];
		}

		var resultType = result['@class'];

		if (resultType == ".AuthenticatedConnectResponse") {
			handshake(result);
		} else if (resultType.match(/Response$/)){
			if(result["requestId"]){
				var requestId = result["requestId"];
				delete result["requestId"];
				if(pendingRequests[requestId]){
					pendingRequests[requestId](result);
					pendingRequests[requestId] = null;
				};
			};
		} else {
			messageCallback(result);
		};

	}
	
	function handshake(result){
		
		if (result['connectUrl']) {
			socketUrl = result['connectUrl'];
			return;
		} else if (result['nonce']) {
			
			var hmac;

			if(nonceCallback != null){
				hmac = nonceCallback(result['nonce']);
			} else {
				hmac = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(result['nonce'], appSecret));
			}

			var toSend = {
				"@class" : ".AuthenticatedConnectRequest",
				hmac : hmac
			};

			if (authToken) {
				toSend.authToken = authToken;
			}

			if (sessionId) {
				toSend.sessionId = sessionId;
			}

			toSend.platform = BrowserDetect.browser;
			toSend.os = BrowserDetect.OS;
			webSocket.send(JSON.stringify(toSend));
			return;
		} else if (result['sessionId']) {
			sessionId = result['sessionId'];
			initialised = true;
			if(initCallback){
				initCallback();
			}
			keepAliveId = setTimeout(keepAlive, 30000);
			return;
		}
	}
};



var BrowserDetect = {
		init: function () {
			this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
			this.version = this.searchVersion(navigator.userAgent)
				|| this.searchVersion(navigator.appVersion)
				|| "an unknown version";
			this.OS = this.searchString(this.dataOS) || "an unknown OS";
		},
		searchString: function (data) {
			for (var i=0;i<data.length;i++)	{
				var dataString = data[i].string;
				var dataProp = data[i].prop;
				this.versionSearchString = data[i].versionSearch || data[i].identity;
				if (dataString) {
					if (dataString.indexOf(data[i].subString) != -1)
						return data[i].identity;
				}
				else if (dataProp)
					return data[i].identity;
			}
		},
		searchVersion: function (dataString) {
			var index = dataString.indexOf(this.versionSearchString);
			if (index == -1) return;
			return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
		},
		dataBrowser: [
			{
				string: navigator.userAgent,
				subString: "Chrome",
				identity: "Chrome"
			},
			{ 	string: navigator.userAgent,
				subString: "OmniWeb",
				versionSearch: "OmniWeb/",
				identity: "OmniWeb"
			},
			{
				string: navigator.vendor,
				subString: "Apple",
				identity: "Safari",
				versionSearch: "Version"
			},
			{
				prop: window.opera,
				identity: "Opera",
				versionSearch: "Version"
			},
			{
				string: navigator.vendor,
				subString: "iCab",
				identity: "iCab"
			},
			{
				string: navigator.vendor,
				subString: "KDE",
				identity: "Konqueror"
			},
			{
				string: navigator.userAgent,
				subString: "Firefox",
				identity: "Firefox"
			},
			{
				string: navigator.vendor,
				subString: "Camino",
				identity: "Camino"
			},
			{		// for newer Netscapes (6+)
				string: navigator.userAgent,
				subString: "Netscape",
				identity: "Netscape"
			},
			{
				string: navigator.userAgent,
				subString: "MSIE",
				identity: "Explorer",
				versionSearch: "MSIE"
			},
			{
				string: navigator.userAgent,
				subString: "Gecko",
				identity: "Mozilla",
				versionSearch: "rv"
			},
			{ 		// for older Netscapes (4-)
				string: navigator.userAgent,
				subString: "Mozilla",
				identity: "Netscape",
				versionSearch: "Mozilla"
			}
		],
		dataOS : [
			{
				string: navigator.platform,
				subString: "Win",
				identity: "Windows"
			},
			{
				string: navigator.platform,
				subString: "Mac",
				identity: "Mac"
			},
			{
				   string: navigator.userAgent,
				   subString: "iPhone",
				   identity: "iPhone/iPod"
		    },
			{
				string: navigator.platform,
				subString: "Linux",
				identity: "Linux"
			}
		]

	};
	BrowserDetect.init();

GameSparks.prototype.acceptChallengeRequest = function(challengeInstanceId, message, onResponse )
{
    var request = {};
		request["challengeInstanceId"] = challengeInstanceId;
		request["message"] = message;
    gamesparks.sendWithData("AcceptChallengeRequest", request, onResponse);
}
GameSparks.prototype.accountDetailsRequest = function(onResponse )
{
    var request = {};
    gamesparks.sendWithData("AccountDetailsRequest", request, onResponse);
}
GameSparks.prototype.analyticsRequest = function(data, end, key, start, onResponse )
{
    var request = {};
		request["data"] = data;
		request["end"] = end;
		request["key"] = key;
		request["start"] = start;
    gamesparks.sendWithData("AnalyticsRequest", request, onResponse);
}
GameSparks.prototype.aroundMeLeaderboardRequest = function(count, friendIds, leaderboardShortCode, social, onResponse )
{
    var request = {};
		request["count"] = count;
		request["friendIds"] = friendIds;
		request["leaderboardShortCode"] = leaderboardShortCode;
		request["social"] = social;
    gamesparks.sendWithData("AroundMeLeaderboardRequest", request, onResponse);
}
GameSparks.prototype.authenticationRequest = function(password, userName, onResponse )
{
    var request = {};
		request["password"] = password;
		request["userName"] = userName;
    gamesparks.sendWithData("AuthenticationRequest", request, onResponse);
}
GameSparks.prototype.buyVirtualGoodsRequest = function(currencyType, quantity, shortCode, onResponse )
{
    var request = {};
		request["currencyType"] = currencyType;
		request["quantity"] = quantity;
		request["shortCode"] = shortCode;
    gamesparks.sendWithData("BuyVirtualGoodsRequest", request, onResponse);
}
GameSparks.prototype.changeUserDetailsRequest = function(displayName, onResponse )
{
    var request = {};
		request["displayName"] = displayName;
    gamesparks.sendWithData("ChangeUserDetailsRequest", request, onResponse);
}
GameSparks.prototype.chatOnChallengeRequest = function(challengeInstanceId, message, onResponse )
{
    var request = {};
		request["challengeInstanceId"] = challengeInstanceId;
		request["message"] = message;
    gamesparks.sendWithData("ChatOnChallengeRequest", request, onResponse);
}
GameSparks.prototype.consumeVirtualGoodRequest = function(quantity, shortCode, onResponse )
{
    var request = {};
		request["quantity"] = quantity;
		request["shortCode"] = shortCode;
    gamesparks.sendWithData("ConsumeVirtualGoodRequest", request, onResponse);
}
GameSparks.prototype.createChallengeRequest = function(accessType, challengeMessage, challengeShortCode, currency1Wager, currency2Wager, currency3Wager, currency4Wager, currency5Wager, currency6Wager, endTime, expiryTime, maxAttempts, maxPlayers, minPlayers, silent, startTime, usersToChallenge, onResponse )
{
    var request = {};
		request["accessType"] = accessType;
		request["challengeMessage"] = challengeMessage;
		request["challengeShortCode"] = challengeShortCode;
		request["currency1Wager"] = currency1Wager;
		request["currency2Wager"] = currency2Wager;
		request["currency3Wager"] = currency3Wager;
		request["currency4Wager"] = currency4Wager;
		request["currency5Wager"] = currency5Wager;
		request["currency6Wager"] = currency6Wager;
		request["endTime"] = endTime;
		request["expiryTime"] = expiryTime;
		request["maxAttempts"] = maxAttempts;
		request["maxPlayers"] = maxPlayers;
		request["minPlayers"] = minPlayers;
		request["silent"] = silent;
		request["startTime"] = startTime;
		request["usersToChallenge"] = usersToChallenge;
    gamesparks.sendWithData("CreateChallengeRequest", request, onResponse);
}
GameSparks.prototype.declineChallengeRequest = function(challengeInstanceId, message, onResponse )
{
    var request = {};
		request["challengeInstanceId"] = challengeInstanceId;
		request["message"] = message;
    gamesparks.sendWithData("DeclineChallengeRequest", request, onResponse);
}
GameSparks.prototype.deviceAuthenticationRequest = function(deviceId, deviceModel, deviceName, deviceOS, deviceType, operatingSystem, onResponse )
{
    var request = {};
		request["deviceId"] = deviceId;
		request["deviceModel"] = deviceModel;
		request["deviceName"] = deviceName;
		request["deviceOS"] = deviceOS;
		request["deviceType"] = deviceType;
		request["operatingSystem"] = operatingSystem;
    gamesparks.sendWithData("DeviceAuthenticationRequest", request, onResponse);
}
GameSparks.prototype.dismissMessageRequest = function(messageId, onResponse )
{
    var request = {};
		request["messageId"] = messageId;
    gamesparks.sendWithData("DismissMessageRequest", request, onResponse);
}
GameSparks.prototype.endSessionRequest = function(onResponse )
{
    var request = {};
    gamesparks.sendWithData("EndSessionRequest", request, onResponse);
}
GameSparks.prototype.facebookConnectRequest = function(accessToken, code, onResponse )
{
    var request = {};
		request["accessToken"] = accessToken;
		request["code"] = code;
    gamesparks.sendWithData("FacebookConnectRequest", request, onResponse);
}
GameSparks.prototype.findChallengeRequest = function(accessType, count, offset, onResponse )
{
    var request = {};
		request["accessType"] = accessType;
		request["count"] = count;
		request["offset"] = offset;
    gamesparks.sendWithData("FindChallengeRequest", request, onResponse);
}
GameSparks.prototype.getChallengeRequest = function(challengeInstanceId, message, onResponse )
{
    var request = {};
		request["challengeInstanceId"] = challengeInstanceId;
		request["message"] = message;
    gamesparks.sendWithData("GetChallengeRequest", request, onResponse);
}
GameSparks.prototype.getDownloadableRequest = function(shortCode, onResponse )
{
    var request = {};
		request["shortCode"] = shortCode;
    gamesparks.sendWithData("GetDownloadableRequest", request, onResponse);
}
GameSparks.prototype.getMessageRequest = function(messageId, onResponse )
{
    var request = {};
		request["messageId"] = messageId;
    gamesparks.sendWithData("GetMessageRequest", request, onResponse);
}
GameSparks.prototype.getRunningTotalsRequest = function(friendIds, shortCode, onResponse )
{
    var request = {};
		request["friendIds"] = friendIds;
		request["shortCode"] = shortCode;
    gamesparks.sendWithData("GetRunningTotalsRequest", request, onResponse);
}
GameSparks.prototype.getUploadUrlRequest = function(uploadData, onResponse )
{
    var request = {};
		request["uploadData"] = uploadData;
    gamesparks.sendWithData("GetUploadUrlRequest", request, onResponse);
}
GameSparks.prototype.getUploadedRequest = function(uploadId, onResponse )
{
    var request = {};
		request["uploadId"] = uploadId;
    gamesparks.sendWithData("GetUploadedRequest", request, onResponse);
}
GameSparks.prototype.googlePlayBuyGoodsRequest = function(currencyCode, signature, signedData, subUnitPrice, onResponse )
{
    var request = {};
		request["currencyCode"] = currencyCode;
		request["signature"] = signature;
		request["signedData"] = signedData;
		request["subUnitPrice"] = subUnitPrice;
    gamesparks.sendWithData("GooglePlayBuyGoodsRequest", request, onResponse);
}
GameSparks.prototype.iOSBuyGoodsRequest = function(currencyCode, receipt, sandbox, subUnitPrice, onResponse )
{
    var request = {};
		request["currencyCode"] = currencyCode;
		request["receipt"] = receipt;
		request["sandbox"] = sandbox;
		request["subUnitPrice"] = subUnitPrice;
    gamesparks.sendWithData("IOSBuyGoodsRequest", request, onResponse);
}
GameSparks.prototype.joinChallengeRequest = function(challengeInstanceId, message, onResponse )
{
    var request = {};
		request["challengeInstanceId"] = challengeInstanceId;
		request["message"] = message;
    gamesparks.sendWithData("JoinChallengeRequest", request, onResponse);
}
GameSparks.prototype.leaderboardDataRequest = function(challengeInstanceId, entryCount, friendIds, leaderboardShortCode, offset, social, onResponse )
{
    var request = {};
		request["challengeInstanceId"] = challengeInstanceId;
		request["entryCount"] = entryCount;
		request["friendIds"] = friendIds;
		request["leaderboardShortCode"] = leaderboardShortCode;
		request["offset"] = offset;
		request["social"] = social;
    gamesparks.sendWithData("LeaderboardDataRequest", request, onResponse);
}
GameSparks.prototype.listAchievementsRequest = function(onResponse )
{
    var request = {};
    gamesparks.sendWithData("ListAchievementsRequest", request, onResponse);
}
GameSparks.prototype.listChallengeRequest = function(entryCount, offset, shortCode, state, onResponse )
{
    var request = {};
		request["entryCount"] = entryCount;
		request["offset"] = offset;
		request["shortCode"] = shortCode;
		request["state"] = state;
    gamesparks.sendWithData("ListChallengeRequest", request, onResponse);
}
GameSparks.prototype.listChallengeTypeRequest = function(onResponse )
{
    var request = {};
    gamesparks.sendWithData("ListChallengeTypeRequest", request, onResponse);
}
GameSparks.prototype.listGameFriendsRequest = function(onResponse )
{
    var request = {};
    gamesparks.sendWithData("ListGameFriendsRequest", request, onResponse);
}
GameSparks.prototype.listInviteFriendsRequest = function(onResponse )
{
    var request = {};
    gamesparks.sendWithData("ListInviteFriendsRequest", request, onResponse);
}
GameSparks.prototype.listLeaderboardsRequest = function(onResponse )
{
    var request = {};
    gamesparks.sendWithData("ListLeaderboardsRequest", request, onResponse);
}
GameSparks.prototype.listMessageRequest = function(entryCount, offset, onResponse )
{
    var request = {};
		request["entryCount"] = entryCount;
		request["offset"] = offset;
    gamesparks.sendWithData("ListMessageRequest", request, onResponse);
}
GameSparks.prototype.listMessageSummaryRequest = function(entryCount, offset, onResponse )
{
    var request = {};
		request["entryCount"] = entryCount;
		request["offset"] = offset;
    gamesparks.sendWithData("ListMessageSummaryRequest", request, onResponse);
}
GameSparks.prototype.listVirtualGoodsRequest = function(onResponse )
{
    var request = {};
    gamesparks.sendWithData("ListVirtualGoodsRequest", request, onResponse);
}
GameSparks.prototype.logChallengeEventRequest = function(challengeInstanceId, eventKey, onResponse )
{
    var request = {};
		request["challengeInstanceId"] = challengeInstanceId;
		request["eventKey"] = eventKey;
    gamesparks.sendWithData("LogChallengeEventRequest", request, onResponse);
}
GameSparks.prototype.logEventRequest = function(eventKey, onResponse )
{
    var request = {};
		request["eventKey"] = eventKey;
    gamesparks.sendWithData("LogEventRequest", request, onResponse);
}
GameSparks.prototype.pushRegistrationRequest = function(deviceOS, pushId, onResponse )
{
    var request = {};
		request["deviceOS"] = deviceOS;
		request["pushId"] = pushId;
    gamesparks.sendWithData("PushRegistrationRequest", request, onResponse);
}
GameSparks.prototype.registrationRequest = function(displayName, password, userName, onResponse )
{
    var request = {};
		request["displayName"] = displayName;
		request["password"] = password;
		request["userName"] = userName;
    gamesparks.sendWithData("RegistrationRequest", request, onResponse);
}
GameSparks.prototype.sendFriendMessageRequest = function(friendIds, message, onResponse )
{
    var request = {};
		request["friendIds"] = friendIds;
		request["message"] = message;
    gamesparks.sendWithData("SendFriendMessageRequest", request, onResponse);
}
GameSparks.prototype.socialLeaderboardDataRequest = function(challengeInstanceId, entryCount, friendIds, leaderboardShortCode, offset, social, onResponse )
{
    var request = {};
		request["challengeInstanceId"] = challengeInstanceId;
		request["entryCount"] = entryCount;
		request["friendIds"] = friendIds;
		request["leaderboardShortCode"] = leaderboardShortCode;
		request["offset"] = offset;
		request["social"] = social;
    gamesparks.sendWithData("SocialLeaderboardDataRequest", request, onResponse);
}
GameSparks.prototype.twitterConnectRequest = function(accessSecret, accessToken, onResponse )
{
    var request = {};
		request["accessSecret"] = accessSecret;
		request["accessToken"] = accessToken;
    gamesparks.sendWithData("TwitterConnectRequest", request, onResponse);
}
GameSparks.prototype.windowsBuyGoodsRequest = function(currencyCode, receipt, subUnitPrice, onResponse )
{
    var request = {};
		request["currencyCode"] = currencyCode;
		request["receipt"] = receipt;
		request["subUnitPrice"] = subUnitPrice;
    gamesparks.sendWithData("WindowsBuyGoodsRequest", request, onResponse);
}
GameSparks.prototype.withdrawChallengeRequest = function(challengeInstanceId, message, onResponse )
{
    var request = {};
		request["challengeInstanceId"] = challengeInstanceId;
		request["message"] = message;
    gamesparks.sendWithData("WithdrawChallengeRequest", request, onResponse);
}


angular.module("cogniss").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/activityhistory/activityhistory.html","<div class=activity-history><div class=filter-controls><div class=date-picker><div class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=start is-open=startDateOpen datepicker-options=startDateOptions class=form-control><div data-ng-click=\"startDateOpen = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div><span class=date-dash></span><div class=date-picker><div class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=end is-open=endDateOpen datepicker-options=endDateOptions class=form-control><div data-ng-click=\"endDateOpen = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div><div class=pull-right><div ng-hide=subject class=ui-select><select ng-model=selectedSubject ng-options=\"subject.name for subject in subjects\"></select></div></div></div><div class=table-reponsive><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th translate=NAME ng-show=\"playerIds.length &gt; 1\"></th><th translate=START_DATE></th><th translate=SUBJECT></th><th translate=TOPIC></th><th translate=SCORE></th><th translate=CORRECT_PERCENT></th><th translate=COMPLETE_DATE></th></tr></thead><tbody><tr data-ng-repeat=\"response in activityResponses | orderBy: \'-date\'\" data-ng-click=selectActivityResponse(response)><td ng-show=\"playerIds.length &gt; 1\">{{response.playerId | displayName}}</td><td>{{response.date | date:\'MMM d, y h:mm a\'}}</td><td>{{response.subjectId | subjectName}}</td><td>{{response.topicId | topicName}}</td><td>{{response.score}}</td><td><span ng-show=response.correctPercent>{{response.correctPercent}}%</span></td><td>{{response.completeDate | date:\'shortTime\'}}</td></tr></tbody></table></div><!--p index {{skip}}--><!--p limit {{limit}}--><!--p max {{max}}--><div data-cg-pagination index=skip limit=limit max=max class=pagination></div></div>");
$templateCache.put("app/components/behavioreditor/behavioreditor.html","<div class=row><div class=col-md-3><ul class=\"behaviors-list list-group\"><li ng-repeat=\"behavior in behaviors\" ng-click=selectBehavior(behavior) class=\"behaviors-list-item list-group-item\"><i class=\"fa fa-bolt\"></i><span ng-show=behavior.name>&nbsp; {{behavior.name}}</span><span ng-hide=behavior.name>&nbsp; {{behavior.triggers[0].type | translate}}</span></li></ul><button translate=NEW_BEHAVIOR ng-click=newBehavior() class=\"btn btn-default button-new-behavior\"></button></div><div class=col-md-9><div class=panel><div class=panel-body><div class=form-group><label translate=BEHAVIOR_TEMPLATE></label><select ng-model=selectedBehaviorTemplate ng-change=copyBehavior() class=form-control><option value=\"\" translate=SELECT_ONE></option><option ng-repeat=\"behavior in templateBehaviors\" ng-value=behavior>{{behavior.name}}</option></select></div></div></div><div class=panel><div class=panel-body><h4 translate=BEHAVIOR></h4><form name=behaviorEditor ng-submit=saveBehavior><div cg-behavior-input behavior=formData tenant=tenant team=team playerid=playerId class=behavior-input></div><button translate=ARCHIVE ng-click=archiveBehavior(editBehavior) ng-disabled=!formData.id class=\"btn btn-danger button-archive-behavior\"></button> <button translate=SAVE ng-click=saveBehavior() data-ng-disabled=behaviorEditor.$invalid class=\"btn btn-success button-save-behavior\"></button></form></div></div></div></div>");
$templateCache.put("app/components/behaviorinput/behaviorinput.html","<div class=form-group><label translate=BEHAVIOR_NAME></label><input type=text ng-model=behavior.name class=\"form-control input-name\"></div><div class=panel><label translate=TRIGGERS></label><div class=panel-body><ul class=\"options-list list-group\"><li ng-repeat=\"trigger in behavior.triggers\" class=\"options-list-item list-group-item\"><div cg-trigger-input trigger=trigger types=enabledTriggerTypes tenant=tenant class=trigger-input></div><div class=form-group><button translate=DELETE ng-click=deleteTrigger(trigger) ng-hide=\"behavior.triggers.length==1\" class=\"btn btn-danger\"></button></div></li></ul><div class=form-group><button translate=ADD ng-click=addTrigger() class=\"btn btn-default\"></button></div></div></div><div class=panel><label translate=CRITERIA></label><div class=panel-body><ul class=\"options-list list-group\"><li ng-repeat=\"criteria in behavior.criteria\" class=\"options-list-item list-group-item\"><div cg-criteria-input criteria=criteria types=enabledCriteriaTypes tenant=tenant class=criteria-input></div><div class=form-group><button translate=DELETE ng-click=deleteCriteria(criteria) class=\"btn btn-danger\"></button></div></li></ul><div class=form-group><button translate=ADD ng-click=addCriteria() class=\"btn btn-default\"></button></div></div></div><div class=panel><label translate=RESULTS></label><div class=panel-body><ul class=\"options-list list-group\"><li ng-repeat=\"result in behavior.results\" class=\"options-list-item list-group-item\"><div cg-result-input result=result types=enabledResultTypes class=result-input></div><div class=form-group><button translate=DELETE ng-click=deleteResult(result) ng-hide=\"behavior.results.length==1\" class=\"btn btn-danger\"></button></div></li></ul><div class=form-group><button translate=ADD ng-click=addResult() class=\"btn btn-default\"></button></div></div></div><div class=form-group><label class=ui-checkbox><input type=checkbox ng-model=behavior.open><span translate=BEHAVIOR_OPEN></span></label></div><div class=form-group><label class=ui-checkbox><input type=checkbox ng-model=behavior.recurring><span translate=BEHAVIOR_RECURRING></span></label></div><div class=form-group><label class=ui-checkbox><input type=checkbox ng-model=behavior.template><span translate=BEHAVIOR_TEMPLATE></span></label></div>");
$templateCache.put("app/components/footer/footer.html","<footer class=\"footer bg-dark\"></footer>");
$templateCache.put("app/components/header/header.html","<header class=\"top-header clearfix\"><div ng-show=\"pendingCount == 0\" class=no-pending>&nbsp;</div><!-- Logo--><!--.logo(ng-class=\"{ \'bg-dark\': [\'11\',\'31\'].indexOf(main.skin) >= 0,\\\n  \'bg-white\': main.skin === \'21\',\\\n  \'bg-primary\': [\'12\',\'22\',\'32\'].indexOf(main.skin) >= 0,\\\n  \'bg-success\': [\'13\',\'23\',\'33\'].indexOf(main.skin) >= 0,\\\n  \'bg-info-alt\': [\'14\',\'24\',\'34\'].indexOf(main.skin) >= 0,\\\n  \'bg-warning\': [\'15\',\'25\',\'35\'].indexOf(main.skin) >= 0,\\\n  \'bg-danger\': [\'16\',\'26\',\'36\'].indexOf(main.skin) >= 0,\\\n  }\")\n  --><div class=top-nav><div class=logo><div class=space><a href=javascript:; ui-sref=tenant.users><span class=logo-text>{{ \'COGNISS\' | translate}}</span></a></div></div><ul class=\"nav-right pull-right list-unstyled\"><li ng-hide=true uib-dropdown=\"\" is-open=status.isopenLang class=\"dropdown langs text-normal\"><a href=javascript:; uib-dropdown-toggle=\"\" ng-disabled=disabled class=active-flag><div class=\"flag {{ getFlag() }}\"></div></a><ul role=menu uib-dropdown-menu=\"\" class=\"dropdown-menu with-arrow list-langs pull-right dropdown-menu-scaleIn\"><li data-ng-show=\"lang !== \'English\' \"><a href=javascript:; data-ng-click=\"setLang(\'English\')\"><div class=\"flag flags-american\"></div>English</a></li><li data-ng-show=\"lang !== \'Deutsch\' \"><a href=javascript:; data-ng-click=\"setLang(\'Deutsch\')\"><div class=\"flag flags-germany\"></div>German</a></li></ul></li><div ng-show=user class=\"nav-right pull-right list-unstyled\"><li uib-dropdown=\"\" is-open=status.isopenProfile class=\"dropdown text-normal nav-profile\"><a href=javascript:; uib-dropdown-toggle=\"\" ng-disabled=disabled class=button-profile-dropdown><i class=\"fa fa-user\"></i><span class=hidden-xs><span class=display-name-header>{{ user.displayName }}</span></span></a><ul uib-dropdown-menu=\"\" class=\"dropdown-menu with-arrow pull-right dropdown-menu-scaleIn\"><li><a ng-click=logout() class=button-logout><i class=\"fa fa-sign-out\"></i> <!--span(data-translate=\'LOG_OUT\')--><span>{{ \'LOG_OUT\' | translate}}</span></a></li></ul></li></div></ul></div></header>");
$templateCache.put("app/components/modal/modal.html","<div class=modal-service-modal><div class=modal-header><button type=button data-dismiss=modal aria-label=Close ng-hide=\"close === false\" ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button><h4 class=modal-title>{{title}}</h4></div><div class=modal-body><p>{{body}}</p></div><div ng-hide=\"footer === false\" class=modal-footer><button type=button data-dismiss=modal ng-click=$dismiss() class=\"btn btn-default modal-button-dismiss\">{{dismissLabel}}</button> <button type=button ng-click=accept() ng-show=accept class=\"btn btn-primary button-confirm\">{{acceptLabel}}</button></div></div>");
$templateCache.put("app/components/profilepanel/profilepanel.html","<div class=\"panel panel-profile\"><div ng-style=\"{\'background-image\':\'url(\' + (tenant.backgroundTexture | uploadURL) + \')\'}\" class=\"panel-heading bg-success\"><span class=\"pull-left profile\"><img ng-src={{userDetails.profileImage}} ng-show=userDetails.profileImage class=\"img-circle img80_80\"><div ng-hide=userDetails.profileImage class=icon-container><i class=\"fa fa-user\"></i></div></span><h3 class=user-name>{{userDetails.displayName}}</h3><button ng-hide=getIsCurrentUser() ng-click=deleteUser() class=\"btn btn-success pull-right button-remove-user\">{{ \'REMOVE_USER\' | translate}}</button></div></div>");
$templateCache.put("app/components/notes/addnote.modal.html","<div class=note-modal><form name=noteForm ng-submit=saveNote(note) class=form-horizontal><div class=modal-header><button type=button data-dismiss=modal aria-label=Close ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button><h4 class=modal-title>{{\'ADD_NOTE\' | translate | titlecase}}</h4></div><div class=modal-body><div class=form-group><label translate=TYPE class=\"col-sm-2 control-label\"></label><div class=col-sm-10><select ng-model=note.type required class=form-control><option ng-repeat=\"type in noteTypes\" value={{type}}>{{type | translate}}</option></select></div></div><div class=form-group><label translate=DESCRIPTION class=\"col-sm-2 control-label\"></label><div class=col-sm-10><textarea ng-model=note.text required data-ng-minlength=1 class=form-control></textarea></div></div><div class=form-group><label translate=DUE class=\"col-sm-2 control-label\"></label><div class=col-sm-4><div class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=note.dueDate is-open=dueDateOpen datepicker-options=dueDateOptions class=form-control><div data-ng-click=\"dueDateOpen = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div></div></div><div class=modal-footer><button type=button ng-click=$dismiss() class=\"btn btn-default\">Cancel</button> <button type=button ng-click=saveNote(note) data-ng-disabled=noteForm.$invalid class=\"btn btn-primary button-submit-code\">Add</button></div></form></div>");
$templateCache.put("app/components/notes/note.modal.html","<div class=note-modal><div class=modal-header><button type=button data-dismiss=modal aria-label=Close ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button><h4 class=modal-title>{{note.playerId | displayName}}</h4></div><div class=modal-body><p></p><h4 translate=DATE></h4><span>{{note.created | date:\'MMM d, y h:mm a\'}}</span><p></p><p></p><h4 translate=AUTHOR></h4><span>{{note.authorId | displayName}}</span><p></p><p></p><h4 translate=TYPE></h4><span ng-show=\"note.type == noteTypes.FOLLOW_UP\" class=\"glyphicon glyphicon-ok-sign\">&nbsp;</span><span ng-show=\"note.type == noteTypes.EMAIL\" class=\"glyphicon glyphicon-envelope\">&nbsp;</span><span ng-show=\"note.type == noteTypes.NOTE\" class=\"glyphicon glyphicon-list-alt\">&nbsp;</span><span ng-show=\"note.type == noteTypes.PHONE_CALL\" class=\"glyphicon glyphicon-earphone\">&nbsp;</span><span>{{note.type | translate}}</span><p></p><p></p><h4 translate=DESCRIPTION></h4><span>{{note.text}}</span><p></p><form name=noteForm ng-submit=saveNote(note) class=form-horizontal><div class=form-group><div class=col-sm-4><h4 translate=DUE></h4><div class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=note.dueDate is-open=dueDateOpen datepicker-options=dueDateOptions class=form-control><div data-ng-click=\"dueDateOpen = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div></div><div class=form-group><div class=col-sm-4><label class=ui-checkbox><input type=checkbox ng-model=note.complete><span translate=COMPLETE></span></label></div></div><div class=form-group><div class=col-sm-4><button type=button ng-click=saveNote(note) data-ng-disabled=noteForm.$invalid class=\"btn btn-primary button-submit-code\">Save</button></div></div></form><h3 translate=COMMENTS></h3><div class=form-group><textarea ng-model=commentText required data-ng-minlength=1 class=form-control></textarea></div><p><button type=button ng-click=saveComment(commentText) translate=SUBMIT class=\"btn btn-primary\"></button></p><ol class=list-group><li ng-repeat=\"comment in note.comments\" class=list-group-item><div class=row><div class=col-xs-3><span class=profile><img ng-src={{userDetails.profileImage}} ng-show=userDetails.profileImage class=\"img-circle img80_80\"><div ng-hide=userDetails.profileImage class=icon-container><i class=\"fa fa-user\"></i></div></span><p>{{comment.playerId | displayName}}</p></div><div class=col-xs-9><p>{{comment.text}}</p><p>{{comment.created | date:\'MMM d, y h:mm a\'}}</p></div></div></li></ol></div><div class=modal-footer><button type=button ng-click=$dismiss() class=\"btn btn-default\">Cancel</button></div></div>");
$templateCache.put("app/components/notes/notes.html","<div class=notes-history><div class=filter-controls><div class=date-picker><div class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=start is-open=startDateOpen datepicker-options=startDateOptions class=form-control><div data-ng-click=\"startDateOpen = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div><span class=date-dash></span><div class=date-picker><div class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=end is-open=endDateOpen datepicker-options=endDateOptions class=form-control><div data-ng-click=\"endDateOpen = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div><button translate=ADD_NOTE ng-click=addNote() ng-show=showAddNoteButton class=\"btn btn-primary pull-right\"></button></div><div class=table-reponsive><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th translate=NAME ng-show=\"playerIds.length &gt; 1\"></th><th translate=CREATION_DATE></th><th translate=AUTHOR></th><th translate=TYPE></th><th translate=DESCRIPTION></th><th translate=DUE_DATE></th><th translate=COMPLETE></th></tr></thead><tbody><tr data-ng-repeat=\"note in notes | orderBy: \'-created\'\" ng-click=selectNote(note)><td ng-show=\"playerIds.length &gt; 1\">{{note.playerId | displayName}}</td><td>{{note.created | date:\'MMM d, y h:mm a\'}}</td><td>{{note.authorId | displayName}}</td><td><span ng-show=\"note.type == noteTypes.FOLLOW_UP\" class=\"glyphicon glyphicon-ok-sign\">&nbsp;</span><span ng-show=\"note.type == noteTypes.EMAIL\" class=\"glyphicon glyphicon-envelope\">&nbsp;</span><span ng-show=\"note.type == noteTypes.NOTE\" class=\"glyphicon glyphicon-list-alt\">&nbsp;</span><span ng-show=\"note.type == noteTypes.PHONE_CALL\" class=\"glyphicon glyphicon-earphone\">&nbsp;</span><span>{{note.type | translate}}</span></td><td><span>{{note.text}} &nbsp;</span><span ng-show=\"note.comments.length &gt; 0\" class=pull-right><i class=\"fa fa-comments color-info\"></i></span></td><td>{{note.dueDate | date:\'MMM d, y\'}}</td><td>{{note.complete ? \'complete\': \'\'}}</td></tr></tbody></table></div><div data-cg-pagination index=skip limit=limit max=max class=pagination></div></div>");
$templateCache.put("app/components/pagination/pagination.html","<ul class=pagination><li data-ng-class=\"{disabled:index == 0 || displayPages.length == 0}\"><a href=JavaScript:void(0); data-ng-click=first()>&laquo;</a></li><li data-ng-class=\"{disabled:index == 0 || displayPages.length == 0}\"><a href=JavaScript:void(0); data-ng-click=previous()>&lt;</a></li><li data-ng-repeat=\"page in displayPages\" data-ng-class={active:page.current}><a href=JavaScript:void(0); data-ng-click=goPage(page)>{{page.index+1}}</a></li><li data-ng-class=\"{disabled:index &gt;= lastPage.first || displayPages.length == 0}\"><a href=JavaScript:void(0); data-ng-click=next()>&gt;</a></li><li data-ng-class=\"{disabled:index &gt;= lastPage.first || displayPages.length == 0}\"><a href=JavaScript:void(0); data-ng-click=last()>&raquo;</a></li></ul>");
$templateCache.put("app/components/questioninput/questioninput.html","<div class=question-input><div ng-if=\"topic.questionType == QuestionTypes.MULTICHOICE\" cg-question-input-multichoice question=$parent.question topic=$parent.topic></div><div ng-if=\"topic.questionType == QuestionTypes.FILL_BLANKS\" cg-question-input-fill-blanks question=$parent.question></div><div ng-if=\"topic.questionType == QuestionTypes.EQUATION\" cg-question-input-equation question=$parent.question></div><div ng-if=\"topic.questionType == QuestionTypes.TEXT_RANGE\" cg-question-input-text-range question=$parent.question></div><div ng-if=\"topic.questionType == QuestionTypes.IMAGE_RESPONSE\" cg-question-input-image-response question=$parent.question topic=$parent.topic></div><div ng-if=\"topic.questionType == QuestionTypes.AUDIO_RESPONSE\" cg-question-input-audio-response question=$parent.question topic=$parent.topic></div><div ng-if=\"topic.questionType == QuestionTypes.CATEGORISATION\" cg-question-input-categorisation question=$parent.question></div><div ng-if=\"noQuestionType || topic.questionType == QuestionTypes.TEMPLATE_INTERPRETED\" cg-question-input-template-interpreted question=$parent.question></div><div ng-if=\"topic.topicType == TopicTypes.PLACEMENT\" class=form-group><label translate=QUESTION_PLACEMENT_TOPIC></label><div class=ui-select><select ng-model=$parent.question.placementTopicId required class=input-next-topic><option value=\"\">none</option><option ng-repeat=\"topic in topics | orderBy : \'name\'\" value={{topic.id}}>{{topic.name}}</option></select></div></div></div>");
$templateCache.put("app/components/sidebar/sidebar.html","<div ng-show=user class=nav-wrapper><ul id=nav data-slim-scroll=\"\" data-accordion-nav=\"\" data-highlight-active=\"\" class=nav><li ng-repeat=\"tenant in tenants\" ng-if=tenant.insights><a ng-click=selectTenant(tenant) href=JavaScript:void(0); class=tenant-link><i class=\"fa fa-dashboard\"><span class=\"icon-bg bg-success\"></span></i><span>{{tenant.name}}</span></a></li><li><a ui-sref=teams.overview class=button-teams><i class=\"color-info fa fa-users\"></i><span>{{ \'TEAMS\' | translate}}</span></a></li><li ng-if=userDetails.admin><a ui-sref=admin.templates class=button-admin><i class=\"color-warning fa fa-cogs\"></i><span>{{ \'ADMIN\' | translate}}</span></a></li></ul></div>");
$templateCache.put("app/components/splash/splash.html","<div class=splash-container><h1>Cogniss</h1><div class=spinner></div></div>");
$templateCache.put("app/components/teamprofilepanel/teamprofilepanel.html","<div ng-style=\"{\'background-image\':\'url(\' + tenant.backgroundTexture + \')\'}\" class=\"panel panel-profile bg-info team-profile-panel\"><div class=panel-heading><span class=pull-left><span class=\"btn-icon btn-icon-lg-alt\"><i class=\"fa fa-users\"></i></span></span><h3 class=team-name>{{team.name}}</h3><p class=team-description>{{team.description}}</p><button data-ng-click=leaveTeam() data-ng-hide=\"team.owner.id == user.userId\" translate=LEAVE_TEAM class=\"btn btn-info pull-right button-leave-team\"></button> <button data-ng-click=addCode() data-ng-show=\"team.owner.id == user.userId\" translate=ADD_TEAM_CODE class=\"btn btn-info pull-right button-add-code\"></button> <button data-ng-click=disbandTeam() data-ng-show=\"team.owner.id == user.userId\" translate=DISBAND_TEAM class=\"btn btn-info pull-right button-disband-team\"></button> <button ui-sref=tenant.team.behaviors data-ng-show=\"team.owner.id == user.userId\" translate=BEHAVIORS class=\"btn btn-info pull-right button-behaviors\"></button></div></div>");
$templateCache.put("app/components/teamthumb/teamthumb.html","<div class=\"panel panel-box teamthumb\"><div ng-style=\"{\'background-image\': \'url(\' + tenant.backgroundTexture +\')\'}\" class=\"panel-top bg-success\"><span class=\"pull-left profile\"></span><div class=text-center><h3><span class=tenant-thumb-user-name>{{team.name}}</span><i class=\"fa fa-chevron-right\"></i></h3></div><!--.divider.divider-xl--><!--.divider.divider-lg--></div><div ng-if=!team.profileImage class=\"panel-icon bg-info\"><i class=\"fa fa-users\"></i></div><div ng-if=team.profileImage class=\"panel-img bg-white\"><img ng-src={{team.profileImage}} class=img-circle></div><div class=list-justified-container><ul ng-show=questionAggregate class=\"list-justified text-center\"><li><p class=size-h3>{{questionAggregate.topicPlayed | number : 0}}</p><p class=text-muted>Topics played</p></li><li><p class=size-h3>{{questionAggregate.attempted | number : 0}}</p><p class=text-muted>Questions answered</p></li></ul></div></div>");
$templateCache.put("app/components/upload/upload.html","<div class=upload><div ng-if=uploader class=form-group><input type=file nv-file-select=\"\" uploader=uploader accept={{accept}}></div></div>");
$templateCache.put("app/components/userthumb/userthumb.html","<div class=\"panel panel-box userthumb\"><div ng-style=\"{\'background-image\': \'url(\' + (tenant.backgroundTexture | uploadURL) +\')\'}\" class=\"panel-top bg-success\"><span class=\"pull-left profile\"></span><div class=text-center><h3><span class=tenant-thumb-user-name>{{details.displayName}}</span><i class=\"fa fa-chevron-right\"></i></h3></div><!--.divider.divider-xl--><!--.divider.divider-lg--></div><div ng-if=!details.profileImage class=\"panel-icon bg-success\"><i class=\"fa fa-user\"></i></div><div ng-if=details.profileImage class=\"panel-img bg-white\"><img ng-src={{details.profileImage}} class=img-circle></div><div class=list-justified-container><ul ng-show=questionAggregate class=\"list-justified text-center\"><li><p class=size-h3>{{questionAggregate.topicPlayed}}</p><p class=text-muted>Topics played</p></li><li><p class=size-h3>{{questionAggregate.attempted}}</p><p class=text-muted>Questions answered</p></li></ul></div></div>");
$templateCache.put("app/screens/admin/admin.html","<div class=screen-admin><h2>{{ \'ADMIN\' | translate}}</h2><div class=row><div class=col-md-12><ul class=\"nav nav-boxed nav-justified\"><li><a ui-sref=admin.templates() class=button-subjects><i class=\"color-info fa fa-gamepad\"></i><span>{{ \'TEMPLATES\' | translate}}</span></a></li><li><a ui-sref=admin.tenants() class=button-subjects><i class=\"color-danger fa fa-cube\"></i><span>{{ \'TENANTS\' | translate}}</span></a></li><li><a ui-sref=admin.behaviors() class=button-subjects><i class=\"color-warning fa fa-bolt\"></i><span>{{ \'BEHAVIORS\' | translate}}</span></a></li><li></li><li></li><li></li><li></li><li></li></ul></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div>");
$templateCache.put("app/screens/main/main.html","<div class=page><section class=\"panel panel-default\"><div class=panel-heading><strong><span class=\"glyphicon glyphicon-th\"></span> Cogniss web client</strong></div><div class=panel-body><p>Content goes here</p></div></section></div>");
$templateCache.put("app/screens/register/register.html","<div class=page-register><div class=\"signin-header hidden-xs\"><div class=\"container text-center\"><section class=logo><a ui-sref=login>{{ \'COGNISS\' | translate}}</a></section></div></div><div class=main-body><div class=container><div class=form-container><section class=\"info text-center\"><h2>{{ \'SIGN_UP_INFO\' | translate}}</h2></section><section><form ng-submit=register() name=registerForm novalidate class=\"form-horizontal form-validation\"><div class=form-group><div class=\"input-group input-group-lg\"><span class=input-group-addon><span class=\"glyphicon glyphicon-user\"></span></span> <input type=text placeholder=\"User name\" ng-model=user.userName required data-ng-minlength=4 maxlength=20 pattern=^$|^[A-Za-z0-9]+ class=form-control></div></div><div class=form-group><div class=\"input-group input-group-lg\"><span class=input-group-addon><span class=\"glyphicon glyphicon-envelope\"></span></span> <input type=email placeholder=Email ng-model=user.email required maxlength=254 class=form-control></div></div><div class=form-group><div class=\"input-group input-group-lg\"><span class=input-group-addon><span class=\"glyphicon glyphicon-lock\"></span></span> <input type=password placeholder=Password ng-model=user.password required data-ng-minlength=6 maxlength=256 class=form-control></div></div><div class=form-group><p class=\"text-muted text-small\">{{ \'CLICK_AGREEMENT\' | translate}}<a href=javascript:;>{{ \'TERMS_CONDITIONS\' | translate}}</a> {{ \'AND\' | translate}} <a href=javascript:;>{{ \'PRIVACY_POLICY\' | translate}}</a></p><div class=divider></div><button id=button-register type=submit data-ng-disabled=registerForm.$invalid class=\"btn btn-primary btn-block btn-lg\">{{ \'SIGN_UP\' | translate}}</button></div></form></section><section><p class=\"text-center text-muted\">{{ \'HAVE_ACCOUNT\' | translate}}<a ui-sref=login>{{ \'LOG_IN_NOW\' | translate}}</a></p></section></div></div></div></div>");
$templateCache.put("app/screens/login/login.html","<div class=page-login><div class=main-body><div class=container><div class=top-form-container><section class=\"info text-center\"><h1 class=hidden-xs>Cogniss. Your gateway to connected learning.</h1><h2 translate=SIGN_IN_INFO></h2></section></div><div class=form-container><form name=loginForm ng-submit=login() class=form-horizontal><fieldset><div class=form-group><div class=\"input-group input-group-lg\"><span class=input-group-addon><span class=\"glyphicon glyphicon-user\"></span></span> <input type=username placeholder=\"Cogniss username\" ng-model=user.userName required data-ng-minlength=4 class=form-control></div></div><div class=form-group><div class=\"input-group input-group-lg\"><span class=input-group-addon><span class=\"glyphicon glyphicon-lock\"></span></span> <input type=password placeholder=Password ng-model=user.password required data-ng-minlength=6 class=form-control></div></div><div class=form-group></div><div class=form-group><button id=button-login data-ng-disabled=loginForm.$invalid class=\"btn btn-primary btn-lg btn-block\">{{ \'LOG_IN\' | translate}}</button></div></fieldset></form><section><p class=text-center><a ui-sref=forgot>{{ \'FORGOT_PASSWORD\' | translate}}</a></p><p class=\"text-center text-muted text-small\">{{ \'NO_ACCOUNT\' | translate}}<a ui-sref=register>{{ \'SIGN_UP\' | translate}}</a></p></section></div><div class=bottom-form-container><section class=panel-box><div class=panel-bottom><ul class=\"list-justified text-center\"><li><a ng-href=http://www.cogniss.com/ target=_blank class=stem-explorer-link><img ng-src=assets/images/BRAIN_icon.png alt=\"Cogniss Brain Health\" class=app-image-properties><p class=\"hidden-xs text-muted\">Cogniss Brain Age</p></a></li><li><a ng-href=http://www.stemexplorer.com.au/ target=_blank class=stem-explorer-link><img ng-src=assets/images/STEM_icon.png alt=\"STEM Explorer\" class=app-image-properties><p class=\"hidden-xs text-muted\">STEM Explorer</p></a></li><li><a ng-href=# target=_blank class=stem-explorer-link><img ng-src=assets/images/KOALA_icon.png alt=\"Koala Academy\" class=app-image-properties><p class=\"hidden-xs text-muted\">Koala Academy</p></a></li></ul></div></section></div></div></div></div>");
$templateCache.put("app/screens/forgot/forgot.html","<div class=page-forgot><div class=signin-header><div class=\"container text-center\"><section class=logo><a ui-sref=login>{{ \'COGNISS\' | translate}}</a></section></div></div><div class=main-body><div class=container><div class=form-container><form name=forgotForm ng-submit=forgot() class=form-horizontal><fieldset><div class=form-group><div class=\"input-group input-group-lg\"><span class=input-group-addon><span class=\"glyphicon glyphicon-user\"></span></span> <input placeholder=\"Username or Email\" ng-model=userNameOrEmail required data-ng-minlength=4 class=form-control></div></div><div class=form-group><button data-ng-disabled=forgotForm.$invalid class=\"btn btn-primary btn-lg btn-block\">{{ \'FORGOT\' | translate}}</button></div></fieldset></form></div><section><p class=\"text-center text-muted\">{{ \'HAVE_ACCOUNT\' | translate}}<a ui-sref=login>{{ \'LOG_IN_NOW\' | translate}}</a></p></section></div></div></div>");
$templateCache.put("app/screens/teams/teams.html","<div class=screen-teams><div ui-view class=\"child-view animate-fade-up\"></div></div>");
$templateCache.put("app/screens/tenant/tenant-info-modal.html","<div class=tenant-info-modal><div class=modal-header><button type=button data-dismiss=modal aria-label=Close ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button><h4 class=modal-title><a class=\"btn-icon btn-icon-round btn-icon-sm bg-info\"><i class=\"fa fa-info\"></i></a><span class=tenant-info-title>{{tenant.name}}</span></h4></div><div class=modal-body><div class=row><div ng-bind-html=tenant.description ng-class=\"{\'col-md-8\':tenant.screenshot, \'col-md-12\':!tenant.screenshot}\" class=description></div><div ng-if=tenant.screenshot class=\"image col-md-4\">image</div></div><div ng-if=\"tenant.iosLink || tenant.androidLink\" class=well><h4>App download links</h4><p ng-if=tenant.iosLink><a ng-href={{tenant.iosLink}} target=_blank>iOS</a></p><p ng-if=tenant.androidLink><a ng-href={{tenant.androidLink}} target=_blank>Android</a></p></div><p><span>Find out more here: </span><a ng-href={{tenant.website}} target=_blank>{{tenant.website}}</a></p></div></div>");
$templateCache.put("app/screens/tenant/tenant.html","<div class=\"screen-tenant page\"><h1><img ng-show=tenant.insightsLogo ng-src=\"{{tenant.insightsLogo | uploadURL}}\" alt={{tenant.name}} class=tenant-logo><span ng-hide=tenant.insightsLogo class=tenant-name>{{tenant.name}}</span><a id=tenant-info href=javascript:; ng-click=showTenantInfo() class=\"btn-icon btn-icon-round btn-icon-sm bg-info\"><i class=\"fa fa-info\"></i></a></h1><div ng-show=topLevel class=\"row top-nav\"><div class=col-md-12><ul class=\"nav nav-boxed nav-justified\"><li><a ui-sref=tenant.users({tenantRef:tenant.urlName})><i class=\"color-success fa fa-user\"></i><span class=users-overview>{{ \'USERS\' | translate}}</span></a></li><li><a ui-sref=tenant.teams({tenantRef:tenant.urlName})><i class=\"color-info fa fa-users\"></i><span class=users-overview>{{ \'TEAMS\' | translate}}</span></a></li><li><a ui-sref=tenant.subjects({tenantRef:tenant.urlName}) class=button-content-overview><i class=\"color-primary fa fa-list\"></i><span class=content-overview>{{ \'CONTENT_OVERVIEW\' | translate}}</span></a></li><li><a ui-sref=tenant.content.subjects({tenantRef:tenant.urlName}) class=button-content-overview><i class=\"color-primary fa fa-list\"></i><span class=content-overview>{{ \'CONTENT\' | translate}}</span></a></li><li ng-if=\"userDetails.tenantDetails.admin || userDetails.admin\"><a ui-sref=tenant.admin.users({tenantRef:tenant.urlName}) class=button-tenant-admin><i class=\"color-warning fa fa-cogs\"></i><span class=admin-overview>{{ \'ADMIN\' | translate}}</span></a></li><li></li><li></li><li></li></ul></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div>");
$templateCache.put("app/screens/reset/reset.html","<div class=page-reset><div class=signin-header><div class=\"container text-center\"><section class=logo><a ui-sref=login>{{ \'COGNISS\' | translate}}</a></section></div></div><div class=main-body><div ng-show=\"state==\'users\'\" class=container><div class=\"panel panel-default\"><div class=panel-heading><strong><span class=\"glyphicon glyphicon-th\"></span><text>{{ \'SELECT_USER\' | translate}}</text></strong></div><ul class=list-group><li ng-repeat=\"id in userIds\" class=list-group-item><a ng-click=selectUser(id)>{{ id | displayName }}</a></li></ul></div></div><div ng-show=\"state==\'reset\'\" class=container><div class=form-container><form name=resetForm ng-submit=reset() class=form-horizontal><fieldset><div class=form-group><div class=\"input-group input-group-lg\"><span class=input-group-addon><span class=\"glyphicon glyphicon-lock\"></span></span> <input type=password placeholder=\"new password\" ng-model=password required data-ng-minlength=6 class=form-control></div></div><div class=form-group></div><div class=form-group><button data-ng-disabled=resetForm.$invalid class=\"btn btn-primary btn-lg btn-block\">{{ \'RESET_PASSWORD\' | translate}}</button></div></fieldset></form><section><p class=text-center><a ui-sref=login>{{ \'LOG_IN_NOW\' | translate}}</a></p></section></div></div></div></div>");
$templateCache.put("app/components/behaviorinput/activityselect/activityselect.html","<select ng-model=selectedActivity class=form-control><option ng-value=null translate=ANY_ACTIVITY></option><option ng-repeat=\"activity in content.activities\" ng-value=activity><span class=activity-display-topic>&nbsp; {{activity.topicId | topicName}}</span><span class=activity-display-template>&nbsp; {{activity.templateId | templateName}}</span></option></select>");
$templateCache.put("app/components/behaviorinput/criteriainput/criteriainput.html","<div class=form-group><label translate=CRITERIA_TYPE></label><select ng-model=criteria.type required ng-change=$parent.onChangeCriteriaType(criteria) class=form-control><option value=\"\" translate=SELECT_ONE></option><option ng-repeat=\"type in types\" value={{type}} translate={{type}}></option></select></div><div ng-if=selectActivity class=form-group><label translate=ACTIVITY></label><div cg-activity-select tenant=tenant activity-id=$parent.criteria.objectId class=activity-select></div></div><div ng-if=selectQuestion class=form-group><label translate=QUESTION></label><div cg-question-select tenant=tenant question-id=$parent.criteria.objectId class=activity-select></div></div><div ng-if=selectCount class=form-group><label translate=COUNT></label><input type=number ng-model=criteria.count min=1 class=form-control></div><div ng-if=selectAnswer class=form-group><label translate=ANSWER></label><input type=text ng-model=criteria.answer min=1 class=form-control></div><div ng-if=selectValue class=form-group><label translate=VALUE></label><input type=number ng-model=criteria.value class=form-control></div><div ng-if=selectValue class=form-group><label translate=MAX_VALUE></label><input type=number ng-model=criteria.valueMax class=form-control></div><div ng-if=selectValue class=form-group><label translate=MIN_VALUE></label><input type=number ng-model=criteria.valueMin class=form-control></div><div ng-if=selectScore class=form-group><label translate=VALUE></label><input type=number ng-model=criteria.value class=form-control></div><div ng-if=selectScore class=form-group><label translate=MAX_SCORE></label><input type=number ng-model=criteria.scoreMax class=form-control></div><div ng-if=selectScore class=form-group><label translate=MIN_SCORE></label><input type=number ng-model=criteria.scoreMin class=form-control></div><div class=form-group><label class=ui-checkbox><input type=checkbox ng-model=criteria.not><span translate=NOT_INVERSION></span></label></div>");
$templateCache.put("app/components/behaviorinput/questionselect/questionselect.html","<select ng-model=selectedTopic class=form-control><option ng-value=null translate=ANY_QUESTION></option><option ng-repeat=\"topic in content.topics\" ng-value=topic>{{topic.name}}</option></select><select ng-model=selectedQuestion ng-show=selectedTopic class=form-control><option ng-value=null translate=SELECT_ONE></option><option ng-repeat=\"question in content.questions | filter:{topicId:selectedTopic.id}\" ng-value=question><span ng-show=question.label>&nbsp; {{question.label}}</span><span ng-hide=question.label>&nbsp; {{question.text}}</span><span ng-hide=\"question.label || question.text\">&nbsp; {{question.id}}</span></option></select>");
$templateCache.put("app/components/behaviorinput/resultinput/resultinput.html","<div class=form-group><label translate=RESULT_TYPE></label><select ng-model=result.type required ng-change=$parent.onChangeResultType(result) class=form-control><option value=\"\" translate=SELECT_ONE></option><option ng-repeat=\"type in types\" value={{type}} translate={{type}}></option></select></div><div ng-if=\"result.type == resultTypes.XP || result.type == resultTypes.COINS\" class=form-group><label translate=QUANTITY></label><input type=number ng-model=result.quantity required class=form-control></div><div ng-if=\"result.type == resultTypes.NEWS || result.type == resultTypes.NOTE || result.type == resultTypes.NOTIFICATION\" class=form-group><label translate=TEXT></label><input type=text ng-model=result.text required class=form-control></div><div ng-if=\"result.type == resultTypes.VIRTUAL_GOOD\" class=form-group><label translate=CODE></label><input type=text ng-model=result.code required class=form-control></div>");
$templateCache.put("app/components/behaviorinput/triggerinput/triggerinput.html","<div class=form-group><label translate=TRIGGER_TYPE></label><select ng-model=trigger.type required ng-change=$parent.onChangeTriggerType(type) class=form-control><option value=\"\" translate=SELECT_ONE></option><option ng-repeat=\"type in types\" value={{type}} translate={{type}}></option></select></div><div ng-if=\"trigger.type == triggerTypes.SCHEDULED\"><div class=form-group><label translate=SCHEDULE_TYPE></label><select ng-model=scheduleType required class=form-control><option ng-repeat=\"type in scheduleTypes\" value={{type}}>{{type}}</option></select></div><div ng-show=\"scheduleType == scheduleTypes.DATE\" class=form-group><label translate=DATE></label><label translate=TIME></label><div class=row><div class=col-sm-4><div ng-if=\"scheduleType == scheduleTypes.DATE\" class=date-picker><div class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=$parent.$parent.date is-open=dateOpen datepicker-options=dateOptions class=form-control><div data-ng-click=\"dateOpen = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div></div><div class=col-sm-4><div class=row><div class=col><select ng-model=$parent.hour required class=form-control><option ng-repeat=\"h in hours\" ng-value=h>{{h.label}}</option></select></div><div class=col><span>:</span></div><div class=col><select ng-model=$parent.minute required class=form-control><option ng-repeat=\"m in minutes\" ng-value=m>{{m.label}}</option></select></div></div></div></div></div><div ng-if=\"scheduleType == scheduleTypes.TIME\" class=form-group><label translate=TIME></label><div class=row><div class=col-sm-4><select ng-model=hour required class=form-control><option ng-repeat=\"hour in hours\" ng-value=hour>{{hour.label}}</option></select><span>:</span><select ng-model=minute required class=form-control><option ng-repeat=\"minute in minutes\" ng-value=minute>{{minute.label}}</option></select></div></div></div><div ng-if=\"scheduleType == scheduleTypes.DURATION\" class=form-group><label translate=DURATION></label><input type=text ng-model=trigger.duration required class=form-control></div></div><div ng-if=selectActivity class=form-group><label translate=ACTIVITY></label><div cg-activity-select tenant=tenant activity-id=$parent.trigger.objectId class=activity-select></div></div><div ng-if=selectQuestion class=form-group><label translate=QUESTION></label><div cg-question-select tenant=tenant question-id=$parent.trigger.objectId class=activity-select></div></div>");
$templateCache.put("app/components/questioninput/audioresponse/audioresponse.html","<div class=form-group><label translate=QUESTION_LABEL></label><input type=text ng-model=question.label ng-required=!topic.attributes.questionText class=\"form-control input-name\"></div><div class=form-group><label translate=QUESTION_DESCRIPTION></label><input type=text ng-model=question.description class=\"form-control input-name\"></div><div ng-if=topic.attributes.questionText class=form-group><label translate=QUESTION_TEXT></label><input type=text ng-model=question.text required class=\"form-control input-answer\"></div><div ng-if=topic.attributes.questionImage class=form-group><label translate=QUESTION_IMAGE></label><div cg-upload upload-id=question.image accept=.png,.jpg class=icon-upload></div><input style=\"display: none\" required readonly ng-model=question.image><img ng-show=question.image ng-src=\"{{question.image | uploadURL}}\" class=image-preview></div><div ng-if=topic.attributes.questionAudio class=form-group><label translate=QUESTION_AUDIO></label><div cg-upload upload-id=question.audio accept=.mp3,.ogg class=icon-upload></div><input style=\"display: none\" required readonly ng-model=question.audio><audio controls ng-show=question.audio ng-src=\"{{question.audio | uploadURL}}\" class=audio-preview></audio></div>");
$templateCache.put("app/components/questioninput/categorisation/categorisation.html","");
$templateCache.put("app/components/questioninput/fillblanks/fillblanks.html","<div class=form-group><label translate=QUESTION_LABEL></label><input type=text ng-model=question.label ng-required=!topic.attributes.questionText class=\"form-control input-name\"></div><div class=form-group><label translate=QUESTION_DESCRIPTION></label><input type=text ng-model=question.description class=\"form-control input-name\"></div><div class=form-group><label translate=QUESTION_TEXT></label><input type=text ng-model=question.text required class=\"form-control input-answer\"></div>");
$templateCache.put("app/components/questioninput/multichoice/multichoice.html","<div class=form-group><label translate=QUESTION_LABEL></label><input type=text ng-model=question.label ng-required=!topic.attributes.questionText class=\"form-control input-name\"></div><div class=form-group><label translate=QUESTION_DESCRIPTION></label><input type=text ng-model=question.description class=\"form-control input-name\"></div><div ng-if=topic.attributes.questionText class=form-group><label translate=QUESTION_TEXT></label><input type=text ng-model=question.text required class=\"form-control input-answer\"></div><div ng-if=topic.attributes.questionImage class=form-group><label translate=QUESTION_IMAGE></label><div cg-upload upload-id=question.image accept=.png,.jpg class=icon-upload></div><input style=\"display: none\" required readonly ng-model=question.image><img ng-show=question.image ng-src=\"{{question.image | uploadURL}}\" class=image-preview></div><div ng-if=topic.attributes.questionAudio class=form-group><label translate=QUESTION_AUDIO></label><div cg-upload upload-id=question.audio accept=.mp3,.ogg class=icon-upload></div><input style=\"display: none\" required readonly ng-model=question.audio><audio controls ng-show=question.audio ng-src=\"{{question.audio | uploadURL}}\" class=audio-preview></audio></div><div ng-if=question.options class=panel><h5>options</h5><div class=panel-body><ul ui-sortable=sortableOptions ng-model=question.options class=\"options-list list-group\"><li ng-repeat=\"option in question.options\" class=\"options-list-item list-group-item\"><div class=form-group><label translate=OPTION_LABEL></label><input type=text ng-model=option.label ng-required=!topic.attributes.optionText class=\"form-control input-name\"></div><div ng-if=topic.attributes.optionText class=form-group><label translate=OPTION_TEXT></label><input type=text ng-model=option.text required class=\"form-control input-answer\"></div><div ng-if=topic.attributes.optionImage class=form-group><label translate=OPTION_IMAGE></label><input type=text ng-model=option.image class=\"form-control input-image\"><div cg-upload upload-id=option.image accept=.png,.jpg class=icon-upload></div><img ng-show=option.image ng-src=\"{{option.image | uploadURL}}\" class=icon-preview> <input style=\"display: none\" required readonly ng-model=option.image></div><div ng-if=topic.attributes.optionAudio class=form-group><label translate=OPTION_AUDIO></label><div cg-upload upload-id=option.audio accept=.mp3,.ogg class=icon-upload></div><input style=\"display: none\" required readonly ng-model=option.audio><audio controls ng-show=option.audio ng-src=\"{{option.audio | uploadURL}}\" class=audio-preview></audio></div><div ng-if=showCorrect class=form-group><label class=ui-radio><input type=radio name=optionCorrect ng-model=selectedOption ng-click=selectOption(option) data-ng-value=option required><span translate=OPTION_CORRECT></span></label></div><div ng-if=showScore class=form-group><label translate=OPTION_SCORE></label><input type=number ng-model=option.score min=0 class=\"form-control input-xp\"></div><div class=form-group><button translate=DELETE ng-click=deleteOption(option) ng-disabled=question.options.length&lt;3 class=\"btn btn-danger button-delete-option\"></button></div></li></ul><button translate=ADD_OPTION ng-click=addOption() class=\"btn btn-default button-add-option\"></button></div></div>");
$templateCache.put("app/components/questioninput/imageresponse/imageresponse.html","<div class=form-group><label translate=QUESTION_LABEL></label><input type=text ng-model=question.label ng-required=!topic.attributes.questionText class=\"form-control input-name\"></div><div class=form-group><label translate=QUESTION_DESCRIPTION></label><input type=text ng-model=question.description class=\"form-control input-name\"></div><div ng-if=topic.attributes.questionText class=form-group><label translate=QUESTION_TEXT></label><input type=text ng-model=question.text required class=\"form-control input-answer\"></div><div ng-if=topic.attributes.questionImage class=form-group><label translate=QUESTION_IMAGE></label><div cg-upload upload-id=question.image accept=.png,.jpg class=icon-upload></div><input style=\"display: none\" required readonly ng-model=question.image><img ng-show=question.image ng-src=\"{{question.image | uploadURL}}\" class=image-preview></div><div ng-if=topic.attributes.questionAudio class=form-group><label translate=QUESTION_AUDIO></label><div cg-upload upload-id=question.audio accept=.mp3,.ogg class=icon-upload></div><input style=\"display: none\" required readonly ng-model=question.audio><audio controls ng-show=question.audio ng-src=\"{{question.audio | uploadURL}}\" class=audio-preview></audio></div>");
$templateCache.put("app/components/questioninput/textrange/textrange.html","<div class=form-group><label translate=QUESTION_LABEL></label><input type=text ng-model=question.label ng-required=!topic.attributes.questionText class=\"form-control input-name\"></div><div class=form-group><label translate=QUESTION_DESCRIPTION></label><input type=text ng-model=question.description class=\"form-control input-name\"></div><div class=form-group><label translate=QUESTION_TEXT></label><input type=text ng-model=question.text required class=\"form-control input-answer\"></div>");
$templateCache.put("app/components/questioninput/templateinterpreted/templateinterpreted.html","<!--div(pretty-json=\"question\" edition=\"true\" on-edit=\"onEdit(newJson)\")--><div ng-form name=jsonForm class=form-group><!--pre {{question}}--><textarea name=jsonInput ng-model=jsonString rows=10 class=form-control></textarea><div ng-hide=wellFormed class=\"alert alert-danger\">Invalid JSON</div></div>");
$templateCache.put("app/components/questioninput/equation/equation.html","<div class=form-group><label translate=QUESTION_LABEL></label><input type=text ng-model=question.label ng-required=!topic.attributes.questionText class=\"form-control input-name\"></div><div class=form-group><label translate=QUESTION_DESCRIPTION></label><input type=text ng-model=question.description class=\"form-control input-name\"></div><div class=form-group><label translate=QUESTION_TEXT></label><input type=text ng-model=question.text required class=\"form-control input-answer\"></div>");
$templateCache.put("app/screens/admin/behaviors/behaviors.html","<h3 translate=BEHAVIORS></h3><div cg-behavior-editor class=editor></div>");
$templateCache.put("app/screens/admin/templates/templates.html","<h3 translate=TEMPLATES></h3><div class=row><div class=col-md-3><ul class=\"templates-list list-group\"><li ng-repeat=\"template in templates\" ng-click=selectTemplate(template) class=\"templates-list-item list-group-item\"><i class=\"fa fa-gamepad\"></i><span class=template-display-name>&nbsp; {{template.name}}</span></li></ul><button translate=NEW_TEMPLATE ng-click=newTemplate() class=\"btn btn-default button-new-template\"></button></div><div class=col-md-9><div class=panel><div class=panel-body><form name=templateEditor ng-submit=saveTemplate><div class=form-group><label translate=TEMPLATE_NAME></label><input type=text ng-model=formData.name required data-ng-minlength=5 class=\"form-control input-name\"></div><div class=form-group><label translate=TEMPLATE_CODE></label><input type=text ng-model=formData.code required data-ng-minlength=5 class=\"form-control input-code\"></div><div class=form-group><label translate=TEMPLATE_DESCRIPTION></label><input type=text ng-model=formData.description required data-ng-minlength=5 class=\"form-control input-description\"></div><div class=form-group><label translate=TEMPLATE_ICON></label><div cg-upload upload-id=formData.icon accept=.png,.jpg class=icon-upload></div><img ng-show=formData.icon ng-src=\"{{formData.icon | uploadURL}}\" class=icon-preview></div><div class=form-group><label translate=TEMPLATE_FILEPATH></label><input type=text ng-model=formData.filepath required data-ng-minlength=5 class=\"form-control input-filepath\"></div><div class=form-group><label translate=TEMPLATE_QUESTION_DURATION></label><input type=number ng-model=formData.questionDuration required class=\"form-control input-question-duration\"></div><div class=form-group><label translate=TEMPLATE_AVGQLNGTH></label><input type=number ng-model=formData.avgqlngth required class=\"form-control input-question-duration\"></div><div class=form-group><label translate=TEMPLATE_TENANTS></label><tags-input type=text use-strings=true ng-model=formData.tenants placeholder=\"Add a tenant\" class=input-tags></tags-input></div><div class=form-group><label translate=TEMPLATE_QUESTION_TYPES></label><ul><li ng-repeat=\"type in formData.questionTypes\"><div class=form-group><label translate=QUESTION_TYPE></label><select ng-model=type.type required ng-change=$parent.onChangeType(type) class=\"form-control input-locked\"><option value=\"\">---Please select---</option><option ng-repeat=\"type in questionTypes\" value={{type}}>{{type}}</option></select></div><div ng-if=\"type.type == questionTypes.MULTICHOICE\" ng-disabled=\"questions.length &gt; 0\" class=well><dl class=dl-horizontal><dt translate=ATTRIBUTES_QUESTION></dt><dd><label class=ui-checkbox><input type=checkbox ng-model=type.attributes.questionText ng-required=getQuestionAttributesSelected()><span translate=TEXT></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=type.attributes.questionAudio ng-required=getQuestionAttributesSelected()><span translate=AUDIO></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=type.attributes.questionImage ng-required=getQuestionAttributesSelected()><span translate=IMAGE></span></label></dd><dt translate=ATTRIBUTES_OPTION></dt><dd><label class=ui-checkbox><input type=checkbox ng-model=type.attributes.optionText ng-required=getOptionAttributesSelected()><span translate=TEXT></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=type.attributes.optionAudio ng-required=getOptionAttributesSelected()><span translate=AUDIO></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=type.attributes.optionImage ng-required=getOptionAttributesSelected()><span translate=IMAGE></span></label></dd></dl></div><div ng-if=\"type.type == questionTypes.AUDIO_RESPONSE || type.type == questionTypes.IMAGE_RESPONSE\" ng-disabled=\"questions.length &gt; 0\" class=well><dl class=dl-horizontal><dt translate=ATTRIBUTES_QUESTION></dt><dd><label class=ui-checkbox><input type=checkbox ng-model=type.attributes.questionText ng-required=getQuestionAttributesSelected()><span translate=TEXT></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=type.attributes.questionAudio ng-required=getQuestionAttributesSelected()><span translate=AUDIO></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=type.attributes.questionImage ng-required=getQuestionAttributesSelected()><span translate=IMAGE></span></label></dd></dl></div><div class=form-group><button ng-click=removeType(type) translate=TEMPLATE_REMOVE_TYPE ng-disabled=\"$parent.formData.questionTypes.length == 1\" class=\"btn btn-default\"></button></div></li></ul><button translate=ADD_TYPE ng-click=addType() class=\"btn btn-default button-add-type\"></button></div><button translate=ARCHIVE ng-click=archiveTemplate(editTemplate) ng-disabled=!formData.id class=\"btn btn-danger button-archive-template\"></button> <button translate=SAVE ng-click=saveTemplate() data-ng-disabled=templateEditor.$invalid class=\"btn btn-success button-save-template\"></button></form></div></div></div></div>");
$templateCache.put("app/screens/admin/tenants/tenants.html","<h3 translate=TENANTS></h3><div class=row><div class=col-md-3><ul class=\"tenants-list list-group\"><li ng-repeat=\"tenant in tenants\" ng-click=selectTenant(tenant) class=\"tenants-list-item list-group-item\"><i class=\"fa fa-gamepad\"></i><span class=tenant-display-name>&nbsp; {{tenant.name}}</span></li></ul><button translate=NEW_TENANT ng-click=newTenant() class=\"btn btn-default button-new-tenant\"></button></div><div class=col-md-9><div class=panel><div class=panel-body><form name=tenantEditor ng-submit=saveTenant class=form-validation><div class=form-group><label translate=TENANT_NAME></label><input type=text ng-model=formData.name required data-ng-minlength=5 class=\"form-control input-name\"></div><div class=form-group><label translate=TENANT_DESCRIPTION></label><textarea type=text ng-model=formData.description class=\"form-control input-description\"></textarea></div><div class=form-group><label translate=TENANT_URL_NAME></label><input type=text ng-model=formData.urlName required data-ng-minlength=1 class=form-control></div><div class=form-group><label translate=TENANT_CODE></label><input type=text ng-model=formData.code required data-ng-minlength=1 class=form-control></div><div class=form-group><label translate=TENANT_ANDROID_ID></label><input type=text ng-model=formData.androidId class=form-control></div><div class=form-group><label translate=TENANT_ITUNES_ID></label><input type=text ng-model=formData.itunesId class=form-control></div><div class=form-group><label translate=TENANT_GA_CODE></label><input type=text ng-model=formData.gaCode class=form-control></div><div class=form-group><label translate=TENANT_INSIGHTS_LOGO></label><div cg-upload upload-id=formData.insightsLogo accept=.png,.jpg class=icon-upload></div><img ng-show=formData.insightsLogo ng-src=\"{{formData.insightsLogo | uploadURL}}\" class=icon-preview></div><div class=form-group><label translate=TENANT_BACKGROUND_TEXTURE></label><div cg-upload upload-id=formData.backgroundTexture accept=.png,.jpg class=icon-upload></div><img ng-show=formData.backgroundTexture ng-src=\"{{formData.backgroundTexture | uploadURL}}\" class=icon-preview></div><div class=form-group><label translate=TENANT_DEFAULT_COINS></label><input type=number ng-model=formData.defaultCoins min=0 class=form-control></div><div class=form-group><label translate=TENANT_DEFAULT_XP></label><input type=number ng-model=formData.defaultXp min=0 class=form-control></div><div class=form-group><label translate=TENANT_DEFAULT_INVENTORY></label><tags-input type=text use-strings=true ng-model=formData.defaultInventory placeholder=\"Add a virtual good\" class=input-tags></tags-input></div><div class=form-group><label class=ui-checkbox><input type=checkbox ng-model=formData.insights><span translate=TENANT_INSIGHTS></span></label></div><div class=form-group><label class=ui-checkbox><input type=checkbox ng-model=formData.behaviour><span translate=TENANT_BEHAVIOUR></span></label></div><div class=form-group><label translate=TENANT_WEBSITE></label><input type=text ng-model=formData.website class=form-control></div><div class=form-group><label translate=TENANT_ISO_LINK></label><input type=text ng-model=formData.iosLink class=form-control></div><div class=form-group><label translate=TENANT_ANDROID_LINK></label><input type=text ng-model=formData.androidLink class=form-control></div><div class=form-group><label translate=TENANT_NEWSFEED_COLOR></label><input colorpicker ng-model=formData.newsfeedConfig.color type=text class=form-control></div><div class=form-group><label translate=TENANT_NEWSFEED_BACKGROUND></label><input colorpicker ng-model=formData.newsfeedConfig.background type=text class=form-control></div><div class=form-group><label translate=TENANT_NEWSFEED_ICON></label><div cg-upload upload-id=formData.newsfeedConfig.icon accept=.png,.jpg class=icon-upload></div><img ng-show=formData.newsfeedConfig.icon ng-src=\"{{formData.newsfeedConfig.icon | uploadURL}}\" class=icon-preview></div><button translate=DELETE ng-click=deleteTenant(editTenant) ng-disabled=!formData.id class=\"btn btn-danger button-delete-tenant\"></button> <button translate=SAVE ng-click=saveTenant() data-ng-disabled=tenantEditor.$invalid class=\"btn btn-success button-save-tenant\"></button></form></div></div></div></div>");
$templateCache.put("app/screens/teams/overview/add-team-modal.html","<div class=add-team-modal><div class=modal-header><button type=button data-dismiss=modal aria-label=Close ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button><h4 class=modal-title>Create your new team</h4></div><div class=modal-body><div class=form-group><label translate=TEAM_NAME></label><input ng-model=team.name required data-ng-minlength=4 maxlength=20 class=\"input-name form-control\"></div><div class=form-group><label translate=TEAM_DESCRIPTION></label><input ng-model=team.description required data-ng-minlength=1 maxlength=140 class=\"input-description form-control\"></div><div class=form-group><label translate=TEAM_CODE></label><input ng-model=team.code required data-ng-minlength=4 maxlength=4 class=\"input-code form-control\"></div></div><div class=modal-footer><button type=button ng-click=$dismiss() class=\"btn btn-default\">Cancel</button> <button type=button ng-click=submitTeam(team) class=\"btn btn-primary button-save-team\">Add</button></div></div>");
$templateCache.put("app/screens/teams/overview/join-team-modal.html","<div class=add-team-modal><div class=modal-header><button type=button data-dismiss=modal aria-label=Close ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button><h4 class=modal-title>Enter the code for the team</h4></div><div class=modal-body><div class=form-group><label translate=TEAM_CODE></label><input ng-model=code required data-ng-minlength=4 maxlength=4 class=\"input-code form-control\"></div></div><div class=modal-footer><button type=button ng-click=$dismiss() class=\"btn btn-default\">Cancel</button> <button type=button ng-click=submitCode(code) class=\"btn btn-primary button-submit-code\">Add</button></div></div>");
$templateCache.put("app/screens/teams/overview/overview.html","<div class=\"screen-teams-overview page\"><div class=\"row teams-list\"><div ng-repeat=\"team in teams\" class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div ng-click=selectTeam(team) class=\"panel mini-box\"><div class=\"btn-icon btn-icon-round btn-icon-lg-alt bg-info\"><i class=\"fa fa-users\"></i></div><div class=box-info><h4>{{team.name}}</h4><p>{{team.description}}</p></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12 add-join-team\"><div class=\"panel panel-box bg-success\"><div ng-click=addTeam() class=\"panel-left panel-item button-add-team\"><p><i class=\"fa fa-plus\"></i></p><p translate=ADD_TEAM></p></div><div ng-click=joinTeam() class=\"panel-right panel-item button-join-team\"><p><i class=\"fa fa-users\"></i></p><p translate=JOIN_TEAM></p></div></div></div></div></div>");
$templateCache.put("app/screens/teams/team/add-code-modal.html","<div class=add-team-modal><div class=modal-header><button type=button data-dismiss=modal aria-label=Close ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button><h4 class=modal-title>Enter the code for the team</h4></div><div class=modal-body><div class=form-group><label translate=TEAM_CODE></label><input ng-model=code required data-ng-minlength=4 maxlength=4 class=\"input-code form-control\"></div></div><div class=modal-footer><button type=button ng-click=$dismiss() class=\"btn btn-default\">Cancel</button> <button type=button ng-click=submitCode(code) class=\"btn btn-primary button-submit-code\">Add</button></div></div>");
$templateCache.put("app/screens/teams/team/team.html","<div class=\"screen-team page\"><div class=panel><div class=panel-body><ol class=breadcrumb-alt><li><a ui-sref=teams.overview>{{ \'TEAMS\' | translate}}</a></li><li><a>{{team.name}}</a></li></ol></div></div><div cg-team-profile-panel team=team class=team-profile-panel></div><div class=\"row users-list\"><div ng-repeat=\"user in team.members\" class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div cg-user-thumb user-id=user.id class=user-thumb></div></div></div></div>");
$templateCache.put("app/screens/tenant/admin/admin.html","<div class=screen-admin><div class=row><div class=col-md-12><ul class=\"nav nav-boxed nav-justified\"><li><a ui-sref=tenant.admin.users({tenantRef:tenant.urlName})><i class=\"color-success fa fa-user\"></i><span>{{ \'USERS\' | translate}}</span></a></li><li><a ui-sref=tenant.admin.content.overview({tenantRef:tenant.urlName}) class=button-content><i class=\"color-primary fa fa-book\"></i><span>{{ \'CONTENT\' | translate}}</span></a></li><li><a ui-sref=tenant.admin.vouchers({tenantRef:tenant.urlName}) class=button-vouchers><i class=\"color-danger fa fa-ticket\"></i><span>{{ \'VOUCHERS\' | translate}}</span></a></li><li><a ui-sref=tenant.admin.behaviors({tenantRef:tenant.urlName}) class=button-behaviors><i class=\"color-warning fa fa-bolt\"></i><span>{{ \'BEHAVIORS\' | translate}}</span></a></li><li><a ui-sref=tenant.admin.leaderboards({tenantRef:tenant.urlName}) class=button-leaderboards><i class=\"color-warning fa fa-trophy\"></i><span>{{ \'LEADERBOARDS\' | translate}}</span></a></li></ul></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div>");
$templateCache.put("app/screens/tenant/content/content.html","<div ui-view class=\"child-view animate-fade-up\"></div>");
$templateCache.put("app/screens/tenant/team/team.html","<div ui-view class=\"child-view animate-fade-up\"></div>");
$templateCache.put("app/screens/tenant/teams/teams.html","<div class=\"screen-tenant-teams page\"><div class=\"row teams-list\"><div ng-repeat=\"team in teams\" class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div cg-team-thumb team=team tenant=tenant ng-click=selectTeam(team) class=team-thumb></div></div></div></div>");
$templateCache.put("app/screens/tenant/subjects/subjects.html","<div class=\"screen-tenant-subjects panel panel-default\"><div class=panel-heading>{{ \'CONTENT_OVERVIEW\' | translate}}</div><div class=table-filters><div class=row><div class=col-md-4><form><span class=ui-select><select ng-model=subject ng-options=\"subject.name for subject in subjectList\"></select></span></form></div><div class=col-md-4></div><div class=col-md-4><div class=input-group><input ng-model=search placeholder=\"{{ \'SEARCH\' | translate}}\" type=text class=form-control><span class=input-group-btn><button ng-click=\"search = \'\'\" class=\"btn btn-default search-button\"><span class=\"glyphicon glyphicon-remove-circle\"></span></button></span></div></div></div></div><table class=\"table table-bordered table-striped table-responsive\"><thead><tr><th><div class=th><span>{{ \'SUBJECT\' | translate}}</span></div></th><th><div class=th><span>{{ \'TOPIC\' | translate}}</span></div></th><th class=hidden-xs><div class=th><span>{{ \'TAGS\' | translate}}</span></div></th></tr></thead><tbody><tr data-ng-repeat=\"topic in topics | orderBy: [&quot;subject.order&quot;, &quot;order&quot;] | filter: searchFilter\"><td class=subject-name>{{topic.subject.name}}</td><td class=topic-name>{{topic.name}}</td><td class=hidden-xs><ul class=tag-list><li ng-repeat=\"tag in topic.tags\" class=tag-list-list><span ng-click=selectTag(tag) class=\"label label-primary\">{{tag}}</span></li></ul></td></tr></tbody></table></div>");
$templateCache.put("app/screens/tenant/user/user.html","<div ui-view class=\"child-view animate-fade-up\"></div>");
$templateCache.put("app/screens/tenant/users/add-user-modal.html","<div class=tenant-info-modal><div class=modal-header><button type=button data-dismiss=modal aria-label=Close ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button><h4 class=modal-title>Enter user Insights code</h4></div><div class=modal-body><input ng-model=code required data-ng-minlength=6 maxlength=6 class=form-control><div class=\"text-center info\">To locate a user\'s unique Insights code, select the user\'s avatar from the app\'s home screen and then select <i>\'My Insights Code\'</i></div></div><div class=modal-footer><button type=button ng-click=$dismiss() class=\"btn btn-default\">Cancel</button> <button id=button-add type=button ng-click=submitUser(code) class=\"btn btn-primary\">Add</button></div></div>");
$templateCache.put("app/screens/tenant/users/users.html","<div class=screen-tenant-users><div class=\"row users-list\"><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div cg-user-thumb user-id=user.userId tenant=tenant ng-click=selectUser(user.userId) class=\"user-thumb default-user-thumb\"></div></div><div ng-repeat=\"userId in users\" class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div cg-user-thumb user-id=userId tenant=tenant ng-click=selectUser(userId) class=user-thumb></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12 add-user\"><div ng-click=addUser() class=\"panel panel-box\"><div class=panel-top><div class=text-center><h3>{{ \'ADD_USER\' | translate}}</h3></div></div><div class=panel-icon><i class=\"fa fa-plus\"></i></div><div class=panel-bottom></div></div></div></div></div>");
$templateCache.put("app/screens/tenant/admin/behaviors/behaviors.html","<h3 translate=BEHAVIORS></h3><div cg-behavior-editor tenant=tenant class=editor></div>");
$templateCache.put("app/screens/tenant/admin/content/content.html","<div class=screen-tenant-admin-content><div class=row><div class=col-md-12><ul class=\"nav nav-boxed nav-justified\"><li><a ui-sref=tenant.admin.content.overview({tenantRef:tenant.urlName}) class=button-overview><i class=\"color-danger fa fa-dashboard\"></i><span class=overview>{{ \'OVERVIEW\' | translate}}</span></a></li><li><a ui-sref=tenant.admin.content.subjects({tenantRef:tenant.urlName}) class=button-subjects-overview><i class=\"color-primary fa fa-book\"></i><span class=subjects-overview>{{ \'SUBJECTS\' | translate}}</span></a></li></ul></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div>");
$templateCache.put("app/screens/tenant/admin/leaderboards/leaderboards.html","<div class=\"screen-tenant-admin-leaderboards panel panel-default\"><div class=panel-heading>{{ \'LEADERBOARDS\' | translate}}</div><div class=panel-body><div class=row><div class=col-md-3><ul ui-sortable=sortableTeams ng-model=leaderboards class=\"leaderboards-list list-group\"><li ng-repeat=\"leaderboard in leaderboards\" ng-click=selectLeaderboard(leaderboard) class=\"leaderboards-list-item list-group-item\"><i class=\"fa fa-trophy\"></i><span class=leaderboard-display-name>&nbsp; {{leaderboard.name}}</span></li></ul><button translate=NEW_LEADERBOARD ng-click=newLeaderboard() class=\"btn btn-default button-new-leaderboard\"></button></div><div class=col-md-9><div class=panel><div class=panel-body><form name=leaderboardEditor ng-submit=saveLeaderboard><div class=form-group><label translate=NAME></label><input type=text ng-model=leaderboardFormData.name required data-ng-minlength=1 class=\"form-control input-name\"></div><div class=form-group><label translate=TEAMS></label><div class=panel-body><ul class=\"teams-list list-group\"><li ng-repeat=\"team in leaderboardFormData.teams\" class=\"teams-list-item list-group-item\"><div class=form-group><label translate=TEAM_ID></label><input type=text ng-model=team.teamId required class=\"form-control input-answer\"><p ng-show=team.teamId>{{team.teamId | teamName}}</p></div><div class=form-group><label translate=TEAM_MULTIPLYER></label><input type=number ng-model=team.multiplyer required class=\"form-control input-answer\"></div><div class=form-group><label translate=TEAM_XP></label><p><span>{{team.xp}}</span><span>&nbsp;({{team.xp * team.multiplyer}})</span></p></div><div class=form-group><button translate=DELETE ng-click=deleteTeam(team) ng-disabled=leaderboardFormData.teams.length&lt;2 class=\"btn btn-danger button-delete-team\"></button></div></li></ul><button translate=ADD_TEAM ng-click=addTeam() class=\"btn btn-default\"></button></div></div><div class=form-group><label translate=START></label><div ng-click=\"startOpen = true\" class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=start is-open=startOpen datepicker-options=dateOptions required class=form-control><div ng-click=\"dateTeams = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div><div class=form-group><label translate=END></label><div ng-click=\"endOpen = true\" class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=end is-open=endOpen datepicker-options=dateOptions required class=form-control><div ng-click=\"dateTeams = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div><button translate=ARCHIVE ng-click=archiveLeaderboard(editLeaderboard) ng-disabled=!leaderboardFormData.id class=\"btn btn-danger button-archive-leaderboard\"></button> <button translate=SAVE ng-click=saveLeaderboard() data-ng-disabled=leaderboardEditor.$invalid class=\"btn btn-success button-save-leaderboard\"></button></form></div></div></div></div></div></div>");
$templateCache.put("app/screens/tenant/admin/users/users.html","<div class=screen-tenant-subjects><table class=\"table table-bordered table-striped table-responsive\"><thead><th class=th>Display name</th><th class=th>Display coins</th><th class=th>Display xp</th><th class=th>Created</th><th class=th>Updated</th></thead><dir-pagination-controls></dir-pagination-controls><tbody><tr dir-paginate=\"user in users| orderBy: order : orderReverse | itemsPerPage: limit\" ui-sref=\"tenant.user.overview({tenantRef:tenant.urlName, userId:user.playerId})\"><td>{{user.playerId | displayName}}</td><td>{{user.coins}}</td><td>{{user.xp}}</td><td>{{user.created.$date | date : \"dd/mm/yy\"}}</td><td>{{user.updated.$date | date : \"dd/mm/yy\"}}</td></tr></tbody></table></div>");
$templateCache.put("app/screens/tenant/admin/vouchers/vouchercreate-modal.html","<div class=voucher-create-modal><div class=modal-header><button type=button voucher-dismiss=modal aria-label=Close ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button><h4 ng-hide=config.bulk class=modal-title>Create voucher</h4><h4 ng-show=config.bulk class=modal-title>Create vouchers</h4></div><div class=modal-body><form ng-submit=submit() class=form-validation><div class=form-group><label translate=VOUCHER_NAME></label><input type=text ng-model=voucher.name voucher-ng-minlength=1 class=form-control></div><div ng-hide=config.bulk class=form-group><label translate=VOUCHER_CODE></label><input type=text ng-model=voucher.code required voucher-ng-minlength=1 class=form-control></div><div ng-show=config.bulk class=form-group><label class=ui-checkbox><input type=checkbox ng-model=config.autoCodes><span translate=VOUCHER_CODE_OPTION></span></label></div><div ng-show=\"config.bulk &amp;&amp; config.autoCodes\" class=form-group><label translate=VOUCHER_CODE_COUNT></label><input type=number ng-model=config.count min=0 class=form-control></div><div ng-show=\"config.bulk &amp;&amp; !config.autoCodes\" class=form-group><label translate=VOUCHER_CODES></label><tags-input type=text use-strings=true ng-model=config.codes placeholder=codes></tags-input></div><div class=form-group><label translate=VOUCHER_DESCRIPTION></label><input type=text ng-model=voucher.description voucher-ng-minlength=1 class=form-control></div><div class=form-group><label translate=VOUCHER_DURATION></label><input type=number ng-model=voucher.duration min=0 class=form-control></div><div class=form-group><label translate=VOUCHER_TAGS></label><tags-input type=text use-strings=true ng-model=voucher.tags placeholder=tags></tags-input></div><div class=form-group><label translate=VOUCHER_BRAND></label><input type=text ng-model=voucher.brand class=form-control></div><div class=form-group><label translate=VOUCHER_EXPIRY></label><div ng-click=\"expiryOpen = true\" class=\"input-group ui-datepicker\"><input uib-datepicker-popup=\"MMM d, yyyy\" ng-model=voucher.expiry is-open=expiryOpen datepicker-options=expiryOptions class=form-control><div ng-click=\"expiryOpen = true\" class=input-group-addon><i class=\"fa fa-calendar\"></i></div></div></div><div class=form-group><label translate=VOUCHER_ICON></label><div cg-upload upload-id=voucher.icon accept=.png,.jpg class=icon-upload></div><img ng-show=voucher.icon ng-src=\"{{voucher.icon | uploadURL}}\" class=icon-preview></div><div ng-if=config.assigned class=form-group><label class=ui-checkbox><input type=checkbox ng-model=config.isAssigned><span translate=VOUCHER_ASSIGNED></span></label><p>{{voucher.playerId | displayName}}</p></div><div ng-if=\"config.isAssigned &amp;&amp; config.consumed\" class=form-group><label class=ui-checkbox><input type=checkbox ng-model=voucher.consumed><span translate=VOUCHER_CONSUMED></span></label><p>{{voucher.consumedDate | date : \"mediumDate\"}}</p></div></form></div><div class=modal-footer><button ng-show=voucher.id type=button ng-click=deleteVoucher(voucher) class=\"btn btn-error btn-danger\">Delete</button> <button type=button ng-click=$dismiss() class=\"btn btn-default\">Cancel</button> <button id=button-add type=button ng-click=\"saveVoucher(voucher, config)\" class=\"btn btn-primary\">Save</button></div></div>");
$templateCache.put("app/screens/tenant/admin/vouchers/vouchers.html","<div class=screen-tenant-vouchers><table class=\"table table-bordered table-striped table-responsive\"><thead><th class=th>Name</th><th class=th>Description</th><th class=th>Code</th><th class=th>Created</th><th class=th>Updated</th><th class=th>Tags</th></thead><dir-pagination-controls on-page-change=changePage(index)></dir-pagination-controls><tbody><tr dir-paginate=\"voucher in vouchers | itemsPerPage : limit\" ng-click=selectVoucher(voucher) total-items=count current-page=currentPage><td>{{voucher.name}}</td><td>{{voucher.description}}</td><td>{{voucher.code}}</td><td>{{voucher.created | date : \"mediumDate\"}}</td><td>{{voucher.updated | date : \"mediumDate\"}}</td><td><ul class=tag-list><li ng-repeat=\"tag in voucher.tags\" class=tag-list-list><span ng-click=selectTag(tag) class=\"label label-primary\">{{tag}}</span></li></ul></td></tr></tbody></table><button translate=CREATE_VOUCHER ng-click=createVoucher() class=\"btn btn-primary\"></button> <button translate=CREATE_BULK_VOUCHERS ng-click=createVoucher(true) class=\"btn btn-primary\"></button></div>");
$templateCache.put("app/screens/tenant/content/activity/activity.html","<div class=\"screen-admin-activitys panel panel-default\"><div class=panel-heading>{{ topic.name}}</div><div ng-show=question class=panel-body><p>{{question.text}}</p><ul class=list-group><li ng-repeat=\"option in question.options\" ng-click=selectOption(option) class=list-group-item><span>{{option.text}}</span></li></ul></div><div ng-show=activityComplete class=panel-body><p>{{topic.name}} {{\'COMPLETE\' | translate}}</p></div></div>");
$templateCache.put("app/screens/tenant/content/subject/subject.html","<div class=\"screen-admin-subjects panel panel-default\"><div class=panel-heading>{{ subject.name}}</div><div class=panel-body><div class=row><div class=col-md-3><ul class=\"subjects-list list-group\"><!--li.subjects-list-item.list-group-item(ng-repeat=\"topic in topics\" ui-sref=\"tenant.content.topic({tenantRef:tenant.urlName, topicId:topic.id})\")--><li ng-repeat=\"topic in topics\" class=\"subjects-list-item list-group-item\"><i class=\"fa fa-gamepad\"></i><span class=subject-display-name>&nbsp; {{topic.name}}</span><div ng-show=\"topic.topicType == \'SURVEY\' || topic.topicType== \'SCORED_SURVEY\'\"><button translate=LAUNCH ng-click=launchTopic(topic) class=\"btn btn-primary\"></button></div></li></ul></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div></div>");
$templateCache.put("app/screens/tenant/content/subjects/subjects.html","<div class=\"screen-admin-subjects panel panel-default\"><div class=panel-heading>{{ \'SUBJECTS\' | translate}}</div><div class=panel-body><div class=row><div class=col-md-3><ul class=\"subjects-list list-group\"><li ng-repeat=\"subject in subjects\" ui-sref=\"tenant.content.subject({tenantRef:tenant.urlName, subjectId:subject.id})\" class=\"subjects-list-item list-group-item\"><i class=\"fa fa-gamepad\"></i><span class=subject-display-name>&nbsp; {{subject.name}}</span></li></ul></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div></div>");
$templateCache.put("app/screens/tenant/team/overview/overview.html","<div class=\"screen-team page\"><div class=panel><div class=panel-body><ol class=breadcrumb-alt><li><a ui-sref=tenant.teams({tenantRef:tenant.urlName})>{{ \'TEAMS\' | translate}}</a></li><li><a>{{team.name}}</a></li></ol></div></div><div cg-team-profile-panel team=team tenant=tenant class=team-profile-panel></div><div class=\"row before\"><div class=col-sm-6><div class=\"panel mini-box\"><div class=\"btn-icon btn-icon-round btn-icon-lg-alt bg-warning\"><i class=\"fa fa-list\"></i></div><div class=box-info><p class=size-h2>{{progress.topicPlayed | number : 0}}</p><p class=text-muted>{{ \'TOPICS_PLAYED\' | translate}}</p></div></div></div><div class=col-sm-6><div class=\"panel mini-box\"><div class=\"btn-icon btn-icon-round btn-icon-lg-alt bg-info\"><i class=\"fa fa-question\"></i></div><div class=box-info><p class=size-h2>{{progress.attempted | number : 0}}</p><p class=text-muted>{{ \'QUESTIONS_ANSWERED\' | translate}}</p></div></div></div></div><div class=\"row subject-list\"><div ng-repeat=\"overview in subjectOverviews | orderBy: \'overview.subject.order\'\" ng-if=overview.aggregate class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\"><div ng-click=selectSubject(overview.subject) class=\"panel panel-default panel-minimal\"><div class=panel-heading><span class=overview-subject-name>{{overview.subject.name}}</span><i class=\"fa fa-chevron-right\"></i></div><div class=panel-body><nvd3 options=chartOptions data=overview.chartData></nvd3><!--.col-sm-5.subject-details-right\n          span.topic-played {{overview.aggregate.topicPlayed}}\n          span {{ \'TOPICS_PLAYED\' | translate}}\n          --></div></div></div></div><div class=\"panel panel-default\"><div class=panel-heading>{{ \'ACTIVITY_HISTORY\' | translate}}</div><div class=panel-body><uib-tabset><uib-tab index=0 heading=\"{{\'ACTIVITY_HISTORY\' | translate}}\"><div cg-activity-history player-ids=userIds tenant=tenant class=activity-history></div></uib-tab><uib-tab index=1 heading=\"{{\'NOTES\' | translate}}\"><div cg-notes player-ids=userIds tenant=tenant class=notes-history></div></uib-tab></uib-tabset></div></div><div class=\"row users-list\"><div ng-repeat=\"user in team.members\" class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div cg-user-thumb user-id=user.id tenant=tenant ng-click=selectUser(user) class=user-thumb></div></div></div></div>");
$templateCache.put("app/screens/tenant/team/behaviors/behaviors.html","<div class=\"screen-team page\"><div class=panel><div class=panel-body><ol class=breadcrumb-alt><li><a ui-sref=tenant.teams({tenantRef:tenant.urlName})>{{ \'TEAMS\' | translate}}</a></li><li><a ui-sref=tenant.team.overview>{{team.name}}</a></li><li><a>{{ \'BEHAVIORS\' | translate}}</a></li></ol></div></div><div cg-team-profile-panel team=team tenant=tenant class=team-profile-panel></div><h3 translate=BEHAVIORS></h3><div cg-behavior-editor tenant=tenant team=team class=editor></div></div>");
$templateCache.put("app/screens/tenant/team/subject/subject.html","<div class=\"screen-team page\"><div class=panel><div class=panel-body><ol class=breadcrumb-alt><li><a ui-sref=tenant.teams({tenantRef:tenant.urlName})>{{ \'TEAMS\' | translate}}</a></li><li><a ui-sref=tenant.team.overview>{{team.name}}</a></li><li><a>{{subject.name}}</a></li></ol></div></div><div cg-team-profile-panel team=team tenant=tenant class=team-profile-panel></div><div class=\"screen-tenant-subjects panel panel-default\"><div class=panel-heading>{{ \'TOPICS\' | translate}}</div><div class=\"row table-filters\"><div class=col-md-8></div><div class=col-md-4><div class=input-group><input ng-model=search placeholder=Search type=text class=form-control><span class=input-group-btn><button ng-click=\"search = \'\'\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove-circle\"></span></button></span></div></div></div><table class=\"table table-bordered table-striped table-responsive\"><thead><tr><th><div class=th><span>{{ \'TOPIC\' | translate}}</span></div></th><th class=hidden-xs><div class=th><span>{{ \'STATUS\' | translate}}</span></div></th><th><div class=th><span>{{ \'MASTERY\' | translate}}</span></div></th><th class=hidden-xs><div class=th><span>{{ \'TAGS\' | translate}}</span></div></th></tr></thead><tbody><tr data-ng-repeat=\"overview in topicOverviews | orderBy: &quot;topic.order&quot; | filter: searchFilter \"><td>{{overview.topic.name}}</td><td class=hidden-xs>{{overview.status}}</td><td class=col-progress><div class=\"progress-rounded progress\"><div ng-style=\"{width: overview.completePercent + \'%\'}\" tooltip-placement=top uib-tooltip=Completed tooltip-append-to-body=true class=\"progress-bar progress-bar-success\"></div><div ng-style=\"{width: overview.revisionPercent + \'%\'}\" tooltip-placement=top uib-tooltip=\"In revision\" tooltip-append-to-body=true class=\"progress-bar progress-bar-warning\"></div><div ng-style=\"{width: overview.attemptedPercent + \'%\'}\" tooltip-placement=top uib-tooltip=Attempted tooltip-append-to-body=true class=\"progress-bar progress-bar-info\"></div></div></td><td class=\"hidden-xs col-tags\"><ul class=tag-list><li ng-repeat=\"tag in overview.topic.tags\"><span ng-click=selectTag(tag) class=\"label label-primary\">{{tag}}</span></li></ul></td></tr></tbody></table></div><div class=\"panel panel-default\"><div class=panel-heading>{{ \'ACTIVITY_HISTORY\' | translate}}</div><div class=panel-body><div cg-activity-history player-ids=userIds tenant=tenant subject=subject class=activity-history></div></div></div></div>");
$templateCache.put("app/screens/tenant/user/overview/overview.html","<div class=screen-tenant-user-overview><div class=\"panel breadcrumb-panel\"><div class=panel-body><ol class=breadcrumb-alt><li><a ui-sref=tenant.users>{{ \'HOME\' | translate}}</a></li><li><a>{{userDetails.displayName}}</a></li></ol></div></div><div cg-profile-panel user-id=userDetails.playerId tenant=tenant class=profile-panel></div><div class=\"row before\"><div class=col-sm-6><div class=\"panel mini-box\"><div class=\"btn-icon btn-icon-round btn-icon-lg-alt bg-warning\"><i class=\"fa fa-list\"></i></div><div class=box-info><p class=size-h2>{{progress.topicPlayed}}</p><p class=text-muted>{{ \'TOPICS_PLAYED\' | translate}}</p></div></div></div><div class=col-sm-6><div class=\"panel mini-box\"><div class=\"btn-icon btn-icon-round btn-icon-lg-alt bg-info\"><i class=\"fa fa-question\"></i></div><div class=box-info><p class=size-h2>{{progress.attempted}}</p><p class=text-muted>{{ \'QUESTIONS_ANSWERED\' | translate}}</p></div></div></div></div><div class=\"row subject-list\"><div ng-repeat=\"overview in subjectOverviews | orderBy: \'overview.subject.order\'\" ng-if=overview.aggregate class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\"><div ng-click=selectSubject(overview.subject) class=\"panel panel-default panel-minimal\"><div class=panel-heading><span class=overview-subject-name>{{overview.subject.name}}</span><i class=\"fa fa-chevron-right\"></i></div><div ng-show=overview.showMastery class=\"panel-body mastery\"><nvd3 options=chartOptions data=overview.chartData></nvd3></div><div ng-hide=overview.showMastery class=\"panel-body activity-response\"><span class=count>{{overview.activityResponses}}</span><span translate=RESPONSES_SUBMITTED></span></div></div></div></div><div class=\"panel panel-default\"><div class=panel-body><uib-tabset><uib-tab index=0 heading=\"{{\'ACTIVITY_HISTORY\' | translate}}\"><div cg-activity-history player-id=userDetails.playerId tenant=tenant class=activity-history></div></uib-tab><uib-tab index=2 heading=\"{{\'NOTES\' | translate}}\"><div cg-notes player-id=userDetails.playerId tenant=tenant class=notes-history></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/screens/tenant/user/response/image-response-modal.html","<div class=image-response-modal><div class=modal-header><button type=button data-dismiss=modal aria-label=Close ng-click=$dismiss() class=close><span aria-hidden=true>×</span></button></div><div class=modal-body><img ng-src=\"{{response.answer | uploadURL}}\"></div><div class=modal-footer><button type=button ng-click=$dismiss() class=\"btn btn-primary\">Ok</button></div></div>");
$templateCache.put("app/screens/tenant/user/response/response.html","<div class=screen-tenant-user-response><div class=panel><div class=panel-body><ol class=breadcrumb-alt><li><a ui-sref=tenant.users>{{ \'HOME\' | translate}}</a></li><li><a ui-sref=tenant.user.overview>{{userDetails.displayName}}</a></li><li><a>{{activityResponse.topicId | topicName}}</a></li></ol></div></div><div cg-profile-panel user-id=userDetails.playerId tenant=tenant class=profile-panel></div><div class=\"panel panel-default\"><div class=panel-heading>{{activityResponse.topicId | topicName}}</div><div class=panel-body><p><span translate=START_DATE></span><span>: {{activityResponse.date | date:\'short\'}}</span></p><p ng-show=activityResponse.score><span translate=SCORE></span><span>: {{activityResponse.score}}</span></p><p ng-show=activityResponse.percentCorrect><span translate=CORRECT_PERCENT></span><span>: {{activityResponse.percentCorrect}}</span></p><p ng-show=activityResponse.completeDate><span translate=COMPLETE_DATE></span><span>: {{activityResponse.completeDate | date:\'short\'}}</span></p><div class=table-reponsive><table class=\"table table-striped table-bordered table-hoverxx\"><thead><tr><th translate=ORDER></th><th translate=QUESTION></th><th translate=ANSWER></th><th translate=CORRECT></th><th translate=RESPONSE_TIME ng-show=showDuration></th></tr></thead><tbody><tr data-ng-repeat=\"response in questionResponses | orderBy: \'date\'\" data-ng-clickxx=selectQuestionResponse(response)><td>{{$index + 1}}</td><td>{{getQuestionText(response.question)}}</td><td data-ng-if=\"response.question.type != QuestionTypes.IMAGE_RESPONSE\">{{response.answer}}</td><td data-ng-if=\"response.question.type == QuestionTypes.IMAGE_RESPONSE\" ng-click=showImageResponse(response)><span class=\"glyphicon glyphicon-picture color-info\"></span></td><td><span data-ng-class=\"{\'badge-success\':response.correct,\'badge-danger\':!response.correct}\" class=badge><span data-ng-show=response.correct class=\"glyphicon glyphicon-ok\"></span><span data-ng-hide=response.correct class=\"glyphicon glyphicon-remove\"></span></span></td><td ng-show=showDuration>{{response.duration/1000 | number:1}} seconds</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/screens/tenant/user/subject/subject.html","<div class=screen-tenant-user-subjects><div class=\"panel breadcrumb-panel\"><div class=panel-body><ol class=breadcrumb-alt><li><a ui-sref=tenant.users>{{ \'HOME\' | translate}}</a></li><li><a ui-sref=tenant.user.overview>{{userDetails.displayName}}</a></li><li><a>{{subject.name}}</a></li></ol></div></div><div cg-profile-panel user-id=userDetails.playerId tenant=tenant class=profile-panel></div><div class=\"screen-tenant-subjects panel panel-default\"><div class=panel-heading>{{ \'TOPICS\' | translate}}</div><div class=\"row table-filters\"><div class=col-md-8></div><div class=col-md-4><div class=input-group><input ng-model=search placeholder=Search type=text class=form-control><span class=input-group-btn><button ng-click=\"search = \'\'\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove-circle\"></span></button></span></div></div></div><table class=\"table table-bordered table-striped table-responsive\"><thead><tr><th><div class=th><span>{{ \'TOPIC\' | translate}}</span></div></th><th class=hidden-xs><div class=th><span>{{ \'STATUS\' | translate}}</span></div></th><th><div class=th><span>{{ \'MASTERY\' | translate}}</span></div></th><th class=hidden-xs><div class=th><span>{{ \'TAGS\' | translate}}</span></div></th></tr></thead><tbody><tr data-ng-repeat=\"overview in topicOverviews | orderBy: &quot;topic.order&quot; | filter: searchFilter \"><td>{{overview.topic.name}}</td><td class=hidden-xs>{{overview.status}}</td><td class=col-progress><div class=\"progress-rounded progress\"><div ng-style=\"{width: overview.completePercent + \'%\'}\" tooltip-placement=top uib-tooltip=Completed tooltip-append-to-body=true class=\"progress-bar progress-bar-success\"></div><div ng-style=\"{width: overview.revisionPercent + \'%\'}\" tooltip-placement=top uib-tooltip=\"In revision\" tooltip-append-to-body=true class=\"progress-bar progress-bar-warning\"></div><div ng-style=\"{width: overview.attemptedPercent + \'%\'}\" tooltip-placement=top uib-tooltip=Attempted tooltip-append-to-body=true class=\"progress-bar progress-bar-info\"></div></div></td><td class=\"hidden-xs col-tags\"><ul class=tag-list><li ng-repeat=\"tag in overview.topic.tags\"><span ng-click=selectTag(tag) class=\"label label-primary\">{{tag}}</span></li></ul></td></tr></tbody></table></div><div class=\"panel panel-default\"><div class=panel-heading>{{ \'ACTIVITY_HISTORY\' | translate}}</div><div class=panel-body><div cg-activity-history player-id=userDetails.playerId tenant=tenant subject=subject class=activity-history></div></div></div></div>");
$templateCache.put("app/screens/tenant/admin/content/activities/activities.html","<div class=\"screen-tenant-admin-activities panel panel-default\"><div class=panel-heading>{{ \'ACTIVITIES\' | translate}}</div><div class=panel-body><div class=row><div class=col-md-4><ul ui-sortable=sortableOptions ng-model=activities class=\"activities-list list-group\"><li ng-repeat=\"activity in activities\" ng-click=selectActivity(activity) class=\"activities-list-item list-group-item\"><i class=\"fa fa-gamepad\"></i><span class=activity-display-topic>&nbsp; {{activity.topicId | topicName}}</span><span class=activity-display-template>&nbsp; {{activity.templateId | templateName}}</span></li></ul><button translate=NEW_ACTIVITY ng-click=newActivity() class=\"btn btn-default button-new-activity\"></button></div><div class=col-md-8><div class=panel><div class=panel-body><form name=activityEditor ng-submit=saveActivity><div class=form-group><label translate=ACTIVITY_NAME></label><input type=text ng-model=activityFormData.name class=\"form-control input-xp\"></div><div class=form-group><label translate=ACTIVITY_DESCRIPTION></label><textarea type=text ng-model=activityFormData.description class=\"form-control input-xp\"></textarea></div><div class=form-group><label translate=ACTIVITY_TOPIC></label><div class=ui-select><select ng-model=activityFormData.topicId required class=input-topic><option ng-repeat=\"topic in topics\" value={{topic.id}}>{{topic.name}}</option></select></div></div><div class=form-group><label translate=ACTIVITY_TEMPLATE></label><div class=ui-select><select ng-model=activityFormData.templateId required class=input-template><option ng-repeat=\"template in templates\" value={{template.id}}>{{template.name}}</option></select></div></div><div class=form-group><label translate=ACTIVITY_XP></label><input type=number ng-model=activityFormData.xp min=0 class=\"form-control input-xp\"></div><div class=form-group><label translate=ACTIVITY_GC></label><input type=number ng-model=activityFormData.currency min=0 class=\"form-control input-gc\"></div><div class=form-group><label translate=ACTIVITY_VG></label><tags-input type=text use-strings=true ng-model=activityFormData.virtualgoods placeholder=\"Add a virtual good\" class=input-vg></tags-input></div><div class=form-group><label translate=ACTIVITY_ICON></label><div cg-upload upload-id=activityFormData.icon accept=.png,.jpg class=icon-upload></div><img ng-show=activityFormData.icon ng-src=\"{{activityFormData.icon | uploadURL}}\" class=icon-preview></div><button translate=ARCHIVE ng-click=archiveActivity(editActivity) ng-disabled=!activityFormData.id class=\"btn btn-danger button-archive-activity\"></button> <button translate=SAVE ng-click=saveActivity() data-ng-disabled=activityEditor.$invalid class=\"btn btn-success button-save-activity\"></button></form></div></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div></div></div>");
$templateCache.put("app/screens/tenant/admin/content/overview/overview.html","<div class=\"screen-admin-content-overview panel panel-default\"><div class=panel-heading>{{ \'OVERVIEW\' | translate}}</div><div class=panel-body><h4 translate=EXPORT_CONTENT></h4><button translate=EXPORT ng-click=export() class=\"btn btn-success button-export\"></button><h4 translate=IMPORT_CONTENT></h4><form name=contentImport ng-submit=import()><div class=form-group><input type=file onchange=angular.element(this).scope().importFileChange(this) accept=application/json class=file-input><!--.button(ngf-select ng-model=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\") Select--></div><button translate=SAVE data-ng-disabled=!content class=\"btn btn-success button-import\"></button></form></div></div>");
$templateCache.put("app/screens/tenant/admin/content/questions/questions.html","<div class=\"screen-tenant-admin-questions panel panel-default\"><div class=panel-heading>{{ \'QUESTIONS\' | translate}}</div><div class=panel-body><div class=row><div class=col-md-4><ul ui-sortable=sortableOptions ng-model=questions class=\"questons-list list-group\"><li ng-repeat=\"question in questions\" ng-click=selectQuestion(question) class=\"questions-list-item list-group-item\"><i class=\"fa fa-question\"></i><span ng-show=question.label>&nbsp; {{question.label}}</span><span ng-hide=question.label>&nbsp; {{question.text}}</span><span ng-hide=\"question.label || question.text\">&nbsp; {{question.id}}</span></li></ul><button translate=NEW_QUESTION ng-click=newQuestion() class=\"btn btn-default button-new-question\"></button></div><div class=col-md-8><div class=panel><div class=panel-body><form name=questionEditor ng-submit=saveQuestion><p ng-show=questionFormData.id>id:{{questionFormData.id}}</p><div cg-question-input question=questionFormData topic=topic class=question-input></div><button translate=ARCHIVE ng-click=archiveQuestion(editQuestion) ng-disabled=!questionFormData.id class=\"btn btn-danger button-archive-question\"></button> <button translate=SAVE ng-click=saveQuestion() data-ng-disabled=questionEditor.$invalid class=\"btn btn-success button-save-question\"></button></form></div></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div></div></div>");
$templateCache.put("app/screens/tenant/admin/content/subject/subject.html","<div class=screen-admin-topic><div class=\"panel breadcrumb-panel\"><div class=panel-body><ol class=breadcrumb-alt><li><a ui-sref=tenant.admin.content.subjects translate=SUBJECTS></a></li><li><a ui-sref=tenant.admin.content.subject.topics({subjectId:subject.id})>{{subject.name}}</a></li></ol></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div>");
$templateCache.put("app/screens/tenant/admin/content/subjects/subjects.html","<div class=\"screen-admin-subjects panel panel-default\"><div class=panel-heading>{{ \'SUBJECTS\' | translate}}</div><div class=panel-body><div class=row><div class=col-md-3><ul ui-sortable=sortableOptions ng-model=subjects class=\"subjects-list list-group\"><li ng-repeat=\"subject in subjects\" ng-click=selectSubject(subject) class=\"subjects-list-item list-group-item\"><i class=\"fa fa-gamepad\"></i><span class=subject-display-name>&nbsp; {{subject.name}}</span></li></ul><button translate=NEW_SUBJECT ng-click=newSubject() class=\"btn btn-default button-new-subject\"></button></div><div class=col-md-9><div class=panel><div class=panel-body><form name=subjectEditor ng-submit=saveSubject><div class=form-group><label translate=SUBJECT_NAME></label><input type=text ng-model=formData.name required data-ng-minlength=1 class=\"form-control input-name\"></div><div class=form-group><label translate=SUBJECT_DESCRIPTION></label><textarea type=text ng-model=formData.description class=\"form-control input-name\"></textarea></div><div class=form-group><label translate=SUBJECT_ICON></label><div cg-upload upload-id=formData.icon accept=.png,.jpg class=icon-upload></div><img ng-show=formData.icon ng-src=\"{{formData.icon | uploadURL}}\" class=icon-preview></div><button translate=ARCHIVE ng-click=archiveSubject(editSubject) ng-disabled=!formData.id class=\"btn btn-danger button-archive-subject\"></button> <button translate=SAVE ng-click=saveSubject() data-ng-disabled=subjectEditor.$invalid class=\"btn btn-success button-save-subject\"></button></form></div></div><div ng-show=formData.id class=row><ul class=\"nav nav-boxed nav-justified\"><li><a ui-sref=\"tenant.admin.content.subject.topics({subjectId: formData.id})\" class=button-subjects-overview><i class=\"color-primary fa fa-book\"></i><span class=subjects-overview>{{ \'TOPICS\' | translate}}</span></a></li><li><a ui-sref=\"tenant.admin.content.subject.activities({subjectId: formData.id})\" class=button-activities-overview><i class=\"color-success fa fa-gamepad\"></i><span class=activities-overview>{{ \'ACTIVITIES\' | translate}}</span></a></li></ul></div></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div></div>");
$templateCache.put("app/screens/tenant/admin/content/topic/topic.html","<div class=screen-admin-topic><div class=\"panel breadcrumb-panel\"><div class=panel-body><ol class=breadcrumb-alt><li><a ui-sref=tenant.admin.content.subjects translate=SUBJECTS></a></li><li><a ui-sref=tenant.admin.content.subject.topics({subjectId:subject.id})>{{subject.name}}</a></li><li><a ui-sref=tenant.admin.content.topic.questions({topicId:topic.id})>{{topic.name}}</a></li><li><a translate=QUESTIONS></a></li></ol></div></div><div ui-view class=\"child-view animate-fade-up\"></div></div>");
$templateCache.put("app/screens/tenant/admin/content/topics/topics.html","<div class=\"screen-tenant-admin-topics panel panel-default\"><div class=panel-heading>{{ \'TOPICS\' | translate}}</div><div class=panel-body><div class=row><div class=col-md-3><ul ui-sortable=sortableOptions ng-model=topics class=\"topics-list list-group\"><li ng-repeat=\"topic in topics\" ng-click=selectTopic(topic) class=\"topics-list-item list-group-item\"><i class=\"fa fa-gamepad\"></i><span class=topic-display-name>&nbsp; {{topic.name}}</span></li></ul><button translate=NEW_TOPIC ng-click=newTopic() class=\"btn btn-default button-new-topic\"></button></div><div class=col-md-9><div class=panel><div class=panel-body><form name=topicEditor ng-submit=saveTopic><div class=form-group><label translate=TOPIC_NAME></label><input type=text ng-model=topicFormData.name required data-ng-minlength=1 class=\"form-control input-name\"></div><div class=form-group><label translate=TOPIC_DESCRIPTION></label><textarea type=text ng-model=topicFormData.description class=\"form-control input-name\"></textarea></div><div class=form-group><label translate=TOPIC_TAGS></label><tags-input type=text use-strings=true ng-model=topicFormData.tags placeholder=\"Add a tag\" class=input-tags></tags-input></div><div class=form-group><label translate=TOPIC_NEXT></label><div class=ui-select><select ng-model=topicFormData.next class=input-next-topic><option value=\"\">none</option><option ng-repeat=\"topic in allTopics | orderBy : \'name\'\" value={{topic.id}}>{{topic.name}}</option></select></div></div><div class=form-group><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.unlock><span translate=TOPIC_UNLOCKED></span></label></div><div class=form-group><label translate=VIRTUAL_GOODS></label><tags-input type=text use-strings=true ng-model=topicFormData.virtualgoods placeholder=\"Add a virtual good\" class=input-virtual-goods></tags-input></div><div ng-hide=\"questions.length == 0\"><div class=form-group><label translate=QUESTION_TYPE></label></div><span>{{topicFormData.questionType}}</span><div ng-if=\"topicFormData.questionType == questionTypes.MULTICHOICE\"><dl class=dl-horizontal><dt translate=ATTRIBUTES_QUESTION></dt><dd ng-show=topicFormData.attributes.questionText translate=TEXT></dd><dd ng-show=topicFormData.attributes.questionAudio translate=AUDIO></dd><dd ng-show=topicFormData.attributes.questionImage translate=IMAGE></dd><dt translate=ATTRIBUTES_OPTION></dt><dd ng-show=topicFormData.attributes.optionText translate=TEXT></dd><dd ng-show=topicFormData.attributes.optionAudio translate=AUDIO></dd><dd ng-show=topicFormData.attributes.optionImage translate=IMAGE></dd></dl></div><div ng-if=\"topicFormData.questionType == questionTypes.AUDIO_RESPONSE || topicFormData.questionType == questionTypes.IMAGE_RESPONSE\"><dl class=dl-horizontal><dt translate=ATTRIBUTES_QUESTION></dt><dd ng-show=topicFormData.attributes.questionText translate=TEXT></dd><dd ng-show=topicFormData.attributes.questionAudio translate=AUDIO></dd><dd ng-show=topicFormData.attributes.questionImage translate=IMAGE></dd></dl></div></div><div ng-show=\"questions.length == 0\"><div class=form-group><label translate=QUESTION_TYPE></label><select ng-model=topicFormData.questionType required class=\"form-control input-locked\"><option value=\"\">---Please select---</option><option ng-repeat=\"type in questionTypes\" value={{type}}>{{type}}</option></select></div><div ng-if=\"topicFormData.questionType == questionTypes.MULTICHOICE\" ng-disabled=\"questions.length &gt; 0\" class=well><dl class=dl-horizontal><dt translate=ATTRIBUTES_QUESTION></dt><dd><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.attributes.questionText ng-required=getQuestionAttributesSelected()><span translate=TEXT></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.attributes.questionAudio ng-required=getQuestionAttributesSelected()><span translate=AUDIO></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.attributes.questionImage ng-required=getQuestionAttributesSelected()><span translate=IMAGE></span></label></dd><dt translate=ATTRIBUTES_OPTION></dt><dd><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.attributes.optionText ng-required=getOptionAttributesSelected()><span translate=TEXT></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.attributes.optionAudio ng-required=getOptionAttributesSelected()><span translate=AUDIO></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.attributes.optionImage ng-required=getOptionAttributesSelected()><span translate=IMAGE></span></label></dd></dl></div><div ng-if=\"topicFormData.questionType == questionTypes.AUDIO_RESPONSE || topicFormData.questionType == questionTypes.IMAGE_RESPONSE\" ng-disabled=\"questions.length &gt; 0\" class=well><dl class=dl-horizontal><dt translate=ATTRIBUTES_QUESTION></dt><dd><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.attributes.questionText ng-required=getQuestionAttributesSelected()><span translate=TEXT></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.attributes.questionAudio ng-required=getQuestionAttributesSelected()><span translate=AUDIO></span></label></dd><dd><label class=ui-checkbox><input type=checkbox ng-model=topicFormData.attributes.questionImage ng-required=getQuestionAttributesSelected()><span translate=IMAGE></span></label></dd></dl></div></div><div class=form-group><label translate=TOPIC_TYPE></label><select ng-model=topicFormData.topicType required class=\"form-control input-locked\"><option ng-repeat=\"type in topicTypes\" value={{type}} translate={{type}}></option></select></div><div class=form-group><label translate=TOPIC_ICON></label><div cg-upload upload-id=topicFormData.icon accept=.png,.jpg class=icon-upload></div><img ng-show=topicFormData.icon ng-src=\"{{topicFormData.icon | uploadURL}}\" class=icon-preview></div><button translate=ARCHIVE ng-click=archiveTopic(editTopic) ng-disabled=!topicFormData.id class=\"btn btn-danger button-archive-topic\"></button> <button translate=SAVE ng-click=saveTopic() data-ng-disabled=topicEditor.$invalid class=\"btn btn-success button-save-topic\"></button></form></div></div><div ng-show=topicFormData.id class=row><ul class=\"nav nav-boxed nav-justified\"><li><a ui-sref=\"tenant.admin.content.topic.questions({topicId: topicFormData.id})\" class=button-questions-overview><i class=\"color-primary fa fa-question\"></i><span class=subjects-overview>{{ \'QUESTIONS\' | translate}}</span></a></li></ul></div></div></div></div></div>");}]);